export const it = {
    fileImport: {
        newAttempt: "Nuovo tentativo",
        "title": "Importa da file",
        "choose": "Scegli il file",
        "mapping": "Collega le colonne",
        "options": "Scegli come importare",
        "progress": "Importazione in corso",
        "completed": "Importazione completata",
        "file": "File CSV",
        "csvHint": "Salva il file Excel come CSV. Fino a 5.000 righe e 20 MB; il file viene letto qui, nel browser.",
        "resumeHint": "Se chiudi o perdi la rete, scegli di nuovo lo stesso file e le stesse opzioni per riprendere. Il browser ricorda solo il tentativo, senza salvare il file.",
        "mappingHint": "{count} righe. Controlla gli esempi e collega le colonne ai campi. I telefoni devono conservare gli zeri iniziali.",
        "columnField": "Campo per {column}",
        "unnamed": "Colonna {number}",
        "empty": "Nessun esempio",
        "ignore": "Non importare questa colonna",
        "cityCode": "Codice ISTAT del comune",
        "fieldUnavailable": "Campo non disponibile",
        "mappingInvalid": "Collega un cellulare o un telefono fisso; ogni campo può avere una sola colonna.",
        "source": "Provenienza",
        "sourceRequired": "Scrivi la provenienza di questi Lead.",
        "tag": "Tag da mettere a tutti",
        "tagHint": "Facoltativo; si aggiunge anche ai Lead già presenti. I tag in una colonna si separano con la virgola.",
        "existing": "Doppioni per telefono",
        "keep": "Lasciali come sono",
        "fill": "Completa solo i campi vuoti",
        "owner": "Assegnazione dei nuovi Lead",
        "rule": "Con la regola di assegnazione",
        "ownerHint": "La scelta vale soltanto per i Lead nuovi: quelli già presenti conservano il loro owner, anche se non ne hanno.",
        "ownerUnavailable": "Le persone non sono disponibili ora. Puoi usare la regola di assegnazione.",
        "entryHint": "Ogni riga valida registra un ingresso, anche per un Lead già presente; la stessa riga di nuovo entro 24 ore è un doppio invio e non conta. I nuovi partono con la sequenza. Non puoi annullare i dati già importati.",
        "next": "Continua",
        "back": "Indietro",
        "import": "Importa",
        "retry": "Riprova",
        "reading": "Lettura del file e dei campi…",
        "processed": "{done} di {total} righe elaborate",
        "interruptedHint": "Puoi chiudere e riprendere con lo stesso file e le stesse scelte. Le righe già entrate restano; riprovarle non le duplica.",
        "counts": "{created} nuovi · {updated} già presenti · {discarded} scartati",
        "rowNumbers": "Le righe si contano dalla tabella letta: intestazione 1, poi le righe non vuote. Una cella con più righe di testo conta una volta.",
        "duplicates": "Doppi invii: {count}. Sono righe con gli stessi dati di un’importazione delle ultime 24 ore: non sono entrate di nuovo e i loro Lead non sono cambiati.",
        "badRow": "Riga {row}: non importata, controlla i dati o i permessi.",
        "problemField": "Campo: {field}.",
        "problems": {
            "phone_missing": "Riga {row}: manca il telefono, non importata.",
            "invalid_phone": "Riga {row}: telefono non valido, non importata.",
            "invalid_field_value": "Riga {row}: un valore non è valido, non importata.",
            "archived_lead": "Riga {row}: il telefono è di un Lead archiviato, non importata. Ripristina il Lead dagli «Archiviati», poi importa di nuovo la riga.",
            "phones_conflict": "Riga {row}: il telefono fisso è già di un Lead con un altro cellulare, non importata. Controlla se è la stessa persona.",
            "owner_not_eligible": "Riga {row}: la persona scelta non può più ricevere Lead, non importata. Riprova con un’altra persona o con la regola di assegnazione.",
            "phone_in_use": "Riga {row}: un numero della riga è già di un altro Lead, non importata.",
            "field_not_editable": "Riga {row}: un campo o una voce è nascosto nella scheda e non si può scrivere, non importata.",
            "phone_repeated_on_lead": "Riga {row}: lo stesso numero è in due colonne, non importata."
        },
        "unknownCity": "Riga {row}: città non riconosciuta, Lead importato senza città.",
        "valueNotImported": "Riga {row}: il valore di «{field}» non è entrato perché non va bene; il resto della riga sì.",
        "possibleEmail": "Riga {row}: email presente anche su un altro Lead; controlla il possibile doppione.",
        "busy": "Un’altra persona sta importando un file. Riprova quando ha finito.",
        "changedAttempt": "Il tentativo è cambiato o è stato chiuso da una nuova importazione. Le righe già entrate restano. Chiudi e avvia un nuovo tentativo con scelte o file aggiornati.",
        "errors": {
            "empty_file": "Il file non contiene righe da importare.",
            "invalid_csv": "Il CSV non è leggibile senza ambiguità. Controlla separatore, virgolette e intestazioni, poi riesportalo.",
            "too_many_rows": "Il file supera 5.000 righe. Dividilo in file più piccoli.",
            "unreadable_file": "Non riesco a leggere il file. Sceglilo di nuovo.",
            "unsupported_file": "Salva il file Excel come CSV, poi scegli il CSV.",
            "file_too_large": "Il file supera 20 MB. Dividilo in file più piccoli.",
            "row_too_large": "Una riga supera la dimensione consentita. Riduci le celle o rimuovi le colonne inutili prima di importare."
        }
    },
    registration: {
        title: "Prova Gioia365 gratis per 15 giorni",
        offer: "15 giorni gratis, poi 49 EUR al mese per utente. Nessuna carta richiesta per iniziare.",
        start: "Inizia la prova gratuita",
        unavailable: "La registrazione non è disponibile in questo momento. Riprova più tardi.",
        emailPending: "Apri l’email che ti abbiamo inviato e conferma il tuo indirizzo per iniziare la prova.",
        activationPending: "Stiamo preparando la tua azienda. Riprova tra poco.",
        activated: "La tua azienda è pronta. Apri il link nell’email per entrare.",
        confirmTitle: "Conferma il tuo indirizzo email",
        confirm: "Conferma email e inizia la prova",
        enter: "Scegli la password ed entra",
        ends: "La prova gratuita termina il {date}.",
        expired: "La prova gratuita è terminata. Attiva l’abbonamento per riprendere il lavoro.",
        capacity: "Salva i posti della prova",
        team: "Gestisci il team",
        retryRegistration: "Richiedi una nuova email di conferma",
    },
    billing: {
        purchaseTitle: "Attiva Gioia365",
        price: "49 EUR al mese per utente",
        telephony: "La telefonia non è inclusa in questo acquisto.",
        companyName: "Nome azienda",
        firstName: "Nome del titolare",
        lastName: "Cognome del titolare",
        email: "Email del titolare",
        seats: "Posti per il team",
        total: "{amount} EUR al mese",
        tax: "Verifica l’importo e i dettagli prima di confermare il pagamento.",
        checkout: "Continua al pagamento",
        signIn: "Accedi a Gioia365",
        unavailable: "Gli acquisti non sono disponibili in questo momento. Riprova più tardi.",
        statusTitle: "Il tuo acquisto",
        newPurchase: "Torna agli acquisti",
        manageTitle: "Abbonamento",
        paid: "Il tuo abbonamento è attivo.",
        unpaid: "Il pagamento richiede attenzione. Gestisci l’abbonamento per riprendere il lavoro.",
        used: "Posti utilizzati: {used} su {seats}.",
        overQuota: "Il team occupa più posti di quelli acquistati. Il CRM è sospeso: aumenta i posti oppure sospendi persone o annulla inviti dal Team.",
        recovery: "Qui puoi gestire i pagamenti e ridurre i posti occupati dal Team. Il CRM riprende quando l’abbonamento è pagato e i posti coprono persone attive e inviti validi. Nessuna persona viene sospesa automaticamente.",
        suspendNamed: "Sospendi {name}",
        cancelNamed: "Annulla invito a {name}",
        leaveView: "Aprendo Team esci dalla Vista Commerciale e torni ad agire come titolare.",
        restart: "Il contratto precedente è terminato. Puoi attivare un nuovo abbonamento per la stessa azienda e il suo team.",
        restartCheckout: "Attiva un nuovo abbonamento",
        confirmSuspend: "Conferma sospensione",
        confirmCancel: "Conferma annullamento",
        cancelText: "L’invito a {name} non sarà più valido. Potrai invitarlo di nuovo quando avrai posti disponibili.",
        ends: "L’abbonamento termina alla fine del periodo già pagato.",
        portal: "Gestisci pagamento e fatture",
        manual: "Questa azienda è gestita direttamente da Gioia365. Non ha addebiti automatici.",
        chooseCompany: "Scegli l’azienda",
        order: { payment_pending: "Stiamo verificando il pagamento.", activation_pending: "Stiamo attivando la tua azienda. Riceverai l’invito per entrare via email.", activated: "La tua azienda è attiva. Ti abbiamo inviato l’invito via email.", expired: "Il pagamento non è stato completato. Puoi iniziare un nuovo acquisto." },
    },
    common: {
        appName: "Gioia365",
        greeting: "Ciao, {name}",
        language: "Lingua",
        italian: "Italiano",
        english: "Inglese",
        loading: "Un momento…",
        retry: "Riprova",
        close: "Chiudi",
        discardChanges: "Annulla le modifiche",
        saving: "Salvataggio in corso…",
        notifications: "Avvisi",
        signOut: "Esci",
        signingOut: "Uscita in corso…",
        cancel: "Annulla",
        // Nome e cognome di una persona, sempre in due caselle con un solo errore (decisione del product owner del 30
        // settembre 2026, come il mock-up del Team).
        firstName: "Nome",
        lastName: "Cognome",
        nameMissing: "Scrivi nome e cognome.",
    },
    auth: {
        errors: {
            rateLimited: "Troppi tentativi di fila. Aspetta un minuto e riprova.",
            unavailable: "Il servizio di accesso non risponde. Riprova tra poco; se continua, avvisa chi gestisce Gioia365.",
            unexpected: "Qualcosa non ha funzionato. Riprova tra poco.",
        },
        login: {
            title: "Accedi a Gioia365",
            email: "Email",
            password: "Password",
            submit: "Accedi",
            submitting: "Accesso in corso…",
            invalidCredentials: "Email o password non corretti.",
        },
        resetPassword: {
            title: "Scegli la tua password",
            intro: "La userai per entrare in Gioia365 insieme alla tua email.",
            newPassword: "Nuova password (almeno {min} caratteri)",
            confirmPassword: "Ripeti la nuova password",
            submit: "Salva la password",
            submitting: "Salvataggio in corso…",
            tooShort: "La password deve avere almeno {min} caratteri.",
            tooLong: "La password può avere al massimo {max} caratteri.",
            mismatch: "Le due password non sono uguali.",
            invalidLink: "Questo link non vale più: dura un'ora e si può usare una volta sola. Chiedi un link nuovo.",
            done: "Password salvata. Ora puoi entrare con la tua email e la nuova password.",
            goToLogin: "Vai all'accesso",
        },
        forgot: {
            link: "Password dimenticata?",
            title: "Password dimenticata?",
            intro: "Scrivi l'email con cui entri: ti mandiamo un link per scegliere una nuova password.",
            email: "Email",
            submit: "Mandami il link",
            submitting: "Invio in corso…",
            sent: "Se l'email è di un account Gioia365, tra poco ti arriva il link. Vale un'ora.",
            noEmail: "Su questo server le email non partono ancora: chiedi un link nuovo al Super admin di Gioia365.",
            back: "Torna all'accesso",
        },
        // «Accedi con Google» (AZI-11): il pulsante e i motivi di un ritorno da Google senza accesso.
        google: {
            or: "oppure",
            button: "Accedi con Google",
            opening: "Apertura di Google…",
            completing: "Accesso con Google in corso…",
            unknown: "Questo account Google non è di nessuna persona di Gioia365. Per entrare chiedi un invito a chi gestisce il team della tua azienda; se l'hai già ricevuto, aprilo dall'email e scegli la password.",
            cancelled: "Accesso con Google annullato. Puoi riprovare oppure entrare con email e password.",
            notLinked: "Con questo account Google non si entra: non corrisponde a una persona di Gioia365 con l'email confermata. Entra con email e password.",
            unverified: "Google non conferma l'email di questo account, quindi con Google non si entra. Entra con email e password.",
            workspace: "Con Google entrano soltanto gli account di lavoro dell'azienda (Google Workspace), non quelli personali. Entra con email e password.",
            failed: "Google non ha completato l'accesso. Riprova, oppure entra con email e password.",
        },
    },
    // Email di sistema (piano M1b D10): testo semplice, il link su una riga a sé.
    email: {
        registration: { subject: "Conferma la tua email per provare Gioia365", body: "Conferma la tua email e inizia la prova gratuita di 15 giorni: {link}" },
        invitation: {
            subject: "Gioia365: il tuo invito in {organization}",
            body: "Ciao {name},\n\nti hanno invitato a lavorare in {organization} su Gioia365. Apri questo link per scegliere la password ed entrare:\n\n{link}\n\nIl link vale fino a {date}. Poi, per entrare in {organization}, usa sempre questo indirizzo con la tua email e la tua password:\n\n{address}\n\nSe non aspettavi questo invito, ignora questa email.",
        },
        passwordReset: {
            subject: "Gioia365: scegli una nuova password",
            body: "Hai chiesto di scegliere una nuova password per Gioia365. Apri questo link entro un'ora:\n\n{link}\n\nSe non l'hai chiesto tu, ignora questa email: la password resta quella di prima.",
        },
        // Richiesta di informazioni dal sito vetrina, per chi la riceve in Gioia365 (decisione del 3 ottobre 2026).
        infoRequest: {
            subject: "Gioia365: richiesta di informazioni da {company}",
            body: "Nuova richiesta di informazioni dal sito {site}.\n\nNome: {name}\nAzienda: {company}\nEmail: {email}\nTelefono: {phone}\nPersone nel team commerciale: {teamSize}\nLingua della pagina: {locale}\nRicevuta: {date}\n\nMessaggio:\n{message}\n\nCon «Rispondi» la risposta va a {email}.",
            notGiven: "non indicato",
        },
        // Il riepilogo del mattino dei possibili doppioni (LEAD-28), a chi ha la funzione di «Pulizia dati». `intro` e `introFirst` vanno
        // in `{intro}` di `body`, le righe `samePhone` e `sameEmail` (e `more`, se le coppie sono più di 20) in `{pairs}`.
        duplicateDigest: {
            subject: "Gioia365: possibili doppioni nuovi in {organization} ({count})",
            intro: "in {organization} ci sono possibili doppioni nuovi dall'ultimo riepilogo: {count}.",
            introFirst: "è il primo riepilogo dei possibili doppioni di {organization}: comprende tutti quelli ancora da controllare, {count}.",
            samePhone: "- {first} e {second}: stesso cellulare",
            sameEmail: "- {first} e {second}: stessa email",
            more: "Altre coppie: {count}.",
            body: "Ciao {name},\n\n{intro}\n\n{pairs}\n\nLi trovi in «Pulizia dati», dove li unisci in un solo Lead o li segni «Non sono doppioni»:\n\n{link}\n\nRicevi questa email ogni mattina lavorativa, quando ci sono possibili doppioni nuovi, perché in {organization} fai la pulizia dei dati.",
        },
    },
    invitation: {
        title: "Entra in {organization}",
        titleGeneric: "Il tuo invito",
        summary: "L'invito è per {email} con il ruolo «{role}». Scade: {date}.",
        incompleteLink: "Questo link non è completo: apri di nuovo il link che hai ricevuto.",
        expiredOn: "L'invito è scaduto: {date}. Chiedi a chi ti ha invitato di mandarlo di nuovo.",
        alreadyMember: "Fai già parte di {organization}.",
        organizationInactive: "{organization} al momento non è attiva su Gioia365.",
        goToLogin: "Vai all'accesso",
        newPassword: "Scegli una password (almeno {min} caratteri)",
        confirmPassword: "Ripeti la password",
        existingIntro: "Hai già un account Gioia365 con questa email: scrivi la tua password.",
        passwordMissing: "Scrivi la tua password.",
        wrongPassword: "La password non è corretta.",
        forgotPassword: "Password dimenticata?",
        signedInAs: "Sei già dentro come {email}.",
        submit: "Entra in {organization}",
        submitting: "Ingresso in corso…",
    },
    home: {
        comingNext: "Qui arriveranno i Lead, i Task e i numeri della giornata.",
        inCompany: "Sei in {organization} come {role}.",
        inCompanyAsPlatform: "Sei in {organization} come Super admin di Gioia365.",
        goToSettings: "Vai alle Impostazioni",
    },
    // La Home «Oggi» e «Sequenze rispettate oggi» (piano M5, Task 22; D16, D19): le parole del brief e del mock-up `home.html` alla
    // lettera. «Non rispettata:» e «Non rispettate:» vengono dal mock-up (ruling H8); le frasi con «nessuna oggi» al posto del conto,
    // «e un'altra», «e altre {count}» e la spiegazione per una regola con un tentativo solo non ci sono: proposte (questione 341).
    homeToday: {
        title: "Oggi",
        newLeads: "Nuovi Lead da contattare",
        newLeadsHint: "entrati nelle Smart List e mai chiamati",
        newLeadsOne: "1 Lead nuovo da contattare",
        newLeadsMany: "{count} Lead nuovi da contattare",
        callNewLeads: "Chiama i nuovi Lead",
        attempts: "Tentativi di chiamata oggi",
        attemptsDetail: "{answered} con risposta · {leads} Lead diversi",
        closedEarly: "{count} chiuse presto · escluse dai tentativi",
        disco: "Disco prenotate",
        discoValue: "{count} oggi",
        discoNext: "La prossima in agenda: {lead}, oggi {time}.",
        discoNone: "Nessuna disco ancora da fare oggi.",
        openNextDisco: "Apri la prossima disco",
        appointments: "Disco e demo di oggi",
        appointmentsNone: "Nessuna disco o demo oggi.",
        appointmentItem: "{time} · {kind} con {lead}",
        appointmentState: {
            to_do: "Da fare",
            in_progress: "In corso",
            to_close: "Da chiudere: segna com'è andata dalla scheda",
            held: "Fatta",
            no_show: "Il Lead non si è presentato",
        },
    },
    homeSequences: {
        mine: "Le tue sequenze rispettate oggi: {respected} su {total}",
        team: "Sequenze rispettate oggi: {respected} su {total}",
        none: "nessuna oggi",
        mineNone: "Le tue sequenze rispettate oggi: {none}",
        teamNone: "Sequenze rispettate oggi: {none}",
        person: "{name}: {respected} su {total}",
        personNone: "{name}: {none}",
        violatedOne: "Non rispettata:",
        violatedMany: "Non rispettate:",
        moreOne: "e un'altra",
        more: "e altre {count}",
        hint: "Rispettata: prima chiamata entro {minutes} minuti da quando entra il Lead, un tentativo in ogni mezza giornata lavorativa{friday}, {first} chiamate al primo tentativo e almeno {others} negli altri (Impostazioni → Sequenza di chiamate). Accanto al nome c'è il primo motivo. Le chiamate della sequenza non sono Task: il Commerciale le fa dalle Smart List, e qui si vede se le ha fatte.",
        hintOneAttempt: "Rispettata: prima chiamata entro {minutes} minuti da quando entra il Lead, un tentativo in ogni mezza giornata lavorativa{friday}, {first} chiamate al primo tentativo (Impostazioni → Sequenza di chiamate). Accanto al nome c'è il primo motivo. Le chiamate della sequenza non sono Task: il Commerciale le fa dalle Smart List, e qui si vede se le ha fatte.",
        fridayHint: " (il venerdì solo la mattina)",
    },
    shell: {
        skipToContent: "Vai al contenuto",
        menu: "Menu",
        mainNavigation: "Navigazione principale",
        // Il menu delle aziende in cima alla rail (decisione del 3 ottobre 2026).
        company: {
            label: "Azienda di questa scheda:",
            button: "Azienda di questa scheda: {organization}",
            none: "Scegli l'azienda",
            title: "Le tue aziende",
            currentRole: "{role} · aperta in questa scheda",
            platformRole: "Super admin di Gioia365",
            all: "Tutte le aziende di Gioia365",
        },
        nav: {
            home: "Home",
            tasks: "Task",
            leads: "Lead",
            opportunities: "Opportunità",
            conversations: "Conversazioni",
            activity: "Attività",
            reports: "Report",
            smartLists: "Smart List",
            settings: "Impostazioni",
            platform: "Aziende di Gioia365",
        },
        // In fondo alla rail su desktop (riscontro del product owner del 3 ottobre 2026, questione aperta 183).
        rail: {
            collapse: "Riduci il menu",
            expand: "Allarga il menu",
        },
        account: {
            role: "{role} · {organization}",
            platformIn: "Super admin di Gioia365 · {organization}",
            platform: "Super admin di Gioia365",
        },
        platformNotice: "Sei in {organization} come Super admin di Gioia365. Ogni accesso resta registrato.",
        // «Guarda come…», la Vista Commerciale (piano M2 Task 22): osservazione senza impersonazione, decisione confermata;
        // su qualunque persona attiva dell'azienda e con questi nomi dal 2 ottobre 2026.
        commercialView: {
            open: "Guarda come…",
            title: "Guarda come un'altra persona dell'azienda",
            intro: "Scegli una persona attiva dell'azienda: vedi il programma come lo vede lei, con il suo menu e i suoi Lead. È soltanto una vista: ciò che fai resta a tuo nome.",
            list: "Persone che puoi guardare",
            otherRoles: "Altri ruoli",
            current: "in vista",
            none: "Non c'è nessun'altra persona attiva che puoi guardare.",
            exit: "Esci dalla vista",
            region: "Guarda come…",
            band: "Stai guardando come vede {name} ({role}).",
            bandName: "Stai guardando come vede {name}.",
            bandNote: "Ciò che fai resta a tuo nome.",
            change: "Cambia",
            leave: "Esci",
            closed: "La vista come {name} si è chiusa: Gioia365 non la permette più, per esempio perché la persona è stata sospesa o il suo ruolo ora ha più poteri del tuo. Ora vedi come sempre.",
            outsideTitle: "Pagina fuori dalla vista",
            outside: "Questa pagina non fa parte di ciò che vede {name}. Esci dalla vista per aprirla.",
        },
    },
    settings: {
        eyebrow: "Impostazioni · {organization}",
        sections: "Sezioni delle impostazioni",
        // I titoli dei gruppi del menu (ordine approvato il 17 ottobre 2026, IMP-13).
        groups: {
            company: "Azienda",
            people: "Persone",
            leads: "Lead",
            calls: "Chiamate",
            whatsapp: "WhatsApp",
            data: "Dati",
        },
        team: "Team",
        roles: "Ruoli e permessi",
        calendar: "Calendario, fuso e lingua",
        leadFields: "Campi della scheda",
        leadVisibility: "Chi vede i Lead",
        callSequence: "Sequenza di chiamate",
        leadIntake: "Ingressi dei Lead",
        assignment: "Assegnazione dei Lead",
        goals: "Obiettivi",
        // Le due sezioni dei WhatsApp (piano M6, R1, Task 5a), con i nomi del menu del mock-up (`whatsapp.html`, `modelli-whatsapp.html`).
        whatsappSending: "Invio dei WhatsApp",
        whatsappTemplates: "Modelli WhatsApp",
        importExport: "Importazione ed esportazione",
        // Le parole della bozza delle sezioni di M2 («Campi della scheda», «Chi vede i Lead»), come nel mock-up `regole.html`.
        draft: {
            summary: "{count} modifiche da salvare. Per il team non cambia niente finché non salvi.",
            summaryOne: "1 modifica da salvare. Per il team non cambia niente finché non salvi.",
            save: "Salva…",
            discarded: "Modifiche annullate: resta tutto com'era.",
            confirmTitle: "Cosa cambia per il team",
            confirmNote: "Vale per tutta l'azienda da subito. La modifica resta nel registro Attività con il tuo nome e l'orario.",
            back: "Torna alle modifiche",
            apply: "Salva e applica a tutta l'azienda",
            leaveTitle: "Non hai salvato le modifiche",
            leaveText: "Se esci adesso le modifiche si perdono e per il team resta tutto com'era.",
            leaveDiscard: "Esci senza salvare",
            stay: "Resta qui",
        },
    },
    // Impostazioni → Team (piano M1b Task 7). Nessun articolo davanti al nome dell'azienda.
    team: {
        about: {
            title: "A cosa serve",
            text: "Qui c'è chi fa parte di {organization}: nome e cognome, ruolo, se è attiva e il numero con cui chiama, che può essere lo stesso per più persone.",
            whoDecidesTitle: "Chi decide",
            whoDecides: "Il Super admin, l'Admin e il Super user dell'azienda, e il Super admin di Gioia365. Nessuno cambia chi ha un ruolo più alto del suo; il titolare è protetto. I numeri per chiamare li aggiungono, verificano, danno e tolgono il Super admin e l'Admin dell'azienda (chi ha «Numeri per chiamare») e il Super admin di Gioia365.",
        },
        readOnly: "Il team lo gestiscono Super user, Admin e Super admin dell'azienda: tu lo vedi soltanto.",
        title: "Chi fa parte di {organization}",
        counts: "Persone: {total} · attive {active} · invitate {invited} · sospese {suspended}",
        invite: "Invita una persona",
        caption: "Il team di {organization}",
        columns: {
            person: "Persona",
            role: "Ruolo",
            status: "Stato",
            action: "Azione",
        },
        owner: "titolare",
        you: "sei tu",
        // Una persona nata sospesa dall'importazione da Close (INGR-15).
        fromClose: "da Close",
        protected: "protetto",
        manage: "Gestisci",
        manageNamed: "Gestisci {name}",
        status: {
            active: "Attivo",
            invited: "Invitato",
            suspended: "Sospeso",
            archived: "Archiviato",
            suspending: "Sospensione in corso",
            archiving: "Archiviazione in corso",
            invitedOn: "Invito: {date}",
            expiredOn: "Scaduto: {date}",
        },
        showArchived: "Mostra anche gli archiviati ({count})",
        // I Lead di chi è sospeso o archiviato (piano M2 Task 22), dai conteggi del server.
        leadsLeft: "{count} Lead da riassegnare",
        leadsLeftOne: "1 Lead da riassegnare",
        // Senza i conteggi del server la riga non fa come se la persona non avesse Lead.
        leadsLeftUnknown: "Lead da riassegnare: conteggio non disponibile",
        countsFailed: "Non riesco a contare i Lead delle persone, quindi accanto a chi è sospeso o archiviato non posso dire quanti Lead restano da riassegnare. Riprova.",
        inView: "Stai guardando come vede {name}: i Lead da riassegnare qui sono soltanto quelli che vede questa persona, e per riassegnarli esci dalla vista.",
        leads: {
            legend: "I suoi {count} Lead",
            legendOne: "Il suo Lead",
            reassign: "Riassegnali agli altri User, a turno",
            reassignHint: "Uno ciascuno agli User attivi, in ordine di nome, dal Lead più vecchio. Nella Timeline di ogni Lead resta chi l'ha riassegnato.",
            keep: "Lasciali a lui per ora",
            keepHint: "Restano segnalati da riassegnare: la sua riga in questa pagina dice quanti sono.",
            cannotReassign: "Restano a lui, segnalati da riassegnare: li riassegna chi può cambiare l'owner di tutti i Lead.",
            cannotReassignInView: "Restano a lui, segnalati da riassegnare: mentre guardi come un'altra persona non si riassegnano. Esci dalla vista per riassegnarli.",
            countsFailedSuspend: "Non riesco a contare i suoi Lead, quindi qui non posso offrirti di riassegnarli. Riprova; se sospendi lo stesso, i Lead che ha restano a lui, segnalati da riassegnare.",
            countsFailedArchive: "Non riesco a contare i suoi Lead. Riprova; se ne ha ancora, l'archiviazione si ferma e dice quanti sono.",
            countsFailedPending: "Non riesco a contare i suoi Lead, quindi qui non posso offrirti di riassegnarli. Riprova.",
            pending: "Sono ancora suoi e aspettano di essere riassegnati.",
            counting: "Conto i suoi Lead…",
        },
        hideArchived: "Nascondi gli archiviati",
        fields: {
            email: "Email per entrare in Gioia365",
            emailHint: "Qui arriva l'invito: la persona sceglie la sua password e entra.",
            // L'invito di una persona nata sospesa da Close (INGR-15).
            emailFromClose: "L'email che aveva in Close: accettando l'invito ritrova i suoi Lead. Se non usa già Gioia365 sceglie lì la sua password; se lo usa già, entra con quella che ha.",
            emailInvalid: "Scrivi un'email valida: è quella con cui entra.",
            emailLocked: "L'email la cambia la persona stessa o il Super admin di Gioia365, perché è quella con cui entra.",
            role: "Ruolo",
            // `{link}` diventa il link a «Ruoli e permessi».
            roleHint: "Cosa può fare ogni ruolo si sceglie in {link}.",
            roleReadOnly: "Questo ruolo può fare cose che tu non puoi fare: non lo cambi da qui.",
            // Una copia del Super admin scritta prima del 30 settembre 2026 (questione 38): non si assegna a nessuno.
            roleSuperAdminLevel: "Un ruolo di livello Super admin non si cambia da qui: il Super admin è uno solo.",
            noRoles: "Non c'è un ruolo che puoi dare: ogni ruolo dell'azienda ha un livello pari o superiore al tuo, oppure può fare cose che tu non puoi fare.",
        },
        inviteDialog: {
            submit: "Manda l'invito",
            sent: "Invito mandato a {email}. {name} entra quando lo accetta.",
            readyTitle: "Invito pronto per {name}",
            readyIntro: "L'email non è partita: copia il link e mandalo tu a {name}, per esempio su WhatsApp. Vale 7 giorni.",
        },
        manageDialog: {
            save: "Salva",
            saved: "Salvato: {name}.",
            suspend: "Sospendi",
            resume: "Riattiva",
            // Per una persona nata sospesa da Close (INGR-15), al posto di «Riattiva».
            invite: "Invita",
            archive: "Archivia",
        },
        invitationDialog: {
            resend: "Manda di nuovo l'invito",
            resent: "Invito mandato di nuovo a {email}.",
            // Decisione del product owner sulla questione 38: il reinvio dà di nuovo il ruolo; annullare resta possibile.
            resendBlocked: "Non puoi mandarlo di nuovo: il ruolo di questo invito può fare cose che tu non puoi fare. Puoi annullarlo.",
            cancel: "Annulla l'invito",
            cancelled: "Invito a {email} annullato.",
        },
        confirm: {
            suspendTitle: "Sospendi {name}",
            suspendText: "{name} non entra più in Gioia365 e non riceve Lead nuovi. Tutto il lavoro fatto resta a suo nome.",
            archiveTitle: "Archivia {name}",
            archiveText: "{name} esce da {organization}. Il suo nome resta nella storia. Non si cancella niente.",
            // Un Lead non resta a una persona archiviata (questione aperta 75).
            archiveLeads: "Ha ancora {count} Lead: un Lead non può restare a una persona archiviata. Prima si riassegnano agli altri User, a turno, poi {name} esce da {organization}.",
            archiveLeadsOne: "Ha ancora 1 Lead: un Lead non può restare a una persona archiviata. Prima si riassegna a un altro User, poi {name} esce da {organization}.",
            archiveReassign: "Riassegna e archivia",
            archiveBlocked: "Ha ancora {count} Lead: prima vanno riassegnati agli altri User, e può farlo soltanto chi cambia l'owner di tutti i Lead.",
            archiveBlockedOne: "Ha ancora 1 Lead: prima va riassegnato a un altro User, e può farlo soltanto chi cambia l'owner di tutti i Lead.",
            archiveBlockedInView: "Ha ancora {count} Lead: prima vanno riassegnati agli altri User. Esci dalla vista per riassegnarli.",
            archiveBlockedInViewOne: "Ha ancora 1 Lead: prima va riassegnato a un altro User. Esci dalla vista per riassegnarlo.",
        },
        done: {
            suspended: "Accesso sospeso per {name}.",
            resumed: "Accesso riattivato per {name}.",
            archived: "{name} non fa più parte di {organization}: il suo nome resta nella storia.",
            suspendedReassigned: "Accesso sospeso per {name}. {count} Lead riassegnati agli altri User, a turno.",
            suspendedReassignedOne: "Accesso sospeso per {name}. 1 Lead riassegnato a un altro User.",
            suspendedKept: "Accesso sospeso per {name}. I suoi {count} Lead restano a lui, segnalati da riassegnare.",
            suspendedKeptOne: "Accesso sospeso per {name}. Il suo Lead resta a lui, segnalato da riassegnare.",
            suspendedNotReassigned: "Accesso sospeso per {name}, ma i suoi Lead restano a lui. {reason}",
            reassigned: "{count} Lead di {name} riassegnati agli altri User, a turno.",
            reassignedOne: "1 Lead di {name} riassegnato a un altro User.",
            archivedReassigned: "{name} non fa più parte di {organization}: il suo nome resta nella storia. {count} Lead riassegnati agli altri User, a turno.",
            archivedReassignedOne: "{name} non fa più parte di {organization}: il suo nome resta nella storia. 1 Lead riassegnato a un altro User.",
            reassignedNotArchived: "I Lead di {name} sono passati agli altri User, ma l'archiviazione non è riuscita. {reason}",
        },
        // Ciò che il Team dice meglio del testo generico di `errors`.
        errors: {
            already_member: "{email} fa già parte di {organization}.",
            invitation_pending: "C'è già un invito in attesa per {email}: aprilo e usa «Manda di nuovo l'invito».",
            role_level: "Non puoi dare questo ruolo o agire su questa persona: il suo livello è pari o superiore al tuo.",
            protected_owner: "Il titolare è protetto: nessuno lo cambia da qui.",
            cannot_act_on_self: "Per te stesso usa «Il tuo account».",
            invalid_state: "Qualcuno l'ha appena cambiato: la tabella è aggiornata.",
            // Decisione del product owner sulla questione 38 (30 settembre 2026).
            system_role: "Il ruolo Super admin, o un ruolo del suo livello, non si dà a nessuno: in ogni azienda il Super admin è uno solo, il titolare.",
            permission_denied: "Non hai il permesso: questo ruolo può fare cose che tu non puoi fare, oppure non gestisci più il team.",
            owner_not_eligible: "Non c'è nessun altro User attivo a cui darli: riattiva o invita un Commerciale, poi riprova.",
            membership_has_leads: "Ha ancora {leads} Lead: prima vanno riassegnati agli altri User.",
            membership_from_close: "Questa persona viene da Close: per farla tornare nel team mandale un invito con «Invita». Quando lo accetta ritrova i suoi Lead.",
        },
    },
    // Impostazioni → Ruoli e permessi (piano M1b Task 8): le schede, «Utenti» e «Chi può fare cosa, in parole».
    // Nessun articolo davanti al nome dell'azienda.
    roles: {
        about: {
            title: "A cosa serve",
            text: "Qui si decide cosa può fare ogni persona di {organization}. Un ruolo è un insieme di permessi: per ogni parte del programma si sceglie cosa può vedere, creare, modificare ed eliminare, e quali funzioni speciali e Impostazioni può usare. A ogni persona si dà un ruolo; se a qualcuno serve qualcosa di diverso, si fa un ruolo su misura per lui.",
            whoDecidesTitle: "Chi decide",
            whoDecides: "Il Super admin e l'Admin dell'azienda creano i ruoli e li danno alle persone, ma nessuno dà permessi che non ha e nessuno cambia chi ha un ruolo pari o superiore al suo. Il Super admin di Gioia365 decide quali permessi le aziende possono dare. Ogni modifica resta registrata con autore e orario.",
        },
        tabs: {
            label: "Cosa vuoi vedere",
            users: "Utenti",
            roles: "Ruoli",
            platform: "Per tutte le aziende",
        },
        // Decisione del product owner sulla questione 38: l'Admin di partenza gestisce i ruoli.
        readOnly: "Ruoli e permessi li cambiano il Super admin e l'Admin dell'azienda: tu li vedi soltanto.",
        needsTeam: "Per dare un ruolo a una persona serve anche il permesso di gestire il team, e tu non lo hai: qui vedi i ruoli soltanto.",
        users: {
            title: "Il ruolo di ogni persona",
            help: "A ogni persona si dà un ruolo: il cambio vale subito. «Ruolo su misura» copia il ruolo di quella persona in uno nuovo, da cambiare come serve.",
            caption: "Persone e ruoli di {organization}",
            columns: {
                person: "Utente",
                role: "Ruolo",
                does: "Cosa fa",
                action: "Azione",
            },
            roleOf: "Ruolo di {name}",
            custom: "Ruolo su misura",
            customFor: "Ruolo su misura per {name}",
            changed: "{name} ora ha il ruolo «{role}».",
            // Con la tastiera la scelta non scatta a ogni freccia: si conferma con Invio o uscendo dal campo.
            unsaved: "Non ancora salvato: premi Invio per salvare o Esc per annullare.",
            // Chi ha il ruolo di sistema senza essere il titolare (dati vecchi): il ruolo non si cambia.
            systemRole: "Il ruolo Super admin non si cambia da qui: in ogni azienda il Super admin è uno solo.",
        },
        words: {
            title: "Chi può fare cosa, in parole",
            intro: "Le regole di {organization} per ogni ruolo, dal livello più alto. Si scrivono da sole dai permessi salvati, quindi cambiano quando cambiano i permessi. Sopra tutti c'è il Super admin di Gioia365, che gestisce la piattaforma per tutte le aziende.",
            level: "livello {level}",
            area: "{area}: {actions}.",
            noAccess: "{area}: nessun accesso.",
            view: { none: "non vede", own: "vede solo i suoi", all: "vede tutti" },
            create: { none: "non crea", all: "crea" },
            update: { none: "non modifica", own: "modifica solo i suoi", all: "modifica tutti" },
            delete: { none: "non elimina", own: "elimina solo i suoi", all: "elimina tutti" },
            can: "Può: {list}.",
            settings: "Impostazioni che può cambiare: {list}.",
            allSettings: "tutte",
        },
        // Scheda «Ruoli» (piano M1b Task 9): l'elenco dei ruoli, l'editor della bozza, la barra delle modifiche e i
        // dialog. Il nome di un livello è quello del ruolo di partenza di quel livello.
        list: {
            label: "Ruoli",
            system: "di sistema",
            holders: "{count} utenti",
            holdersOne: "1 utente",
            unsaved: "da salvare",
            add: "Nuovo ruolo",
        },
        editor: {
            name: "Nome del ruolo",
            nameMissing: "Dai un nome al ruolo.",
            nameTaken: "C'è già un ruolo con questo nome.",
            description: "Descrizione",
            descriptionHint: "Una frase su a cosa serve: compare in «Cosa fa» nella scheda Utenti.",
            level: "Livello: {level}",
            levelHelp: "Il livello viene dal ruolo di partenza e non si cambia.",
            levels: { user: "User", superUser: "Super user", admin: "Admin", superAdmin: "Super admin" },
            holders: "Lo hanno {count} utenti.",
            holdersOne: "Lo ha 1 utente.",
            holdersNone: "Non lo ha ancora nessuno.",
            unsaved: "Non esiste finché non lo salvi.",
            forPerson: "Quando lo salvi, diventa il ruolo di {name}.",
            // Chi gestisce i ruoli ma non il team crea il ruolo; a darlo alla persona è chi gestisce il team.
            forPersonNoTeam: "Quando lo salvi, il ruolo si crea; a {name} lo dà chi gestisce il team.",
            duplicate: "Duplica",
            delete: "Elimina",
            newName: "Nuovo ruolo",
            newDescription: "Parte dai permessi di «{role}».",
            copyName: "{name} (copia)",
            copyDescription: "Copia di «{role}».",
            customName: "Ruolo di {name}",
            customDescription: "Copia di «{role}», su misura per {name}.",
            // Decisione del product owner sulla questione 38: il Super admin è uno solo e il suo ruolo non si tocca.
            systemLock: "Il Super admin può tutto e il suo ruolo non si cambia: il Super admin è uno solo, il titolare.",
            // Un ruolo di livello 4 che non è quello di sistema (una copia scritta prima del 30 settembre 2026).
            superAdminLevel: "Un ruolo di livello Super admin non si copia né si assegna: il Super admin è uno solo.",
            levelReadOnly: "Puoi cambiare soltanto i ruoli di livello più basso del tuo: questo lo vedi soltanto.",
            powersReadOnly: "Questo ruolo può fare cose che tu non puoi fare: lo vedi soltanto.",
            matrixCaption: "Cosa può fare con i dati",
            matrixArea: "Parte del programma",
            cell: "{area}: {action}",
            notNeeded: "non serve",
            matrixNote: "«Solo i suoi» vuol dire i dati di cui è owner o che ha creato; «Tutti» vuol dire quelli di tutta l'azienda. «Eliminare» vuol dire archiviare: il Lead esce da elenchi e Smart List e si può ripristinare.",
            notYoursOption: "{scope} · non puoi dare un permesso che non hai",
            notYours: "· non puoi dare un permesso che non hai",
            unavailable: "· non disponibile: lo decide Gioia365",
            settingsNote: "Le sezioni che non ci sono ancora valgono da quando arrivano.",
            invalidCell: "Questa scelta non va bene: scegline un'altra.",
            invalidText: "Questo testo contiene caratteri che non si possono usare: riscrivilo.",
        },
        // Le modifiche di una bozza a parole, nella barra e nell'avviso di salvataggio.
        diff: {
            new: "Nuovo ruolo «{name}».",
            newFor: "Nuovo ruolo «{name}», da dare a {person}.",
            name: "Nome: «{before}» diventa «{after}».",
            description: "Descrizione cambiata.",
            scope: "{area}, {action}: da «{before}» a «{after}».",
            can: "Può: {feature}.",
            cannot: "Non può più: {feature}.",
            canSetting: "Può cambiare «{section}» nelle Impostazioni.",
            cannotSetting: "Non può più cambiare «{section}» nelle Impostazioni.",
        },
        saveBar: {
            summary: "{count} modifiche non salvate al ruolo «{name}»: {changes}",
            summaryOne: "1 modifica non salvata al ruolo «{name}»: {changes}",
            more: "{changes} …",
            save: "Salva il ruolo",
            discarded: "Modifiche annullate: il ruolo resta com'era.",
            saved: "Ruolo «{name}» salvato ({count} modifiche): vale subito per chi lo ha.",
            savedOne: "Ruolo «{name}» salvato (1 modifica): vale subito per chi lo ha.",
            // Un ruolo nuovo si salva in più richieste (D9): se una si ferma, si dice cosa è stato fatto.
            notCompleted: "Il ruolo «{name}» è stato creato ma i permessi non sono stati salvati: riprova con «Salva il ruolo».",
            notGiven: "Il ruolo «{name}» è stato creato ma non dato a {person}: daglielo dalla scheda Utenti.",
        },
        leave: {
            title: "Non hai salvato il ruolo",
            text: "Se esci adesso le modifiche al ruolo si perdono e i permessi restano com'erano.",
            discard: "Esci senza salvare",
            stay: "Resta qui",
        },
        remove: {
            title: "Eliminare il ruolo «{name}»?",
            text: "Non lo ha nessuno: sparisce dall'elenco e il nome torna libero.",
            confirm: "Elimina il ruolo",
            done: "Ruolo «{name}» eliminato: non lo aveva nessuno.",
        },
        // Ciò che l'editor dei ruoli dice meglio del testo generico di `errors`.
        errors: {
            permission_denied: "Non puoi dare permessi che non hai.",
            role_level: "Puoi cambiare soltanto i ruoli di livello più basso del tuo.",
            validation_failed: "Alcuni dati non vanno bene: ognuno è segnato con un avviso.",
            feature_unavailable: "Queste funzioni non si possono più dare, lo decide Gioia365: {list}.",
            inUse: "Lo hanno ancora {who}: cambia prima il loro ruolo.",
            inUseOne: "Lo ha ancora {who}: cambia prima il suo ruolo.",
            people: "{count} persone",
            peopleOne: "1 persona",
            invitations: "{count} inviti",
            invitationsOne: "1 invito",
            both: "{people} e {invitations}",
        },
        // Scheda «Per tutte le aziende»: soltanto per il Super admin di Gioia365.
        platform: {
            title: "Permessi che le aziende possono dare",
            intro: "Qui decide il Super admin di Gioia365, per tutte le aziende. Un permesso spento non si può dare a nessun ruolo delle aziende: resta soltanto al Super admin di ogni azienda.",
            removeTitle: "Togliere «{feature}» a tutte le aziende?",
            removeText: "Sparisce da tutti i ruoli che non sono di sistema, in ogni azienda, e riaccenderla non la rimette nei ruoli.",
            removeConfirm: "Togli a tutte le aziende",
            removed: "Tolto «{feature}»: {count} ruoli aggiornati.",
            removedOne: "Tolto «{feature}»: 1 ruolo aggiornato.",
            restored: "«{feature}» di nuovo disponibile per le aziende: si dà a un ruolo quando serve.",
        },
    },
    // Impostazioni → Calendario, fuso e lingua (piano M1b Task 10). Nessun articolo davanti al nome dell'azienda, e
    // nessun articolo o preposizione davanti a una data («Chiusura tolta: {date}», mai «del {date}»). La
    // lingua dell'azienda serve soltanto da ripiego per chi accetta un invito (decisione 39, 30 settembre 2026).
    calendar: {
        about: {
            title: "A cosa serve",
            text: "Il fuso orario, i giorni e gli orari di lavoro e le chiusure di {organization}, più la lingua per le persone nuove. Da qui partono la Sequenza di chiamate, i richiami, i Task e i periodi di Home e Report.",
            whyTitle: "Perché sta nelle Impostazioni",
            why: "Il fuso è dell'azienda e non della persona: un Commerciale in viaggio vede le stesse ore dei colleghi. Lo cambiano l'Admin e il Super admin dell'azienda; la modifica vale subito per tutti e resta registrata.",
        },
        lastSaved: "Ultimo salvataggio: {when}.",
        readOnly: "Le vedi soltanto: le cambiano l'Admin e il Super admin di {organization}.",
        // Decisione D13 (questione 43): il server lo permetterebbe, ma sono regole dell'azienda.
        readOnlyPlatform: "Sono regole di {organization}: le cambia il suo Super admin o il suo Admin, non il Super admin di Gioia365.",
        zone: {
            title: "Fuso orario",
            label: "Tutte le date e le ore di Gioia365 si leggono con il fuso",
            entry: "{name} · {id}",
        },
        zones: {
            rome: "Italia (Roma)",
            zurich: "Svizzera (Zurigo)",
            paris: "Francia (Parigi)",
            berlin: "Germania (Berlino)",
            madrid: "Spagna (Madrid)",
            london: "Regno Unito (Londra)",
            lisbon: "Portogallo (Lisbona)",
            vienna: "Austria (Vienna)",
        },
        hours: {
            title: "Giorni e orario di lavoro",
            day: "Giorno",
            works: "Si lavora",
            worksDay: "Si lavora, {day}",
            from: "Dalle",
            to: "Alle",
            fromDay: "Dalle, {day}",
            toDay: "Alle, {day}",
        },
        // Il nome del giorno in tre forme, per le frasi: «Lunedì» (tabella), «il lunedì», «del lunedì».
        weekdays: {
            name: { "1": "Lunedì", "2": "Martedì", "3": "Mercoledì", "4": "Giovedì", "5": "Venerdì", "6": "Sabato", "7": "Domenica" },
            on: { "1": "il lunedì", "2": "il martedì", "3": "il mercoledì", "4": "il giovedì", "5": "il venerdì", "6": "il sabato", "7": "la domenica" },
            of: { "1": "del lunedì", "2": "del martedì", "3": "del mercoledì", "4": "del giovedì", "5": "del venerdì", "6": "del sabato", "7": "della domenica" },
        },
        closures: {
            title: "Chiusure",
            caption: "Giorni di chiusura",
            day: "Giorno",
            reason: "Perché",
            remove: "Togli",
            removeNamed: "Togli la chiusura: {date}",
            none: "Nessuna chiusura.",
            noReason: "senza motivo",
            dayLabel: "Giorno di chiusura",
            reasonPlaceholder: "Per esempio: chiusura estiva",
            add: "Aggiungi la chiusura",
            missing: "Scegli il giorno e scrivi perché si chiude.",
            duplicate: "Quel giorno è già chiuso.",
            full: "Il calendario tiene al massimo 1.000 chiusure: togline qualcuna già passata.",
            note: "Nei giorni chiusi non si programmano né chiamate della sequenza né richiami: si passa al primo giorno aperto.",
            // Le festività nazionali, le giornate rosse del calendario (richiesta del product owner del 1° ottobre 2026).
            addHolidays: "Aggiungi le festività del {year}",
            holidaysHint: "Le giornate rosse del calendario: Capodanno, Epifania, Pasqua e Pasquetta, 25 aprile, 1° maggio, 2 giugno, Ferragosto, San Francesco (4 ottobre), Ognissanti, Immacolata, Natale e Santo Stefano. Entrano quelle che mancano, da oggi in poi, ognuna con il suo nome; un giorno già chiuso resta con il suo motivo. La festa del patrono si aggiunge a mano.",
            holidaysAdded: "Aggiunte {count} festività del {year}: valgono quando salvi.",
            holidaysAddedOne: "Aggiunta 1 festività del {year}: vale quando salvi.",
        },
        language: {
            title: "Lingua dell'azienda",
            label: "Lingua per le persone nuove, se il loro browser non ne indica una",
            hint: "Non cambia la lingua di chi c'è già: ognuno sceglie la sua dal proprio account. Serve soltanto a chi accetta un invito con un browser che non dice la sua lingua.",
        },
        problems: {
            noOpenDay: "Scegli almeno un giorno lavorativo.",
            endBeforeStart: "In ogni giorno l'ora di fine viene dopo quella di inizio.",
        },
        // Le modifiche di una bozza a parole, per «Cosa cambia per il team».
        changes: {
            zone: "Il fuso dell'azienda diventa {after}, non più {before}: tutte le date e le ore si leggono così.",
            opens: "Si lavora {day}, dalle {start} alle {end}.",
            closes: "Non si lavora più {day}.",
            hours: "L'orario di lavoro {day} diventa {start}–{end}.",
            closureAdded: "Nuova chiusura: {date}, {reason}.",
            closureAddedNoReason: "Nuova chiusura: {date}.",
            closureRemoved: "Chiusura tolta: {date} ({reason}).",
            closureRemovedNoReason: "Chiusura tolta: {date}.",
            closureReason: "Nuovo motivo per la chiusura: {date}, «{reason}».",
            language: "La lingua dell'azienda diventa {language}: vale soltanto per le persone nuove il cui browser non indica una lingua.",
            languages: { it: "italiano", en: "inglese" },
        },
        saveBar: {
            summary: "{count} modifiche da salvare. Per il team non cambia niente finché non salvi.",
            summaryOne: "1 modifica da salvare. Per il team non cambia niente finché non salvi.",
            save: "Salva…",
            discarded: "Modifiche annullate: resta tutto com'era.",
            saved: "Salvato: vale per tutta l'azienda.",
        },
        confirm: {
            title: "Cosa cambia per il team",
            note: "Vale per tutta l'azienda da subito. La modifica resta registrata con il tuo nome e l'orario.",
            back: "Torna alle modifiche",
            apply: "Salva e applica a tutta l'azienda",
        },
        leave: {
            title: "Non hai salvato le modifiche",
            text: "Se esci adesso le modifiche a calendario, fuso e lingua si perdono e restano quelle di prima.",
            discard: "Esci senza salvare",
            stay: "Resta qui",
        },
        // Ciò che la sezione dice meglio del testo generico di `errors`.
        errors: {
            closureReasons: "Una chiusura non ha un motivo che vada bene: toglila e aggiungila di nuovo.",
        },
    },
    // Aziende di Gioia365 (piano M1b Task 11), soltanto per il Super admin di Gioia365. Nessun articolo davanti al
    // nome dell'azienda. Il titolare diventa il Super admin dell'azienda, uno solo (decisione 38); la lingua è il
    // ripiego per chi accetta un invito con un browser che non ne indica una (decisione 39).
    platform: {
        eyebrow: "Super admin di Gioia365",
        title: "Aziende di Gioia365",
        about: {
            title: "A cosa serve",
            text: "Qui ci sono le aziende che usano Gioia365. Le crea e le sospende soltanto il Super admin di Gioia365.",
        },
        list: {
            title: "Le aziende",
            caption: "Le aziende di Gioia365",
            counts: "In tutto {total}: attive {active}, sospese {suspended}, chiuse {closed}, in preparazione {preparing}.",
            empty: "Non c'è ancora nessuna azienda. Creane una con «Nuova azienda».",
            preparing: "Sto preparando il database di {organization}…",
        },
        new: "Nuova azienda",
        columns: {
            company: "Azienda",
            status: "Stato",
            owner: "Titolare",
            people: "Persone attive",
            created: "Creata il",
            action: "Azione",
        },
        status: {
            provisioning: "In preparazione",
            stalled: "La preparazione si è fermata",
            active: "Attiva",
            suspending: "Sospensione in corso",
            closing: "Chiusura in corso",
            suspended: "Sospesa",
            closed: "Chiusa",
        },
        row: {
            enter: "Entra",
            enterNamed: "Entra in {organization}",
            manage: "Gestisci",
            manageNamed: "Gestisci {organization}",
            continueSetup: "Riprendi la preparazione",
            continueSetupNamed: "Riprendi la preparazione di {organization}",
        },
        fields: {
            name: "Nome dell'azienda",
            nameMissing: "Scrivi il nome dell'azienda.",
            slug: "Indirizzo breve",
            slugHint: "È anche l'indirizzo dell'azienda, da dare a chi ci lavora (per esempio gioia365.com/academy); non si cambia.",
            slugInvalid: "Usa da 3 a 40 caratteri: minuscole e numeri, separati da trattini, e non il nome di una pagina del programma.",
            timeZone: "Fuso orario",
            language: "Lingua per le persone nuove, se il loro browser non ne indica una",
            owner: "Titolare",
            ownerValue: "{name} · {email}",
            ownerFirstName: "Nome del titolare",
            ownerLastName: "Cognome del titolare",
            ownerNameMissing: "Scrivi nome e cognome del titolare.",
            ownerEmail: "Email del titolare",
            ownerEmailHint: "Qui arriva l'invito: il titolare sceglie la sua password e diventa il Super admin dell'azienda.",
            ownerEmailInvalid: "Scrivi un'email valida: è quella con cui il titolare entra.",
        },
        create: {
            submit: "Crea l'azienda",
            submitting: "Sto preparando il database dell'azienda…",
            waiting: "Ci vuole un momento: non chiudere questa finestra.",
            created: "Azienda creata. L'invito è partito per {email}.",
        },
        ownerLink: {
            title: "Invito del titolare pronto",
            intro: "{organization} è stata creata. L'email non è partita: copia il link e mandalo tu a {name}, per esempio su WhatsApp. Scade: {date}.",
        },
        manage: {
            suspend: "Sospendi",
            resume: "Riattiva",
            close: "Chiudi",
            closeNamed: "Chiudi {organization}",
            done: "Fatto",
            // «Cambia nome» (decisione del 4 ottobre 2026).
            rename: "Salva il nome",
            renaming: "Salvataggio…",
            renamed: "Nome salvato.",
            renameHint: "Lo vedono tutti nel programma e negli inviti. L'indirizzo breve qui sotto non cambia.",
        },
        confirm: {
            suspendTitle: "Sospendere {organization}?",
            suspendText: "Nessuno dell'azienda entra finché non la riattivi. Non si cancella niente.",
            closeTitle: "Chiudere {organization}?",
            closeText: "È definitivo: nessuno entra più. I dati restano finché il database non viene eliminato a mano.",
        },
        done: {
            suspended: "{organization} è sospesa.",
            resumed: "{organization} è di nuovo attiva.",
            closed: "{organization} è chiusa.",
        },
        // Ciò che la pagina dice meglio del testo generico di `errors`.
        errors: {
            invalid_state: "Qualcuno l'ha appena cambiata: la tabella è aggiornata.",
            resumeTaken: "Qualcun altro l'ha appena completata: la tabella è aggiornata.",
        },
    },
    // «Telefonia» di un'azienda, dalla riga della pagina «Aziende di Gioia365» (piano M4, Task 14, D18): il Super admin di
    // Gioia365 accende la telefonia, segue i passi che il server fa da solo presso il fornitore, verifica il numero mostrato,
    // sceglie le impostazioni, prova la connessione e la spegne. Nessun mock-up: le parole sono proposte (questione 200). Non
    // c'è mai un campo per una chiave o un segreto: li crea e li custodisce il server.
    // I numeri ammessi dei WhatsApp automatici di un'azienda (piano M6, R2, Task 7b; D19, questione 414), accanto alla telefonia nella
    // pagina «Aziende di Gioia365», soltanto dove sono richiesti (fuori dalla produzione). Senza mock-up: le parole sono proposte
    // (questione 409), sul modello dei numeri ammessi della telefonia.
    platformWhatsApp: {
        open: "Numeri WhatsApp",
        title: "Numeri ammessi per i WhatsApp di {organization}",
        intro: "Fuori dalla produzione i WhatsApp automatici di {organization} (il WhatsApp ufficiale di Meta e WhatsApp Agile) partono soltanto verso questi numeri: i telefoni del team che prova. Il modo a mano non manda niente da sé e resta sempre.",
        allowed: "Numeri ammessi",
        allowedFormat: "Un numero per riga, con il prefisso del paese, per esempio +393000000001. Al massimo {max}.",
        allowedInvalid: "«{number}» non è un numero valido: scrivilo con il prefisso del paese, per esempio +393000000001.",
        allowedTooMany: "Sono troppi: al massimo {max} numeri.",
        empty: "Nessun numero ammesso: nessun WhatsApp automatico di {organization} parte.",
        save: "Salva",
        saveNothing: "Nessuna modifica da salvare.",
        saved: "Numeri ammessi salvati.",
        conflict: "Nel frattempo qualcuno ha cambiato i numeri ammessi di {organization}: per tenere quelli scritti qui, salva di nuovo.",
    },
    platformTelephony: {
        title: "Telefonia di {organization}",
        open: "Telefonia",
        off: "La telefonia è spenta.",
        turnOn: "Accendi la telefonia",
        turnOnHint: "Gioia365 crea da sola presso il fornitore il sottoaccount, la chiave e l'applicazione dell'azienda: non serve aprire la console né copiare niente.",
        turningOnWait: "Gioia365 sta impostando il fornitore: ci vuole qualche secondo. Puoi lasciare aperta questa finestra.",
        provider: "Fornitore",
        providers: {
            twilio: "Twilio",
            telnyx: "Telnyx",
        },
        setupTitle: "Impostazione presso il fornitore",
        stepName: {
            account: "Sottoaccount",
            api_key: "Chiave",
            application: "Applicazione",
            storage: "Spazio dell'audio",
        },
        stepAccount: "Sottoaccount creato",
        stepApiKey: "Chiave creata",
        stepApplication: "Applicazione creata",
        stepStorage: "Spazio dell'audio impostato",
        // Dal 4 ottobre 2026 le registrazioni restano presso il fornitore: senza lo spazio di Gioia365 il passo dello spazio si salta.
        stepAudioAtProvider: "L'audio resta presso il fornitore (Twilio, Stati Uniti)",
        stepDoing: "{step}: in corso…",
        stepWaiting: "{step}: in attesa",
        stepFailed: "{step}: non riuscito",
        statePending: "In preparazione…",
        stateReady: "Pronta",
        stateFailed: "Non riuscita al passo «{step}»: {reason}",
        stateStalled: "La preparazione si è fermata a metà: «Riprova» la riprende da dove era arrivata.",
        retry: "Riprova",
        retrying: "Sto riprovando…",
        // Il motivo di un passo non riuscito, dal codice che il server ha registrato (mai il messaggio del fornitore). Ogni codice ha
        // la sua frase in parole semplici; un codice che non si conosce vale `generic`, e il codice grezzo non si mostra mai.
        reason: {
            credentials: "il fornitore non accetta la chiave di Gioia365: va sostituita con una valida.",
            rateLimited: "il fornitore chiede di rallentare: riprova fra qualche minuto.",
            providerDown: "il fornitore ha un guasto in questo momento: riprova fra qualche minuto.",
            unreachable: "Gioia365 non ha raggiunto il fornitore: riprova fra poco.",
            timeout: "il fornitore non ha risposto in tempo: riprova.",
            accountMissing: "il sottoaccount non c'è più presso il fornitore.",
            foreignAccount: "presso il fornitore c'è già un account con questo nome che Gioia365 non ha creato per questa azienda, e non lo usa.",
            applicationMissing: "l'applicazione della voce non c'è più presso il fornitore.",
            invalidResponse: "il fornitore ha risposto in un modo che Gioia365 non capisce: riprova fra poco.",
            signingSecret: "il fornitore non ha dato a Gioia365 il codice con cui riconosce i suoi avvisi: riprova fra poco.",
            secrets: "Gioia365 non riesce a rileggere i dati di accesso che aveva salvato per questa azienda.",
            generic: "il fornitore non ha completato il passo: riprova fra poco.",
        },
        waitReady: "Il numero mostrato, la registrazione e la prova si aprono quando la telefonia è pronta.",
        // Il motivo per cui un pulsante è spento: dice esattamente che cosa non si può fare. Con la telefonia spenta c'è soltanto
        // «Accendi la telefonia»; con la telefonia accesa sono spenti «Riprova» e «Verifica», e restano «Salva», «Prova la
        // connessione» e «Spegni la telefonia».
        inactiveTurnOn: "L'azienda non è attiva: finché non lo è, la telefonia non si può accendere.",
        inactive: "L'azienda non è attiva: finché non lo è, non si può riprendere l'impostazione né verificare il numero mostrato. Salvare le impostazioni, provare la connessione e spegnere la telefonia si può.",
        callerTitle: "Numero mostrato",
        callerNumber: "Numero mostrato (per «Prova la connessione»)",
        callerHint: "Serve a «Prova la connessione». Per verificare questo numero il fornitore telefona al cellulare e chi lo tiene digita il codice. Nelle chiamate il Lead vede il cellulare di chi chiama, dato in Impostazioni → Team.",
        callerInvalid: "Scrivi il numero con il prefisso del paese e senza spazi, per esempio +393000000001.",
        // `409 caller_number_already_verified` sul numero mostrato (piano M4, Task 20): il pannello non ha il parco dei cellulari,
        // quindi non rimanda a «Leggi i cellulari già verificati» come il testo dell'errore (questione 208).
        callerAlreadyVerified: "Il fornitore ha già verificato questo numero per l'azienda, per esempio nel parco dei cellulari: qui non si verifica una seconda volta, e il numero mostrato resta quello di prima.",
        callsTitle: "Registrazione e numeri",
        recording: "Registra le chiamate",
        recordingNotice: "Avviso al Lead prima della registrazione",
        recordingNoticeHint: "Il Lead lo sente appena risponde. Lascialo vuoto per non dire niente.",
        noticeInvalid: "L'avviso può avere al massimo 300 caratteri, su una riga e senza caratteri speciali.",
        allowed: "Numeri ammessi",
        allowedHint: "Soltanto questi numeri si possono chiamare. Nelle aziende di prova sono obbligatori.",
        allowedFormat: "Un numero per riga, con il prefisso del paese, per esempio +393000000001. Al massimo {max}.",
        allowedMissing: "Nelle aziende di prova servono i numeri ammessi: scrivine almeno uno.",
        allowedInvalid: "«{number}» non è un numero valido: scrivilo con il prefisso del paese, per esempio +393000000001.",
        allowedTooMany: "Sono troppi: al massimo {max} numeri.",
        allowedLandline: "{number} sembra un fisso italiano senza lo 0: dopo +39 i fissi cominciano con 0, per esempio +39 02… o +39 095…",
        save: "Salva",
        saveNothing: "Nessuna modifica da salvare.",
        saved: "Impostazioni salvate.",
        conflict: "Qualcun altro ha appena cambiato la telefonia di questa azienda: ho riletto le impostazioni. Controlla ciò che hai scritto e salva di nuovo.",
        checkTitle: "Connessione",
        check: "Prova la connessione",
        checking: "Sto provando la connessione…",
        checkOk: "Connessione riuscita",
        checkedAt: "Provata il {date}",
        // Il motivo di una prova non riuscita (`ConnectionCheck` del dominio), dal codice che il server ha registrato.
        checkReason: {
            credentials_rejected: "Il fornitore non accetta la chiave di questa azienda.",
            account_mismatch: "Il sottoaccount che risponde non è quello di questa azienda.",
            application_missing: "L'applicazione della voce non c'è più presso il fornitore.",
            caller_not_verified: "Il numero mostrato non è ancora verificato: verificalo qui sopra.",
            unreachable: "Gioia365 non ha raggiunto il fornitore: riprova fra poco.",
            other: "La prova non è riuscita: riprova fra poco.",
        },
        disable: "Spegni la telefonia",
        disableTitle: "Spegnere la telefonia di {organization}?",
        disableText: "Nessuno dell'azienda potrà più chiamare finché non la riaccendi. Presso il fornitore non si cancella niente.",
        disabling: "Sto spegnendo la telefonia…",
    },
    // La verifica di un cellulare presso il fornitore (piano M4, D18): il codice di sei cifre da digitare sul telefono, lo
    // stato e «Verifica». Un componente solo (`telephony/caller-verification.tsx`), usato dalla «Telefonia» dell'azienda
    // (Task 14) e dal parco dei cellulari di Team (Task 17).
    callerVerification: {
        verify: "Verifica",
        busy: "Chiedo la verifica al fornitore…",
        typeCode: "Il telefono sta squillando: chi lo tiene risponde e digita sulla tastiera {code}.",
        codeSent: "Il fornitore manda un codice a quel telefono. La verifica finisce quando il fornitore la conferma.",
        requested: "Verifica chiesta al fornitore: aspetto la conferma. Se il telefono non ha squillato, premi «Verifica» per chiedere un nuovo codice.",
        verified: "Verificato",
        failed: "Verifica non riuscita: il telefono non ha risposto o il codice non era giusto. Premi «Verifica» per riprovare.",
    },
    // Il parco dei cellulari dell'ufficio in Impostazioni → Team (piano M4, Task 17): la colonna «Numero per chiamare», la
    // sezione «Parco numeri per chiamare» e la scelta del numero in «Gestisci». Dal mock-up (`mockup.js`, Team), alla lettera:
    // `poolTitle`, `column`, `none`, `free`, `of` e `summary`; `poolHint` riscritto con TEL-3 (18/10/2026). Il resto sono proposte
    // (questione 209). Il codice da
    // digitare, «Verifica» e «Verificato» sono quelli di `callerVerification`, come la riga in verifica per chi può verificarla;
    // `requested` è la riga in verifica per chi non ha «Verifica».
    callerNumbers: {
        poolTitle: "Parco numeri per chiamare",
        poolHint: "I numeri italiani dell'azienda, da cui partono le chiamate: arrivano con la telefonia e si danno alle persone dalla loro riga, con «Gestisci». Ognuno ne ha uno, e lo stesso numero può essere di più persone: ogni chiamata resta di chi la fa.",
        column: "Numero per chiamare",
        none: "Nessun numero",
        free: "libero",
        of: "di {name}",
        // Nella scelta del numero, un cellulare che è già di altre persone (TEL-3): si può dare anche a questa.
        alsoOf: "anche di {names}",
        summary: "Numeri per chiamare: {assigned} assegnati su {total}.",
        summaryOne: "Numeri per chiamare: 1 assegnato su {total}.",
        add: "Aggiungi un cellulare",
        import: "Leggi i cellulari già verificati",
        failed: "Verifica non riuscita: riprova.",
        remove: "Togli dal parco",
        requested: "Verifica chiesta al fornitore: aspetto la conferma.",
        failedElsewhere: "Verifica non riuscita: la riprova chi gestisce i numeri per chiamare, il Super admin o l'Admin dell'azienda.",
        empty: "Nel parco non c'è ancora nessun cellulare.",
        loadFailed: "Non riesco a leggere i numeri per chiamare. Riprova.",
        verifyNamed: "Verifica {number}",
        removeNamed: "Togli dal parco {number}",
        imported: "Cellulari già verificati aggiunti al parco: {count}.",
        importedOne: "Un cellulare già verificato aggiunto al parco.",
        importedNone: "Nessun cellulare nuovo: quelli verificati presso il fornitore sono già nel parco.",
        addDialog: {
            verifyTitle: "Verifica {number}",
            intro: "Gioia365 chiede al fornitore di verificarlo: il cellulare squilla e chi lo tiene digita il codice che compare qui.",
            number: "Cellulare",
            numberHint: "Un cellulare italiano con il prefisso, per esempio +393000000001.",
            numberInvalid: "Scrivi il cellulare con il prefisso +39, per esempio +393000000001.",
            label: "Nome del cellulare",
            labelHint: "Per riconoscerlo, per esempio «Postazione 2».",
            labelMissing: "Scrivi il nome del cellulare, al massimo 60 caratteri.",
            gone: "Questo cellulare non è più nel parco: l'ha tolto qualcun altro.",
            // «Verifica» di nuovo su una riga del parco che il fornitore ha già verificato (`409 caller_number_already_verified`, piano
            // M4, Task 20): l'importazione da sola non la cambia, perché il numero è già nel parco (questione 208).
            alreadyVerified: "Il fornitore ha già verificato questo cellulare: premi «Togli dal parco» e poi «Leggi i cellulari già verificati», che lo riporta nel parco verificato.",
            // Al più cinque telefonate di verifica l'ora per cellulare, trenta per azienda (`429 rate_limited`, TEL-3).
            tooMany: "Troppe verifiche in poco tempo: il telefono ha già squillato più volte. Riprova fra un'ora.",
        },
        removeDialog: {
            title: "Togliere {number} dal parco?",
            assigned: "{name} lo perde e resta senza numero per chiamare finché non gliene dai un altro.",
            assignedMany: "{names} lo perdono e restano senza numero per chiamare finché non gliene dai un altro.",
            free: "Non è di nessuno.",
            past: "Le chiamate già fatte con questo cellulare restano com'erano.",
            done: "{number} tolto dal parco.",
        },
        assign: {
            blocked: "Per dare i numeri, il tuo ruolo deve avere la sezione «Numeri per chiamare» in {link}.",
            suspended: "Chi è sospeso tiene il suo numero, ma non ne riceve uno nuovo.",
            versionConflict: "Nel frattempo qualcuno ha cambiato i numeri per chiamare: li ho riletti, controlla e salva di nuovo.",
            releasedOnly: "{name} non ha più {number}, ma il numero scelto non è stato assegnato. {reason}",
        },
        // Il solo numero dalla cella «Numero per chiamare», sulle righe senza «Gestisci» (il titolare, la propria).
        numberDialog: {
            title: "Numero per chiamare di {name}",
            assign: "Assegna",
            change: "Cambia",
            assignNamed: "Assegna un numero per chiamare a {name}",
            changeNamed: "Cambia il numero per chiamare di {name}",
        },
    },
    // Le etichette del catalogo dei permessi (aree, azioni, ambiti, funzioni), dai mock-up `permessi.html`. Una
    // voce del catalogo senza etichetta non compila (`permission-labels.ts`). Le funzioni sono all'infinito
    // («Chiamare…»): nelle frasi di «in parole» diventano «Può: chiamare…».
    permissions: {
        area: {
            leads: "Lead",
            smart_lists: "Smart List",
            tasks: "Task e richiami",
            opportunities: "Opportunità",
            conversations: "Conversazioni e registrazioni",
            activity: "Registro Attività",
            reports: "Report e numeri della Home",
        },
        action: {
            view: "Vedere",
            create: "Creare",
            update: "Modificare",
            delete: "Eliminare",
        },
        scope: {
            none: "No",
            own: "Solo i suoi",
            all: "Tutti",
        },
        // «Creare» ha soltanto «No» e «Sì».
        createScope: {
            none: "No",
            all: "Sì",
        },
        group: {
            leads: "Lead",
            calls: "Chiamate e WhatsApp",
            team: "Team e utenti",
            settings: "Impostazioni che può cambiare",
        },
        feature: {
            change_owner: "Cambiare l'owner, con il motivo",
            import_leads: "Importare da file",
            export_leads: "Esportare in un file",
            bulk_actions: "Fare azioni multiple su più Lead",
            merge_duplicates: "Unire i doppioni (Pulizia dati)",
            trash_restore: "Archiviare e ripristinare i Lead",
            manage_tags: "Creare e cambiare i tag",
            call: "Chiamare e usare la postazione",
            whatsapp_send: "Mandare WhatsApp",
            listen_team_recordings: "Ascoltare le registrazioni dei colleghi",
            commercial_view: "Guardare come un'altra persona dell'azienda («Guarda come…»)",
            manage_team: "Gestire il team (invitare, sospendere, archiviare, nomi, telefoni e WhatsApp)",
            manage_roles: "Gestire ruoli e permessi",
            // Le sezioni delle Impostazioni: nomi, non azioni.
            settings: {
                team: "Team",
                roles: "Ruoli e permessi",
                phone_numbers: "Numeri per chiamare",
                lead_statuses: "Status del Lead",
                lead_fields: "Campi della scheda",
                lead_visibility: "Chi vede i Lead",
                tags: "Tag",
                call_sequence: "Sequenza di chiamate (anche i minuti della prima chiamata)",
                outcomes: "Esiti e percorsi",
                callbacks: "Richiami e orari",
                whatsapp_channels: "I WhatsApp che usa l'azienda",
                whatsapp_sending: "Invio dei WhatsApp",
                whatsapp_templates: "Modelli WhatsApp",
                calendar: "Calendario, fuso e lingua",
                assignment: "Assegnazione dei Lead",
                lead_intake: "Ingressi dei Lead",
                table_views: "Vista dell'azienda",
                goals: "Obiettivi",
            },
        },
    },
    // Il link da copiare quando il server non manda l'email (inviti del Team, titolare di un'azienda nuova).
    manualLink: {
        label: "Link dell'invito",
        copy: "Copia il link",
        copied: "Copiato",
        copyFailed: "Non riesco a copiarlo da qui: seleziona il link e copialo a mano.",
    },
    account: {
        title: "Il tuo account",
        // Nome e cognome dell'account: le due caselle usano «Nome» e «Cognome» di `common`.
        name: {
            help: "È il nome del tuo account.",
            helpInCompany: "È il nome del tuo account. Nel team di {organization} compari come «{displayName}»: lo cambia chi gestisce il team.",
            save: "Salva il nome",
            saved: "Nome salvato.",
        },
        // Ogni lingua con il suo nome, uguale nei due cataloghi.
        language: {
            label: "Lingua",
            italian: "Italiano",
            english: "English",
            saved: "Lingua salvata.",
        },
        password: {
            title: "Password",
            change: "Cambia la password",
            current: "Password attuale",
            currentMissing: "Scrivi la password attuale.",
            wrong: "La password attuale non è corretta.",
            done: "Password cambiata. Le altre sessioni sono state chiuse.",
        },
        company: {
            title: "Azienda di questa scheda",
            current: "{organization} · {role}",
            platform: "In questa scheda sei in {organization} come Super admin di Gioia365.",
            change: "Cambia azienda",
        },
    },
    tab: {
        question: "In quale azienda lavori in questa scheda?",
        onePerTab: "Ogni scheda del browser lavora in una sola azienda: puoi aprirne un'altra su un'altra azienda.",
        unavailable: "L'azienda di questa scheda non è più disponibile: scegline un'altra.",
        // L'indirizzo con il nome dell'azienda (`/<slug>`, decisione del 3 ottobre 2026) che non è di un'azienda della persona.
        unknownAddress: "Non hai l'autorizzazione per aprire questa pagina.",
        noCompany: "Non fai parte di nessuna azienda attiva. Chiedi a chi gestisce il team di invitarti.",
        platformLink: "Aziende di Gioia365",
    },
    errorPage: {
        message: "Qualcosa non ha risposto. Riprova tra poco.",
        signOut: "Uscita non riuscita. Riprova tra poco.",
    },
    // Un testo per ogni codice d'errore dell'API (`API_ERROR_CODES` nei contratti) più quelli del client:
    // l'interfaccia non mostra mai il messaggio tecnico del server. Le schermate possono dire di più.
    errors: {
        google_calendar_unavailable: "Google Calendar non è ancora disponibile in Gioia365.",
        google_oauth_invalid: "Il collegamento è scaduto o non appartiene a questa sessione. Riprova da Il tuo account.",
        google_calendar_failed: "Google Calendar non ha risposto correttamente. Riprova.",
        registration_unavailable: "La registrazione non è disponibile in questo momento. Riprova più tardi.",
        registration_token_invalid: "Questo link non è valido o è scaduto. Registrati di nuovo per ricevere un nuovo link.",
        billing_unavailable: "Gli acquisti non sono disponibili in questo momento. Riprova più tardi.",
        billing_payment_required: "Il pagamento richiede attenzione. Gestisci l’abbonamento per riprendere il lavoro.",
        billing_seat_limit: "Il team occupa più posti di quelli acquistati. Aumenta i posti prima di invitare o riattivare altre persone.",
        billing_signature_invalid: "Pagamento non verificabile.",
        unauthenticated: "La sessione è scaduta: accedi di nuovo.",
        membership_required: "Questa scheda non sa in quale azienda lavori: scegli l'azienda.",
        membership_forbidden: "Non fai più parte di questa azienda, oppure il tuo accesso è sospeso.",
        platform_forbidden: "Questa parte è soltanto per il Super admin di Gioia365.",
        organization_unavailable: "L'azienda al momento non è disponibile. Riprova tra poco; se continua, avvisa chi gestisce Gioia365.",
        permission_denied: "Non hai il permesso per farlo.",
        protected_owner: "Il titolare dell'azienda è protetto: il suo ruolo e il suo stato non si cambiano.",
        role_level: "Puoi farlo soltanto per ruoli più bassi del tuo.",
        slug_taken: "Questo indirizzo breve è già usato da un'altra azienda: scegline un altro.",
        provisioning_failed: "La preparazione si è fermata a metà. Riprova: riparte da dove si era fermata.",
        provisioning_unavailable: "Su questo server la creazione delle aziende non è attiva: manca la credenziale amministrativa del database.",
        invitation_invalid: "Questo link non vale più: chiedi un nuovo invito a chi ti ha invitato.",
        invitation_expired: "L'invito è scaduto: chiedi a chi ti ha invitato di mandarlo di nuovo.",
        invitation_revoked: "Questo invito è stato annullato o sostituito da uno più nuovo: usa l'ultimo link che hai ricevuto.",
        invitation_used: "Questo invito è già stato usato.",
        invitation_pending: "C'è già un invito in attesa per questa email.",
        already_member: "C'è già una persona dell'azienda con questa email.",
        invalid_credentials: "Email o password non corretti.",
        role_in_use: "Questo ruolo è ancora assegnato a qualcuno: cambia prima il loro ruolo.",
        system_role: "Il ruolo Super admin dell'azienda non si cambia e non si archivia.",
        feature_unavailable: "Questa funzione non è disponibile: lo decide Gioia365.",
        cannot_act_on_self: "Non puoi farlo sul tuo account.",
        not_found: "Non trovo quello che cerchi: forse è stato tolto.",
        validation_failed: "Alcuni dati non vanno bene: controlla i campi e riprova.",
        invalid_state: "Non si può fare nello stato in cui si trova adesso: ricarica la pagina e controlla.",
        rate_limited: "Troppi tentativi: aspetta un minuto e riprova.",
        session_mismatch: "Questo invito è per un'altra persona. Esci e apri di nuovo il link.",
        role_name_taken: "C'è già un ruolo con questo nome: scegline un altro.",
        origin_forbidden: "La richiesta non arriva da Gioia365: ricarica la pagina e riprova.",
        payload_too_large: "Troppi dati in una volta sola: riducili e riprova.",
        internal_error: "Qualcosa non ha funzionato. Riprova tra poco.",
        // Lead, scheda e importazione (piano M2): testi di ripiego, le schermate di M2 possono dire di più.
        organization_schema_outdated: "L'azienda aspetta un aggiornamento del suo database. Riprova tra poco; se continua, avvisa chi gestisce Gioia365.",
        lead_not_found: "Lead non trovato: forse è stato archiviato o unito a un altro, oppure non rientra fra quelli che vedi.",
        version_conflict: "Qualcuno ha appena modificato questi dati: ricarica e rifai la modifica.",
        field_not_editable: "Questo campo non si modifica da qui.",
        invalid_field_value: "Un valore non va bene: controlla il campo e riprova.",
        invalid_phone: "Il numero di telefono non va bene: controllalo e riprova.",
        phone_required: "Serve almeno un telefono: il cellulare o il fisso.",
        phone_in_use: "Questo numero è già su un altro Lead.",
        phone_repeated_on_lead: "Questo numero è già scritto su questo Lead.",
        possible_duplicate_email: "Questa email è già su un altro Lead: forse è la stessa azienda target.",
        reason_required: "Scrivi il motivo del cambio.",
        owner_not_eligible: "La persona scelta non può essere owner di questi Lead, oppure non c'è nessuno a cui darli.",
        call_not_found: "Non trovo questa telefonata su questo Lead.",
        card_model_invalid: "La composizione della scheda non va bene: controlla i campi e riprova.",
        import_run_not_found: "Non trovo questa importazione.",
        saved_search_not_found: "Non trovo questa ricerca salvata di Close fra quelle da decidere: ricarica la pagina.",
        commercial_view_denied: "Non puoi guardare come vede questa persona.",
        membership_active: "Questa persona è ancora attiva: i suoi Lead si riassegnano soltanto quando è sospesa o archiviata.",
        membership_has_leads: "Questa persona ha ancora dei Lead: riassegnali prima di continuare.",
        membership_from_close: "Questa persona viene da Close: per farla tornare nel team mandale un invito.",
        // Filtri dell'elenco Lead e delle Smart List (piano M3): testo di ripiego.
        filter_invalid: "Un filtro non va bene: cambialo o toglilo e riprova.",
        // Smart List (piano M3, Task 7): testi di ripiego.
        smart_list_not_found: "Smart List non trovata: forse è stata eliminata, oppure non è fra quelle che vedi.",
        smart_list_name_taken: "C'è già una Smart List con questo nome nel menu del suo owner: scegline un altro.",
        tag_name_invalid: "Questo nome non va bene per un tag: serve almeno una lettera o una cifra, e «Owner:» è riservato agli ingressi.",
        tag_hidden: "C'è già un tag con questo nome, ma è nascosto: non si aggiunge più ai Lead. Scegli un altro nome.",
        recipients_required: "Scegli almeno un collega con cui condividerla.",
        // Archivio dei Lead (piano M3, Task 11): testi di ripiego.
        lead_archived: "Questo Lead è già archiviato: lo trovi fra gli «Archiviati».",
        lead_not_archived: "Questo Lead non è archiviato: ricarica la pagina e controlla.",
        lead_merged: "Un Lead unito a un altro non si ripristina: i suoi dati sono già nel Lead che è rimasto.",
        confirmation_required: "Scrivi «elimina» per confermare: l'eliminazione è per sempre.",
        // Azioni multiple (piano M3, Task 13): testo di ripiego.
        bulk_too_large: "Troppi Lead per un'azione multipla: al massimo 5.000 alla volta. Restringi la ricerca o i filtri e riprova.",
        // «Pulizia dati»: unione dei doppioni (piano M3, Task 16): testo di ripiego.
        merge_invalid: "Questi due Lead non si uniscono così: ricarica «Pulizia dati» e riprova dalla coppia proposta.",
        // La telefonia di un'azienda (piano M4, Task 5): testi di ripiego.
        telephony_unavailable: "La telefonia di questa azienda non è pronta: accendila e aspetta che l'impostazione finisca, poi riprova.",
        telephony_provisioning_unavailable: "La telefonia non si può impostare adesso: a Gioia365 manca la chiave di accesso presso il fornitore.",
        telephony_provisioning_failed: "Il fornitore della telefonia non ha completato un passo dell'impostazione. Premi «Riprova»: riprende da dove si è fermata.",
        // Le chiamate della telefonia (piano M4, Task 8): testi di ripiego, la postazione dice il motivo.
        lead_not_callable: "Questo Lead o questo numero adesso non si chiama: ricarica la scheda per vedere il motivo.",
        lead_status_blocks_calls: "Con questo status il Lead non si chiama: niente richiamo.",
        lead_in_call: "Un collega è già al telefono con questo Lead: aspetta che finisca.",
        destination_not_allowed: "Questo numero non è fra quelli che l'azienda può chiamare durante le prove.",
        // L'esito della chiamata (piano M4, Task 10): la chiamata ne ha già uno, e la scelta nuova resta nella Timeline.
        call_outcome_exists: "Questa chiamata ha già un esito: quello che hai scelto adesso resta nella Timeline come arrivato tardi, senza cambiarlo.",
        // L'ascolto di una registrazione (piano M4, Task 11a; dal 4 ottobre 2026 dall'audio presso il fornitore).
        recording_unavailable: "La registrazione adesso non si può ascoltare. Riprova più tardi.",
        recording_link_expired: "L'ascolto è scaduto: premi di nuovo «Ascolta».",
        attachment_unavailable: "L'allegato adesso non si apre: riprova fra poco.",
        attachment_link_expired: "Il collegamento dell'allegato è scaduto: aprilo di nuovo dalla Timeline.",
        // Un testo che vale per ogni motivo (un guasto da riprovare, lo spazio dell'audio non impostato, una registrazione in corso).
        lead_audio_not_deleted: "Le registrazioni delle chiamate o gli allegati delle note di questo Lead non si sono potuti cancellare, quindi il Lead non è stato eliminato e resta fra gli archiviati.",
        // Il Power Dialer (piano M5, Task 3): testi di ripiego, la barra e la lista dicono il resto.
        dialer_session_active: "Hai già una sessione di chiamate aperta: interrompila prima di iniziarne un'altra.",
        dialer_session_not_found: "Questa sessione di chiamate non c'è più: torna alla lista e premi «Inizia a chiamare».",
        dialer_source_empty: "In questa lista adesso non c'è nessun Lead da chiamare.",
        dialer_outcome_missing: "Prima scegli l'esito della chiamata e fai i passi obbligatori, poi «Lead successivo».",
        dialer_call_in_progress: "La chiamata è ancora in corso: chiudila prima di passare al Lead successivo.",
        lead_reserved: "Lo sta lavorando un collega nel Power Dialer adesso: lo chiami quando lo lascia.",
        dialer_queue_busy: "I Lead da chiamare li sta cambiando qualcuno proprio adesso: riprova fra un attimo.",
        dialer_already_called: "Questo Lead l'hai già chiamato in questa sessione: non si salta, passa oltre con «Lead successivo».",
        dialer_session_paused: "In pausa: premi Riprendi per continuare",
        // La sequenza di chiamate (piano M5, Task 10a).
        sequence_not_open: "La sequenza di chiamate di questo Lead è già finita.",
        sequence_cannot_restart: "La sequenza riparte soltanto dopo una risposta del Lead, dopo averla fermata a mano o dopo un numero errato.",
        // Il parco dei cellulari dell'ufficio (piano M4, Task 16): «Non hai un numero per chiamare» è il motivo del mock-up.
        caller_number_missing: "Non hai un numero per chiamare: chiedi a chi gestisce i numeri di darti un cellulare, in Impostazioni → Team.",
        caller_number_taken: "Questa persona ha già un numero per chiamare: ognuno ne ha uno solo. Toglile prima quello che ha.",
        caller_number_not_verified: "Questo cellulare non è ancora verificato: si assegna quando il fornitore conferma la verifica.",
        caller_number_not_mobile: "Si aggiungono soltanto cellulari italiani: un fisso o un numero straniero non va bene.",
        caller_number_exists: "Questo numero è già nel parco dei cellulari.",
        caller_number_already_verified: "Questo cellulare è già verificato presso il fornitore: premi «Leggi i cellulari già verificati».",
        // I Task e i richiami (piano M5, Task 16): testi di ripiego, la finestra «Richiama dopo» dice il motivo dell'orario.
        task_not_found: "Questo Task non c'è più, oppure non è fra quelli che vedi.",
        task_exists: "Questo Lead ha già un richiamo aperto: spostalo invece di fissarne un altro.",
        callback_slot_invalid: "Questo orario non va bene per un richiamo: si richiama dal lunedì al venerdì dalle 08:30 alle 20:00, a quarti d'ora e dopo adesso.",
        appointment_exists: "Esiste già un appuntamento aperto di questo tipo.",
        appointment_slot_invalid: "Scegli un orario futuro nel calendario lavorativo dell’azienda.",
        appointment_result_too_early: "Puoi registrare l’esito soltanto dall’ora dell’appuntamento.",
        // Le Opportunità (piano M6, R8, Task 24): testi di ripiego, la scheda e la pagina dicono di più.
        opportunity_not_found: "Questa opportunità non c'è più, oppure non è fra quelle che vedi.",
        opportunity_exists: "Questo Lead ha già un'opportunità aperta: chiudi quella prima di riaprirne un'altra.",
        manual_call_invalid: "Quest'ora non va bene per la telefonata: scegli un momento già passato, da quando c'è il Lead.",
        // I WhatsApp (piano M6, R1, Task 3): testi di ripiego, la finestra e le Impostazioni dicono di più (il motivo, il nome di chi ha
        // già il numero).
        whatsapp_blocked: "A questo Lead non si mandano WhatsApp adesso: lo status lo blocca, manca un cellulare o è acceso «Non inviare WhatsApp».",
        whatsapp_number_taken: "Questo numero è già di un collega: ogni persona ha il suo.",
        whatsapp_channel_not_enabled: "L'azienda non può ancora usare questo WhatsApp: per ora imposta «A mano».",
        // Il WhatsApp ufficiale di Meta (piano M6, R2): testi di ripiego, la finestra «Imposta», i modelli e la finestra del WhatsApp
        // dicono di più (il passo che si è fermato, il numero, il tetto).
        whatsapp_meta_not_configured: "Il WhatsApp ufficiale non è ancora collegato a Gioia365: per ora i WhatsApp si mandano a mano.",
        whatsapp_meta_window_required: "Per registrare questo numero serve la finestra di Meta: premi «Registra su Meta e salva» e completa i passi.",
        whatsapp_signup_failed: "La registrazione su Meta si è fermata a metà: premi «Riprova», riprende da dove si è fermata.",
        whatsapp_signup_busy: "C'è già una registrazione su Meta in corso per l'azienda: aspetta che finisca e riprova.",
        whatsapp_number_mismatch: "Il numero scelto nella finestra di Meta non è quello scritto qui: controlla il numero e riprova.",
        whatsapp_waba_mismatch: "Nella finestra di Meta è stato scelto un account WhatsApp Business diverso da quello dell'azienda, che è già in uso (un numero registrato o un modello mandato a Meta): scegli quello dell'azienda e riprova.",
        whatsapp_number_cap_reached: "Il Business Manager ha già tutti i numeri che può registrare: per aggiungerne altri serve una richiesta a Meta.",
        // Su un errore di Meta il modello resta com'era presso Meta (Task 8a): un modello approvato resta approvato.
        whatsapp_template_not_submitted: "Meta non ha accettato il modello: riprova fra poco. Il suo stato su Meta non è cambiato.",
        whatsapp_template_variable_at_edge: "Meta non accetta un modello che comincia o finisce con una variabile: aggiungi una parola o un punto.",
        whatsapp_recipient_not_allowed: "Numero non ammesso nell'azienda di prova: il WhatsApp automatico non parte, puoi mandarlo a mano.",
        whatsapp_waba_taken: "Questo account WhatsApp Business è già collegato a un'altra azienda di Gioia365: nella finestra di Meta scegli quello di questa azienda.",
        whatsapp_waba_not_accessible: "Meta dice che l'accesso dato nella finestra non comprende questo account WhatsApp Business: riapri la finestra di Meta e scegli l'account dell'azienda.",
        // WhatsApp Agile (piano M6, R9): il tetto del giorno che ferma davvero (WA-10) e il salvataggio del codice di una persona.
        whatsapp_daily_cap: "Questo Lead ha già ricevuto oggi i suoi 2 WhatsApp: con WhatsApp Agile il terzo non parte. Se serve, mandalo a mano.",
        whatsapp_agile_code_not_recognised: "WhatsApp Agile non riconosce questo codice per questo numero: controlla il codice e il numero, con il prefisso.",
        whatsapp_agile_not_paired: "Il codice è giusto ma il telefono non risulta collegato: inquadra il codice QR con il telefono di lavoro e salva di nuovo.",
        whatsapp_agile_unreachable: "WhatsApp Agile non risponde in questo momento: niente è stato salvato, riprova fra qualche minuto.",
        intake_test_unavailable: "«Fai entrare un Lead di prova» c'è soltanto nelle aziende di prova.",
        meta_unavailable: "Il collegamento con Meta non è attivo su questo server.",
        meta_login_failed: "Facebook non ha accettato l'accesso: riprova con «Collega la pagina Facebook».",
        meta_unreachable: "Meta non risponde in questo momento: riprova fra qualche minuto.",
        meta_page_not_found: "Questa pagina non è fra quelle che amministri su Facebook: riprova e scegline una tua.",
        meta_page_forms_unreadable: "Meta non lascia leggere i moduli di questa pagina: serve un account amministratore della pagina con un ruolo sull'app di Meta e, se la pagina usa il «Leads Access Manager», l'accesso ai Lead.",
        meta_page_in_use: "Questa pagina è già collegata a un'altra azienda di Gioia365: una pagina fa entrare i Lead in un'azienda sola.",
        // Il Report (piano M7, Task 2): un «Personalizzato» dopo oggi o più lungo di 366 giorni.
        report_period_invalid: "Il periodo arriva dopo oggi o è più lungo di un anno.",
        close_key_rejected: "Close non riconosce questa chiave: controlla di averla copiata intera.",
        close_key_forbidden: "Questa chiave non può leggere l'organizzazione di Close: creane una che la legga.",
        close_unreachable: "Close non risponde: riprova fra qualche minuto.",
        close_key_missing: "Prima salva la chiave API di Close.",
        close_key_unreadable: "La chiave salvata non si legge più: salvala di nuovo.",
        close_dry_run_required: "Prima fai una prova senza salvare con la chiave di adesso e aspetta che finisca.",
        close_import_busy: "C'è già un'importazione da Close in corso per questa azienda: aspetta che finisca.",
        close_import_not_started: "L'importazione da Close non è partita: riprova fra qualche minuto; se succede ancora, lo controlla il team di Gioia365.",
        ghl_key_rejected: "GoHighLevel non accetta questo token: controlla di averlo copiato intero e che abbia gli ambiti di sola lettura (contacts.readonly, conversations.readonly, conversations/message.readonly, locations.readonly).",
        ghl_key_forbidden: "Questo token non può leggere la posizione: controlla il Location ID e che il token sia di questo sotto-account, con gli ambiti di sola lettura (contacts.readonly, conversations.readonly, conversations/message.readonly, locations.readonly).",
        ghl_location_not_found: "GoHighLevel non trova una posizione con questo Location ID: copialo di nuovo dalle impostazioni del sotto-account.",
        ghl_rate_limited: "GoHighLevel ha ricevuto troppe richieste: riprova fra un minuto.",
        ghl_unreachable: "GoHighLevel non risponde: riprova fra qualche minuto.",
        ghl_key_missing: "Prima salva la chiave di GoHighLevel.",
        ghl_key_unreadable: "La chiave di GoHighLevel salvata non si legge più: salvala di nuovo.",
        ghl_import_busy: "Una prova o un'importazione da GoHighLevel è già in corso.",
        ghl_dry_run_required: "Prima fai «Prova senza salvare» con la chiave di adesso.",
        ghl_tags_unconfirmed: "Prima conferma i tag dell'ultima prova.",
        ghl_owner_missing: "La persona che riceve i Lead nuovi non è nel Team come User attivo.",
        ghl_tags_stale: "Questi tag sono di una prova che non è più l'ultima: guarda quella nuova.",
        ghl_close_import_running: "Sta girando l'importazione da Close (o sono fra le 21:00 e le 22:05): riprova quando è finita.",
        ghl_dry_run_incomplete: "L'ultima prova non ha letto tutto quello che GoHighLevel ha: rifalla prima di importare.",
        close_ghl_import_running: "Sta girando l'importazione da GoHighLevel: quella da Close parte quando ha finito.",
        ghl_write_dry_run_required: "Prima fai «Prova senza scrivere» con la chiave di adesso.",
        ghl_write_forbidden: "GoHighLevel non lascia scrivere con questo token: crea un token nuovo con anche gli ambiti contacts.write e locations/customFields.write e salvalo qui sopra.",
        network: "Non riesco a collegarmi a Gioia365. Controlla la connessione e riprova.",
        unexpected_response: "La risposta di Gioia365 non è quella giusta. Riprova tra poco.",
        unexpected: "Qualcosa non ha funzionato. Riprova tra poco.",
    },
    // Elenco Lead (piano M2 Task 17, mock-up `lead.html`): ricerca in tutti i campi, «Di chi», ordinamento dalle
    // intestazioni, righe virtuali. «Prossima task» resta «—» finché i Task non arrivano (M5).
    leadList: {
        intro: "Cerca e apri una scheda. Clicca un'intestazione per ordinare.",
        searchLabel: "Cerca in tutti i campi",
        searchPlaceholder: "Cerca: nome, azienda target, telefono, email, città…",
        whoLabel: "Di chi sono i Lead",
        whoMine: "I miei",
        whoAll: "Tutti",
        countOne: "1 Lead",
        countMany: "{count} Lead",
        newLead: "Nuovo Lead",
        captionAll: "Tutti i Lead di {organization}",
        captionMine: "I tuoi Lead",
        // Quando una ricerca o dei filtri restringono l'elenco la didascalia non dice «Tutti» (decisione P25, proposta).
        captionFound: "I Lead trovati in {organization}",
        captionMineFound: "I tuoi Lead trovati",
        captionFiltered: "I Lead filtrati di {organization}",
        captionMineFiltered: "I tuoi Lead filtrati",
        captionSorted: "{scope} · ordinati per {column}, {direction}",
        columns: {
            // «Lead» (nome e cognome insieme, il salone sotto) non è più una colonna (decisione del 6 ottobre 2026): il nome resta per
            // l'ordinamento di prima, che una Smart List salvata o un indirizzo possono ancora avere.
            lead: "Lead",
            // Le prime colonne della vista iniziale (decisione del 6 ottobre 2026): «Questi sono i 4 dati fondamentali», con il salone
            // dopo l'Email (questione aperta 455). Le parole sono quelle della scheda.
            lastName: "Cognome",
            firstName: "Nome",
            salonName: "Nome Azienda Target",
            city: "Città",
            status: "Status",
            latestCall: "Ultima chiamata",
            nextTask: "Prossimo richiamo",
            calls: "Chiamate",
            // «Chiamate» conta tutta la storia (anche le chiamate di Close); il nome intero lo dice nel suggerimento.
            callsFull: "Chiamate di tutta la storia",
            // Le chiamate delle finestre che scorrono (decisione del 1° ottobre 2026): l'intestazione breve, il nome intero
            // nel suggerimento e nella didascalia dell'ordinamento.
            calls12Months: "Chiamate 12 mesi",
            calls12MonthsFull: "Chiamate negli ultimi 12 mesi",
            calls4Months: "Chiamate 4 mesi",
            calls4MonthsFull: "Chiamate negli ultimi 4 mesi",
            tags: "Tag",
            createdAt: "Data di creazione",
            owner: "Owner",
            // Le colonne del mock-up (piano M3 Task 6, `COLUMNS`); dal 6 ottobre 2026 Cellulare ed Email si vedono di partenza, le
            // altre si accendono da «Colonne e vista».
            mobile: "Cellulare",
            landline: "Telefono fisso",
            email: "Email",
            province: "Provincia",
            region: "Regione",
            country: "Nazione",
            latestCallOutcome: "Esito dell'ultima chiamata",
            // Le due colonne che costano una lettura in più e arrivano soltanto quando si vedono (LEAD-13).
            source: "Provenienza",
            smartLists: "In Smart List",
        },
        sortWords: {
            textAsc: "dalla A alla Z",
            textDesc: "dalla Z alla A",
            numberAsc: "dal più basso",
            numberDesc: "dal più alto",
            dateAsc: "dal meno recente",
            dateDesc: "dal più recente",
            orderAsc: "nell'ordine degli status",
            orderDesc: "in ordine inverso",
        },
        province: "{name} ({abbreviation})",
        neverCalled: "Mai chiamato",
        inbound: "in entrata",
        // «Prossima task» (piano M5, Task 20; decisione del 25 settembre 2026): sotto la data, il perché del richiamo aperto.
        nextTask: { agreed: "richiamo concordato", callback: "richiamo" },
        // «Provenienza» (LEAD-13, INGR-5): la prima attribuzione, la sorgente con la campagna se c'è; sotto, l'ultimo ingresso se è un
        // altro. Una sorgente che questa versione non conosce è «Altro ingresso».
        source: {
            meta: "Moduli di Meta",
            web: "Sito",
            ghl: "GoHighLevel",
            file: "Da file",
            manual: "A mano",
            close: "Close",
            other: "Altro ingresso",
            withCampaign: "{source} · {campaign}",
            latest: "ultima: {source}",
        },
        // «In Smart List»: le prime tre liste e quante altre; chi usa uno screen reader sente anche i loro nomi.
        smartListsMore: "+{count}",
        smartListsMoreLabel: "e altre {count}: {names}",
        noOwner: "Senza owner",
        ownerInactive: "non più attivo, da riassegnare",
        loadingRow: "Riga in caricamento",
        pagesFailed: "Alcune righe non si sono caricate.",
        emptyTitle: "Ancora nessun Lead",
        emptyAll: "In {organization} non ci sono ancora Lead.",
        emptyMineTitle: "Non hai ancora Lead tuoi",
        emptyMineChoose: "Scegli «Tutti» per vedere anche quelli dei colleghi.",
        emptyMineWait: "Quando te ne affideranno uno, lo troverai qui.",
        noResultsTitle: "Nessun Lead per «{q}»",
        noResultsText: "Controlla come l'hai scritto, oppure cerca una parte del nome, dell'azienda target o del telefono.",
        noResultsMine: "Stai guardando soltanto i tuoi: scegli «Tutti» per cercare anche fra quelli dei colleghi.",
        resetSearch: "Azzera la ricerca",
    },
    // Il pulsante «Filtri» dell'elenco Lead (piano M3 Task 4, mock-up `setupFilterBar`, `FIELDS` e `OPERATORS`): il
    // pannello a destra con i filtri per gruppi, fuori soltanto quelli attivi. Le parole sono quelle del mock-up, già
    // riviste dal product owner; «tutti» o «tutte» seguono il nome del campo.
    leadFilters: {
        button: "Filtri",
        activeOne: "1 filtro attivo",
        activeMany: "{count} filtri attivi",
        allTogether: "{active}: valgono tutti insieme",
        none: "Nessun filtro: vedi tutti i Lead",
        reset: "Azzera i filtri",
        done: "Fatto",
        find: "Cerca un filtro",
        noFieldMatches: "Nessun filtro per «{q}».",
        searchIn: "Cerca in {field}",
        search: "Cerca",
        removeThis: "Togli questo filtro",
        remove: "Togli il filtro {field}",
        chipField: "{field}:",
        all: "tutti",
        allFeminine: "tutte",
        groups: {
            owner: "Owner",
            status: "Status",
            calls: "Chiamate e task",
            territory: "Territorio",
            salon: "Azienda Target",
            opportunities: "Disco, demo e opportunità",
            created: "Provenienza",
        },
        fields: {
            owner: "Owner",
            status: "Status",
            tags: "Tag",
            nextTaskAt: "Prossimo richiamo",
            sequence: "Sequenza di chiamate",
            latestCallAt: "Ultima chiamata",
            latestCallOutcome: "Esito dell'ultima chiamata",
            outgoingCallCount: "Numero di chiamate",
            outgoingCallCountLast12Months: "Chiamate negli ultimi 12 mesi",
            outgoingCallCountLast4Months: "Chiamate negli ultimi 4 mesi",
            country: "Nazione",
            region: "Regione",
            province: "Provincia",
            city: "Città",
            opportunity: "Opportunità",
            createdAt: "Data di creazione",
            emailClicked: "Ha cliccato un'email",
        },
        ops: {
            in: "è",
            not_in: "non è",
            any: "ha uno di questi",
            all: "li ha tutti",
            none: "non ha",
            gte: "almeno",
            lte: "al massimo",
            eq: "esattamente",
            today: "oggi",
            yesterday: "ieri",
            last7: "ultimi 7 giorni",
            last30: "ultimi 30 giorni",
            older7: "più di 7 giorni fa",
            older30: "più di 30 giorni fa",
            older90: "più di 3 mesi fa",
            older180: "più di 6 mesi fa",
            older365: "più di 12 mesi fa",
            on: "il giorno…",
            before: "prima del…",
            after: "dopo il…",
        },
        // Per «Ultima chiamata» i periodi «più di … fa» comprendono anche chi non è mai stato chiamato (piano M3, D2).
        orNeverCalled: "{op} o mai chiamato",
        how: "{field}: come",
        number: "{field}: numero",
        numberInvalid: "Scrivi un numero intero, da 0 in su.",
        day: "Giorno",
        chosen: "{count} scelti",
        chosenOne: "1 scelto",
        noOwner: "Senza owner",
        outcomeNone: "Mai chiamato",
        // Gli operatori di «Prossima task» (piano M5, Task 20; mock-up `OPERATORS.task`), alla lettera.
        nextTask: { overdue: "scaduto", today: "oggi", tomorrow: "domani", by: "entro il giorno…", none: "nessuno" },
        // «Ha cliccato un'email» (ingresso dei Lead, I5, D5): «negli ultimi N giorni» (7 di partenza) e «mai»; soltanto i clic.
        emailClicked: {
            within: "negli ultimi … giorni",
            withinDays: "negli ultimi {days} giorni",
            never: "mai",
            days: "{field}: quanti giorni",
            daysInvalid: "Scrivi un numero di giorni da 1 a 365.",
            hint: "Contano soltanto i clic: un'apertura può essere l'anteprima automatica di un programma di posta.",
        },
        // Le voci di «Sequenza di chiamate» (piano M5, Task 14; sequenza, novità 16), alla lettera dal mock-up.
        sequence: {
            due_today: "Da chiamare oggi",
            new_never_called: "Lead nuovo, mai chiamato",
            in_progress_later: "In corso, più avanti",
            ended: "Finita o ferma",
        },
        // Le voci di «Opportunità» (piano M6, R8, Task 24; questione 141), alla lettera dal mock-up (`OPPORTUNITY_OPTIONS`).
        opportunity: {
            none: "Nessuna",
            disco_booked: "Disco prenotata",
            disco_held: "Disco effettuata",
            demo_booked: "Demo prenotata",
            demo_held: "Demo effettuata",
            sold: "Venduto",
            lost: "Persa",
        },
        // I numeri accanto alle voci contano tutti i Lead che chi guarda vede (piano M3, D4), non soltanto quelli
        // dell'elenco di adesso: la riga lo dice quando l'elenco è ristretto da altro.
        perimeter: "Conteggi su tutti i Lead che vedi",
        typeTwo: "Scrivi almeno due lettere per cercare.",
        noOptions: "Nessuna voce da scegliere.",
        noMatches: "Nessuna voce per «{q}».",
        truncated: "Ci sono altre voci: scrivi di più per trovarle.",
        optionsFailed: "Le voci di questo filtro non si sono caricate.",
        emptyTitle: "Nessun Lead corrisponde a questa ricerca o a questi filtri.",
        emptyHint: "Prova a togliere un filtro.",
        emptyHintMine: "Prova a togliere un filtro, o scegli «Tutti» per cercare anche fra quelli dei colleghi.",
        resetAll: "Azzera ricerca e filtri",
        countryNames: {
            IT: "Italia",
            CH: "Svizzera",
        },
    },
    // «Colonne e vista» dell'elenco Lead e delle Smart List (piano M3 Task 6, D5 e D14; mock-up `setupTableView` e
    // `VIEW_LEVELS`): le parole dei mock-up, già riviste dal product owner, con il nome dell'azienda al posto di «Academy»
    // e senza articolo. La vista in uso: la disposizione non salvata del dispositivo, la vista personale, quella
    // dell'azienda o quella iniziale del prodotto.
    tableView: {
        button: "Colonne e vista",
        title: "Colonne e vista",
        intro: "Le colonne non cambiano i filtri. Larghezza: trascina il bordo destro dell'intestazione.",
        find: "Cerca una colonna",
        noMatches: "Nessuna colonna per «{q}».",
        companyFieldsFull: "Al massimo {max} campi dell'azienda nella tabella: togline uno per mostrare questo.",
        show: "Mostra",
        moveUp: "Sposta su",
        moveDown: "Sposta giù",
        moveLeft: "Sposta a sinistra",
        moveRight: "Sposta a destra",
        hide: "Nascondi",
        width: "Larghezza",
        shown: "Nella tabella",
        others: "Altre colonne",
        leadFixed: "sempre prima, ferma a sinistra",
        groups: {
            lead: "Lead",
            calls: "Chiamate e task",
            territory: "Territorio",
            contact: "Telefoni ed email",
            salon: "Azienda Target",
        },
        // Il configuratore nomina sempre il contesto (UX_SYSTEM, «Contesti, standard e personalizzazione»).
        contextLabel: "Vale per:",
        contextLeads: "elenco Lead",
        contextList: "la Smart List «{name}»",
        sourceProduct: "la vista iniziale",
        sourcePersonal: "la tua vista salvata",
        sourceCompany: "la vista di {organization}",
        sourceDevice: "la tua disposizione, non ancora salvata",
        using: "Stai usando {source}.",
        // L'ordinamento dell'elenco Lead fa parte della vista (LEAD-17): uno scelto dall'intestazione e non ancora salvato.
        sortUnsaved: "Ordinamento da salvare: {column}, {direction}.",
        savedHint: "Colonne e ordine restano come li lasci, anche se esci.",
        unsavedHint: "Resta così anche se esci. Salvala per ritrovarla su ogni dispositivo.",
        // Le letture che la vista aspetta: finché non arrivano non si salva (stati di UX_SYSTEM).
        layoutFailed: "La vista salvata non si è caricata.",
        catalogFailed: "I campi dell'azienda non si sono caricati. Riprova prima di salvare la vista.",
        useMine: "Usa la tua vista salvata",
        useProduct: "Torna alla vista iniziale",
        useCompany: "Usa la vista di {organization}",
        saveMine: "Salva per me",
        savedMine: "Vista salvata soltanto per te: la ritrovi su ogni computer e telefono.",
        saveCompany: "Salva per tutta {organization}",
        confirmCompany: "Conferma: vale per tutti in {organization}",
        warnCompany: "Tutti gli utenti di {organization} vedranno questa disposizione; le viste personali già salvate si azzerano. Ognuno potrà poi sistemarla di nuovo per sé.",
        savedCompany: "Vista salvata per tutta {organization}.",
        reasonCompany: "Solo chi ha «Vista dell'azienda» in «Ruoli e permessi» salva la vista per tutta l'azienda.",
        // Il `409` della pubblicazione: la vista dell'azienda è cambiata intanto ed è stata riletta.
        conflictCompany: "Qualcuno ha appena salvato un'altra vista per tutta {organization}. È stata riletta: conferma di nuovo per sostituirla con la tua.",
        commercialViewWarning: "Stai pubblicando per tutti gli utenti, non soltanto per {name}.",
        close: "Chiudi",
        menu: "Altro su questa colonna",
        sortAsc: "Ordina {direction}",
        resizeHandle: "Ridimensiona {column}",
    },
    // Le Smart List dall'elenco Lead e nel menu (piano M3 Task 8, D7 e D14; mock-up `lead.html`, `setupNewListDialog`,
    // `LIST_GROUPS` e la rail di `renderShell`): le parole dei mock-up, già riviste dal product owner. «Chi la vede» con la
    // spiegazione sotto ogni scelta; «A mano» e «Importa da file» arrivano con le liste manuali e M6 (questione 140).
    smartLists: {
        create: "Crea Smart List da questi filtri",
        createReason: "Aggiungi almeno un filtro per creare una Smart List.",
        dialogTitle: "Crea Smart List",
        name: "Nome della lista",
        nameRequired: "Scrivi il nome della lista.",
        nameTaken: "Hai già una lista con questo nome.",
        nameTakenFor: "{name} ha già una lista con questo nome.",
        whoSees: "Chi la vede",
        visibility: {
            private: "Privata",
            shared: "Condivisa con colleghi scelti",
            public_team: "Pubblica al team",
        },
        visibilityHint: {
            private: "tu, i Super user, gli Admin e il Super admin",
            shared: "con colleghi scelti",
            public_team: "tutti gli utenti attivi dell'azienda",
        },
        shareWith: "Condividi con",
        recipientsRequired: "Scegli almeno un collega con cui condividerla.",
        noColleagues: "Nel team non c'è un altro User attivo con cui condividerla.",
        // «Di chi sono…» faceva pensare a un cambio di owner (riscontro del product owner del 2 ottobre 2026).
        whoseLeads: "Quali Lead entrano nella lista",
        noOwnerChange: "Nessun Lead cambia owner: la lista sceglie soltanto quali Lead mostrare.",
        theseFilters: "I Lead di questi filtri",
        // Il Super admin di Gioia365 non ha un'appartenenza nell'azienda: una lista sua non può esistere (decisione P40).
        theseFiltersPlatform: "Come Super admin di Gioia365 non hai liste tue in questa azienda: crea la lista per un Commerciale, oppure entra come titolare.",
        todayCount: ": oggi {count} Lead.",
        todayCountOne: ": oggi 1 Lead.",
        forPerson: "I Lead di un Commerciale, per lui:",
        personSelect: "Il Commerciale della lista",
        noCommercials: "Come Super admin di Gioia365 crei una lista per un Commerciale, e nel team non c'è nessuno User attivo.",
        scopeNoteOwner: "Ogni Commerciale ci vede e chiama soltanto i Lead di cui è owner: lo dice Impostazioni → «Chi vede i Lead».",
        scopeNoteAll: "Chi usa la lista ci vede e chiama tutti i Lead dei filtri, anche quelli dei colleghi: lo dice Impostazioni → «Chi vede i Lead».",
        saveNote: "Si salvano i filtri, non la ricerca libera: la lista si aggiorna da sola quando cambiano i dati.",
        mineNotSaved: "«I miei» non si salva nella lista: dentro ci sono tutti i Lead di questi filtri che puoi vedere.",
        cancel: "Annulla",
        createAndOpen: "Crea e apri",
        // «Salva come nuova» dalla pagina di una lista (mock-up `smart-list.html`, `#m-new-list`).
        saveAsTitle: "Salva come nuova",
        saveAsName: "Nome della nuova lista",
        saveAsNote: "La lista originale non cambia. La nuova è tua e si apre subito.",
        saveAsSubmit: "Salva e apri",
        groups: {
            pinned: "Fissate",
            mine: "Tue",
            shared_with_me: "Condivise con te",
            team: "Del team",
            colleagues: "Dei colleghi",
        },
        railLabel: "Le Smart List che vedi",
        // Le fissate e l'ordine del menu (SL-11, richiesta del product owner del 23 ottobre 2026): valgono soltanto per chi li sceglie.
        pin: "Fissa in alto",
        unpin: "Togli dalle fissate",
        moveUp: "Sposta su",
        moveDown: "Sposta giù",
        pinList: "Fissa in alto «{name}»",
        unpinList: "Togli dalle fissate «{name}»",
        moveUpList: "Sposta su «{name}»",
        moveDownList: "Sposta giù «{name}»",
        orderFailed: "L'ordine delle liste non si è salvato: è tornato com'era. Riprova.",
        findList: "Cerca una lista",
        truncated: "Qui ci sono le prime {count} liste che vedi: «Cerca una lista» cerca soltanto fra queste.",
        noLists: "Ancora nessuna Smart List: nasce dall'elenco Lead, con «Filtri» e poi «Crea Smart List da questi filtri».",
        goToLeads: "Vai all'elenco Lead",
        countOne: "1 Lead",
        countMany: "{count} Lead",
        countMissing: "—",
        countUnavailable: "Il conteggio di questa lista non è disponibile adesso.",
        // Le «novità» di una lista nel menu (riscontro del product owner del 3 ottobre 2026, questione aperta 182).
        newOne: "1 nuovo",
        newMany: "{count} nuovi",
        railNews: "Ci sono Lead nuovi nelle Smart List",
        // La pagina della lista (piano M3 Task 9, mock-up `smart-list.html` e `initSmartList`): le parole sono quelle del
        // mock-up; dove il mock-up non ne ha (avviso del 409, owner di stato sconosciuto, versione già uguale) sono proposte.
        page: {
            dynamic: "Con i filtri: si aggiorna da sola",
            owner: "Owner: {name}",
            ownerWithStatus: "Owner: {name} ({status})",
            personWithStatus: "{name} ({status})",
            personStatus: {
                suspended: "sospeso",
                archived: "archiviato",
                inactive: "non più attivo",
            },
            savedAtBy: "Salvata il {when} da {who}",
            saved: "Salvata",
            dirty: "Modifiche non salvate",
            staleOne: "Un filtro di questa lista usava un campo che non c'è più: non vale più e si toglie al prossimo «Salva».",
            staleMany: "{count} filtri di questa lista usavano campi che non ci sono più: non valgono più e si tolgono al prossimo «Salva».",
            share: "Condividi",
            more: "Gestisci lista",
            moreLabel: "Gestisci la lista",
            rename: "Rinomina",
            renameHint: "Il nome cambia anche per chi la usa",
            history: "Storico della lista",
            historyHintOne: "1 versione: chi l'ha cambiata e quando",
            historyHint: "{count} versioni: chi l'ha cambiata e quando",
            delete: "Elimina la lista",
            deleteHint: "Ai Lead non succede niente",
            // Chi può fare ciò che manca, con i ruoli di partenza: il Super user rinomina ogni lista ma elimina soltanto le sue
            // (la nota del mock-up diceva che il Super user elimina tutte le liste: questione aperta 158).
            moreNote: "Rinominarla possono soltanto {owner}, i Super user, gli Admin e il Super admin; eliminarla soltanto {owner}, gli Admin e il Super admin.",
            moreNoteDelete: "Eliminarla possono soltanto {owner}, gli Admin e il Super admin.",
            moreNoteRename: "Rinominarla possono soltanto {owner}, i Super user, gli Admin e il Super admin.",
            discard: "Annulla modifiche",
            save: "Salva",
            saveAs: "Salva come nuova",
            copyName: "{name} (copia)",
            readOnly: "Sola lettura: la cambia soltanto l'owner ({owner}) o un Super user, un Admin o il Super admin. Per tenere le tue modifiche usa «Salva come nuova».",
            start: "Inizia a chiamare",
            // Il Power Dialer dalla lista (piano M5, Task 6; mock-up `initSmartList`): da chi si parte, perché il pulsante è spento,
            // la sessione interrotta da riprendere e la sessione viva su un'altra sorgente. `savedLineOne` è il singolare del mock-up.
            startFrom: "Si parte da {lead}: {count} Lead da chiamare.",
            startDirty: "Salva le modifiche con «Salva» o «Salva come nuova» per avviare le chiamate",
            startEmpty: "Nessun Lead da chiamare adesso in questa lista.",
            startNoCall: "Serve «Chiamare e usare la postazione» in «Ruoli e permessi».",
            resume: "Riprendi a chiamare",
            restart: "Ricomincia da capo",
            savedLine: "Sessione interrotta il {when}, con {done} Lead fatti: si riprende da {next}. «Ricomincia da capo» riparte dal primo.",
            savedLineOne: "Sessione interrotta il {when}, con 1 Lead fatto: si riprende da {next}. «Ricomincia da capo» riparte dal primo.",
            savedLineNone: "Sessione interrotta il {when}, prima di finire il primo Lead: si riprende da {next}.",
            workedCalled: "Chiamato nella sessione da riprendere",
            workedSkipped: "Saltato nella sessione da riprendere",
            otherSession: "Hai una cascata in corso su «{source}»: la interrompi per chiamare da qui?",
            interruptOther: "Interrompi e chiama da qui",
            search: "Cerca nei risultati",
            searchNote: "La ricerca mostra {shown} di {total} Lead e non cambia la lista.",
            queue: "Si chiama in quest'ordine, dal numero 1: {sort}. Per cambiarlo clicca un'intestazione, poi «Salva».",
            sortText: "{column}, {direction}",
            caption: "Lead della lista nell'ordine di chiamata: {sort}",
            position: "Posto {position} nell'ordine di chiamata",
            positionPrefix: "Posto",
            empty: "Nessun Lead corrisponde alle condizioni della lista.",
            emptyHint: "Quando i dati cambiano, la lista si aggiorna da sola.",
            noSearchResults: "La ricerca non trova Lead in questa lista.",
            clearSearch: "Cancella la ricerca",
            savedVersion: "Salvata: versione {revision}.",
            conflict: "Nel frattempo qualcun altro ha salvato questa lista: l'ho ricaricata e le tue modifiche sono ancora qui. Controllale e premi di nuovo «Salva».",
            changedMeanwhile: "Nel frattempo qualcun altro ha cambiato questa lista: l'ho ricaricata. Controlla e riprova.",
            confirmTitle: "Cosa cambia per chi la usa",
            confirmUsers: "La usano anche {people}. Da adesso, per loro:",
            confirmUsersTeam: "tutti in {organization}, perché è pubblica al team",
            confirmUsersShared: "i colleghi con cui è condivisa",
            confirmCount: "Per te i Lead nella lista passano da {before} a {after}.",
            confirmHistory: "La versione di prima resta nello storico.",
            confirmSave: "Salva per tutti",
            leaveTitle: "Non hai salvato le modifiche",
            leaveText: "Hai cambiato i filtri o l'ordine di questa lista. Se esci adesso, le modifiche si perdono e la lista resta com'era.",
            stay: "Resta qui",
            leaveDiscard: "Esci senza salvare",
            saveAndLeave: "Salva ed esci",
            renameTitle: "Rinomina la lista",
            renameName: "Nome",
            renameNote: "Il nome cambia anche nel menu di chi la usa.",
            renamed: "Lista rinominata: «{name}».",
            deleteTitle: "Elimina la lista",
            deleteText: "Elimini «{name}»? Sparisce dal menu di chi la vede; ai Lead non succede niente.",
            deleteConfirm: "Elimina",
            deleted: "Lista «{name}» eliminata. Ai Lead non è successo niente.",
            notFoundTitle: "Smart List non trovata",
            notFoundText: "Questa lista non esiste più oppure non è condivisa con te.",
            openList: "Apri «{name}»",
            historyCaption: "Versioni della lista, dalla più recente",
            historyVersion: "Versione",
            historyWhen: "Quando",
            historyWho: "Chi",
            historyWhat: "Cosa è cambiato",
            historyAction: "Azione",
            inUse: "in uso",
            restore: "Rimetti questa versione",
            historyNote: "Ogni salvataggio è una versione. Rimettere una versione vecchia non cancella quelle dopo.",
            restored: "Versione {revision} rimessa come modifica non salvata: premi «Salva» per tenerla.",
            restoredReadOnly: "Versione {revision} rimessa come modifica: puoi tenerla soltanto con «Salva come nuova».",
            restoredSame: "La versione {revision} ha già gli stessi filtri e lo stesso ordine della lista: non c'è niente da salvare.",
            shareTitle: "Chi vede questa lista",
            shareReadOnly: "La gestisce {owner}: puoi vedere chi la vede, ma cambiarlo possono soltanto l'owner, i Super user, gli Admin e il Super admin.",
            shareHint: {
                private: "La vedono l'owner, i Super user, gli Admin e il Super admin.",
                shared: "In più la vedono i colleghi che spunti qui sotto.",
                public_team: "La vedono tutti in {organization}, nel menu a sinistra. Fuori da Gioia365 non la vede nessuno.",
            },
            shareOwner: "Owner della lista",
            shareOwnerNote: "Puoi dare la lista a un collega: sarà sua e la gestirà lui. Nello storico resta che l'hai fatto tu.",
            shareOwnerInactive: "{owner} è {status}: la lista resta e chi la usa continua a chiamare. Se serve, scegli qui sotto un nuovo owner.",
            shareNote: "Chi la vede può aprirla, chiamare con «Inizia a chiamare» e salvarne una copia con «Salva come nuova». Cambiarla possono soltanto l'owner, i Super user, gli Admin e il Super admin. Condividere una lista non fa vedere Lead in più: ognuno vede soltanto i Lead che può già vedere.",
            shareSave: "Salva chi la vede",
            shareOwnerOnly: "{owner} diventa l'owner: scegli almeno un altro collega con cui condividerla, oppure un'altra visibilità.",
            shared: "{changes} Resta nello storico della lista.",
            recipientSuspended: "{name} (sospeso)",
            recipientInactive: "{name} (non è più fra gli User attivi)",
            changes: {
                filterAdded: "Aggiunto il filtro {field}: {value}.",
                filterChanged: "{field}: da «{before}» a «{after}».",
                filterRemoved: "Tolto il filtro {field} (era «{value}»).",
                structure: "Cambiato come si combinano i filtri.",
                sort: "Ordine di chiamata: da «{before}» a «{after}».",
                name: "Rinominata da «{before}» a «{after}».",
                visibility: "Chi la vede: {after}.",
                recipients: "Condivisa con: {names}.",
                owner: "Owner: da {before} a {after}.",
                created: "Creata.",
            },
        },
    },
    // «Nuovo Lead» (piano M2 Task 17, mock-up `lead.html`): il telefono è il solo dato obbligatorio (decisione del 28
    // settembre 2026); dopo «Crea Lead» si apre la scheda del Lead nuovo.
    newLead: {
        title: "Nuovo Lead",
        salonName: "Nome Azienda Target",
        mobile: "Cellulare",
        prefix: "Prefisso del cellulare",
        prefixes: {
            it: "+39 IT",
            ch: "+41 CH",
            sm: "+378 SM",
            fr: "+33 FR",
            de: "+49 DE",
            at: "+43 AT",
        },
        mobilePlaceholder: "347 123 4567",
        landline: "Telefono fisso",
        phoneHint: "Il telefono è il solo dato obbligatorio: il cellulare o il fisso.",
        email: "Email",
        owner: "Owner",
        ownerNone: "Senza owner, lo assegni dopo",
        // Con una regola di assegnazione scelta (piano M6, Task 13, questione 366) la scelta vuota non lascia il Lead senza owner.
        ownerRule: "Con la regola di assegnazione",
        ownerSelf: "Il Lead nuovo è tuo.",
        afterCreate: "Entra con lo status di partenza; dopo «Crea Lead» si apre la sua scheda.",
        submit: "Crea Lead",
        phoneRequired: "Scrivi il cellulare o il telefono fisso.",
        phoneInvalid: "Questo numero non va bene: controllalo, per esempio 347 123 4567.",
        looksLandline: "Sembra un numero fisso: scrivilo in «Telefono fisso».",
        looksMobile: "Sembra un cellulare: scrivilo in «Cellulare».",
        phoneRepeated: "È lo stesso numero del cellulare.",
        emailInvalid: "Controlla l'email, per esempio nome@azienda.it.",
        cityInvalid: "Scegli la città dall'elenco mentre scrivi.",
        phoneInUse: "Esiste già un Lead con questo numero: non ne creo un secondo.",
        phoneInUseHidden: "Esiste già un Lead con questo numero, ma non è fra quelli che puoi aprire: chiedi a chi gestisce i Lead.",
        openLead: "Apri il Lead",
        duplicateEmail: "Un altro Lead ha questa email. Potrebbe essere un doppione, ma un Lead si riconosce dal telefono: se è un'altra persona, crealo lo stesso.",
        createAnyway: "Crea lo stesso",
        created: "Lead creato.",
    },
    // Il selettore della città (scheda e «Nuovo Lead»): si scrive soltanto la città, provincia, regione e nazione si
    // compilano da sole (decisione del 25 settembre 2026); al massimo otto comuni, cercati dal server.
    cityPicker: {
        label: "Città",
        placeholder: "Scrivi la città, anche solo una parte",
        hint: "Provincia, regione e nazione si compilano da sole.",
        place: "{province} · {region} · {country}",
        italy: "Italia",
        results: "Comuni trovati",
        searching: "Cerco i comuni…",
        none: "Nessun comune trovato per «{q}».",
    },
    styleguide: {
        title: "Sistema di design",
        tokens: "Token",
        breakpoints: "Punti di rottura",
        components: "Componenti",
        dialogs: "Finestre e pannelli",
        fields: "Campi",
        tables: "Tabelle",
        states: "Stati e note",
        feedback: "Avvisi e barra delle modifiche",
        navigation: "Intestazione e scelte",
        serverStatus: "Stato del server",
        serverUnavailable: "Server non raggiungibile",
        serverVersion: "Versione {version}",
    },
    // Esiti normalizzati delle chiamate (`calls.outcome`), con le parole della postazione. La ricerca dei Lead li
    // confronta in tutte e due le lingue.
    outcomes: {
        answered: "Risposta",
        no_answer: "Nessuna risposta",
        wrong_number: "Numero errato",
    },
    // Il secondo passo dell'esito, dopo «Risposta» (`calls.answered_outcome`, piano M4, D7), con le parole della postazione e
    // del mock-up («Com'è andata?»): anche il filtro e la colonna «Esito dell'ultima chiamata» le usano.
    answeredOutcomes: {
        call_back: "Richiamare",
        not_interested: "Non interessato",
        do_not_call: "Non vuole essere chiamato",
        disco_booked: "Disco prenotata",
        demo_booked: "Demo prenotata",
        other: "Altro (con nota)",
    },
    // La Timeline della scheda Lead (piano M2 Task 19, mock-up `scheda-lead.html`): telefonate con i loro appunti, note,
    // salvataggi (più campi insieme in una riga che si apre) e lo storico di Close, dal più recente. Gli esiti hanno le
    // parole della postazione; «da Close» e «data originale non nota» sono le proposte 16 e 17 dell'importazione da Close.
    timeline: {
        title: "Timeline",
        filtersLabel: "Mostra nella Timeline",
        filters: {
            all: "Tutto",
            calls: "Telefonate",
            notes: "Note",
            changes: "Modifiche",
            history: "Storico di Close",
            email: "Email",
        },
        searchLabel: "Cerca nella Timeline",
        loading: "Carico la Timeline…",
        loadingMore: "Carico gli elementi più vecchi…",
        more: "Mostra gli elementi più vecchi",
        moreFailed: "Gli elementi più vecchi non sono arrivati.",
        empty: "Ancora niente nella Timeline di questo Lead.",
        emptyFilter: "Niente da mostrare con questo filtro.",
        noResults: "Niente nella Timeline per «{q}».",
        resetSearch: "Azzera la ricerca",
        fromClose: "da Close",
        dateUnknown: "data originale non nota",
        unknownAuthor: "autore non noto",
        composer: {
            label: "Nuova nota",
            placeholder: "Scrivi una nota sul Lead…",
            hint: "Le note non si modificano: un'aggiunta diventa una nota nuova.",
            submit: "Salva nota",
            saving: "Salvo la nota…",
            required: "Scrivi qualcosa prima di salvare la nota.",
            saved: "Nota salvata nella Timeline.",
        },
        memo: {
            title: "Appunto",
            add: "Aggiungi appunto",
            label: "Appunto su questa chiamata",
            submit: "Salva appunto",
            saving: "Salvo l'appunto…",
            required: "Scrivi l'appunto prima di salvarlo.",
            saved: "Appunto salvato su questa chiamata. Non si modifica: un'aggiunta diventa un appunto nuovo.",
        },
        call: {
            outbound: "Chiamata in uscita",
            inbound: "Chiamata in entrata",
            unknownOutcome: "Esito non noto",
            failed: "Non riuscita, non conta",
            outcomeWithDetail: "{outcome} ({detail})",
            // La telefonata della telefonia ancora in corso, e l'esito in due passi, «Risposta · Richiamare» (piano M4, Task 12).
            live: "In corso",
            twoSteps: "{outcome} · {answered}",
            duration: "durata {duration}",
            // La telefonata fatta fuori dal CRM e registrata con «Registra attività» (piano M5, Task 19), con i minuti di conversazione.
            manual: "inserita a mano",
            minutes: "{count} min",
            // Il dettaglio di «Nessuna risposta» (le `disposition` di Close), e «segnata da Gioia365» per l'esito che Gioia365 dà da sé (TEL-32).
            details: {
                busy: "occupato",
                vmAnswer: "segreteria",
                vmLeft: "segreteria, messaggio lasciato",
                abandoned: "chiusa prima della risposta",
                blocked: "chiamata bloccata",
                automatic: "segnata da Gioia365",
            },
        },
        // Un WhatsApp (piano M6, R1, Task 4a; D3, questione 402): un elemento per messaggio con lo stato di adesso, invece delle due
        // righe del mock-up; in «quando · chi» il numero e, dichiarato inviato, l'ora della dichiarazione con le parole del mock-up
        // («aperto in WhatsApp Desktop verso …» per quello a mano).
        whatsapp: {
            prepared: "WhatsApp preparato",
            declaredSent: "WhatsApp dichiarato inviato",
            // WhatsApp Agile (R9) arriva con le sue parole.
            other: "WhatsApp",
            // Un messaggio del Lead (piano M6, R3, passo 11a; questione 425): il titolo e «Da leggere» del mock-up (`mockup.js`, `WA_LOG` e
            // `renderWhatsapp`); in «quando · chi» il numero dell'azienda che l'ha ricevuto, con `to`. Ciò che non è un testo non si scarica:
            // la frase dice di aprirlo sul telefono (parole nuove di R3, questione 424), con la didascalia sotto, se c'è.
            received: "Ha scritto il Lead",
            unread: "Da leggere",
            // Chi l'ha letto in Gioia365 e quando (passo 11c, questione 423): «Letto da …» del mock-up (`mockup.js`, `waStateText`), con il
            // nome di adesso della persona e l'ora nel fuso dell'azienda; nella Timeline e nella lista di «Conversazioni → WhatsApp».
            readBy: "Letto da {name} il {when}",
            // Letto dal contesto di Gioia365 («Entra» del gestore della piattaforma), che non è una persona del team (decisione del controller
            // sull'11c; parole nuove, questione 424).
            readByPlatform: "Letto da Gioia365 il {when}",
            // Segna letto un messaggio del Lead senza rispondere, nella Timeline e nella riga di «Conversazioni → WhatsApp» senza «Rispondi»
            // (passo 12b, questione 423; parole nuove, questione 424): il mock-up lo fa soltanto con «Rispondi» e «Segna tutti come letti».
            markRead: "Segna come letto",
            // Chi ha scritto un messaggio che Gioia365 manda da sé, la conferma dello «STOP» (passo 11b, questione 420), in «quando · chi».
            automaticAuthor: "Gioia365 (automatico)",
            inboundKinds: {
                image: "Il Lead ha mandato un'immagine: aprila sul telefono",
                audio: "Il Lead ha mandato un audio: ascoltalo sul telefono",
                video: "Il Lead ha mandato un video: aprilo sul telefono",
                document: "Il Lead ha mandato un documento: aprilo sul telefono",
                sticker: "Il Lead ha mandato uno sticker: aprilo sul telefono",
                location: "Il Lead ha mandato una posizione: aprila sul telefono",
                contacts: "Il Lead ha mandato un contatto: aprilo sul telefono",
                other: "Il Lead ha mandato un messaggio che Gioia365 non mostra: aprilo sul telefono",
            },
            withTemplate: "{title} · modello «{name}»",
            openedTo: "aperto in WhatsApp Desktop verso {number}",
            to: "a {number}",
            declaredAt: "dichiarato inviato {when}",
            unverifiable: "consegna e lettura non verificabili",
            // Il WhatsApp ufficiale (piano M6, R2, Task 10a; questioni 409 e 415): il canale e lo stato che dice Meta, con le parole del
            // mock-up (`m6.html`: «Inviato», poi «Consegnato», poi «Letto dal Lead»; se non arriva, «Non consegnato» con il motivo) e,
            // prima che Meta lo dica, «Preso in carico da Meta» (come «Preso in carico da WhatsApp Agile» di `mockup.js`); «Non confermato»
            // quando Meta non ha mai risposto all'invio.
            official: "WhatsApp ufficiale · {state}",
            officialStates: {
                queued: "Preso in carico da Meta",
                sent: "Inviato",
                delivered: "Consegnato",
                read: "Letto dal Lead",
                failed: "Non consegnato",
                notConfirmed: "Non confermato",
            },
            failureReason: "motivo: {reason}",
            // Un codice di Meta senza un testo qui sotto: il titolo di Meta, nella sua lingua, e il codice.
            failureWithCode: "{title} (codice {code})",
            failureCode: "codice {code}",
            // I codici più comuni degli errori di Meta (la pagina «Error codes» della Cloud API), per codice; `notConfirmed` è «Non
            // confermato» (questione 415).
            failureReasons: {
                code130429: "il numero ha raggiunto il limite di messaggi al secondo di Meta",
                code130472: "il numero del Lead fa parte di un esperimento di Meta che esclude questo messaggio",
                code131000: "errore sconosciuto di Meta",
                code131021: "il numero del Lead è lo stesso di chi scrive",
                code131026: "il numero non è su WhatsApp, non ha accettato i termini di WhatsApp o ha un'app troppo vecchia",
                code131031: "l'account WhatsApp Business è bloccato da Meta",
                code131042: "c'è un problema con il metodo di pagamento dell'account WhatsApp Business",
                code131047: "sono passate più di 24 ore dall'ultima risposta del Lead",
                code131048: "troppi messaggi di questo numero sono stati bloccati o segnalati come spam",
                code131049: "Meta non l'ha consegnato per non mandare troppi messaggi di marketing alla stessa persona",
                code131050: "il Lead ha scelto di non ricevere messaggi di marketing da questa azienda",
                code131056: "troppi messaggi allo stesso Lead in poco tempo",
                code131057: "l'account WhatsApp Business è in manutenzione",
                code132000: "i valori non corrispondono alle variabili del modello",
                code132001: "il modello non c'è su Meta o non è approvato",
                code132007: "il modello viola una regola di WhatsApp",
                code132012: "i valori del modello non hanno il formato giusto",
                code132015: "il modello è sospeso da Meta per bassa qualità",
                code132016: "il modello è stato disattivato da Meta",
                code133010: "il numero di chi scrive non è registrato su WhatsApp Business",
                code368: "l'account WhatsApp Business è limitato da Meta per una violazione delle regole",
                notConfirmed: "Meta non ha confermato l'invio: il messaggio può essere arrivato o no",
            },
            // WhatsApp Agile (piano M6, R9, Task 27b; WA-7): Agile sa soltanto «preso in carico», con le parole del mock-up (`mockup.js`,
            // `WA_LOG`), e il titolo dice il canale. Gli altri stati e i motivi sono parole nuove: la risposta del fornitore che non arriva
            // (può essere partito, e non si rimanda da sé), il messaggio che il fornitore non ha mai confermato (il giro di ogni ora), il
            // rifiuto del fornitore con la sua risposta e un numero che non ha la forma giusta.
            agileStates: {
                queued: "In invio con WhatsApp Agile",
                sent: "Preso in carico da WhatsApp Agile",
                failed: "Non preso in carico da WhatsApp Agile",
                noResponse: "WhatsApp Agile non ha risposto: non sappiamo se è partito",
                notConfirmed: "Non confermato da WhatsApp Agile",
            },
            agileFailures: {
                http: "WhatsApp Agile ha risposto con l'errore {status}",
                httpWithText: "{text} (WhatsApp Agile, errore {status})",
                invalidReference: "il numero del Lead o quello di chi scrive non ha la forma che WhatsApp Agile accetta",
                notResent: "non si rimanda da sé, per non mandarlo due volte: WhatsApp Agile riprova da solo per 24 ore quello che ha preso",
            },
        },
        // Un evento delle email di GoHighLevel (piano dell'ingresso del 12 ottobre 2026, I5, D5; INGR-22), in sola lettura: le parole del
        // piano; in «quando · chi» GoHighLevel, che manda le email; sotto l'oggetto e il link, se il flusso li manda.
        email: {
            events: {
                delivered: "Email consegnata",
                opened: "Email aperta",
                clicked: "Clic su un link dell'email",
                bounced: "Email rimbalzata",
                complained: "Email segnata come spam",
                unsubscribed: "Disiscritto dalle email",
                replied: "Ha risposto all'email",
            },
            subject: "Oggetto: «{subject}»",
            link: "Link:",
        },
        note: {
            title: "Nota",
            // La provenienza scritta dall'importazione, per esempio «Campo «Note Telefono» di Close».
            withOrigin: "Nota · {origin}",
            attachments: {
                title: "Allegati",
                open: "Apri",
                download: "Scarica",
                openLabel: "Apri «{name}»",
                downloadLabel: "Scarica «{name}»",
                to_copy: "Da copiare da Close",
                failed: "Copia da Close non riuscita",
                missing: "Non più in Close",
                expired: "Non più disponibile",
                sizeKb: "{size} KB",
                sizeMb: "{size} MB",
            },
        },
        change: {
            one: "Campo «{field}» cambiato",
            many: "{count} modifiche: {fields}",
            line: "{field}: {change}",
            fromTo: "da «{before}» a «{after}»",
            added: "aggiunto «{value}»",
            removed: "tolto «{value}»",
            reason: "Motivo: {reason}",
            empty: "vuoto",
            // Un campo di cui il registro non dice il nome (o lo dice con una chiave che questa versione non conosce).
            unknownField: "Dato del Lead",
            yes: "sì",
            no: "no",
        },
        // Gli ingressi dei Lead (piano dell'ingresso del 10 ottobre 2026, I2, Task 4): il Lead entrato da una porta (`lead.created` con il
        // sistema) e il Lead che rientra con lo stesso cellulare (`lead.reentered`), con da dove e che cosa è cambiato.
        intake: {
            enteredWeb: "Entrato dal sito",
            enteredGhl: "Entrato da GoHighLevel",
            enteredMeta: "Entrato dai moduli di Meta",
            enteredFile: "Entrato da un file",
            reentered: "Rientrato con lo stesso cellulare · {source}, {changes}",
            sources: {
                web: "dal sito",
                ghl: "da GoHighLevel",
                meta: "dai moduli di Meta",
                file: "da un file",
                manual: "da «Nuovo Lead»",
                other: "da un ingresso",
            },
            nothingNew: "niente da aggiornare",
            updated: "dati aggiornati, {list}",
            fieldsOne: "1 campo",
            fieldsMany: "{count} campi",
            tagsOne: "un tag",
            tagsMany: "{count} tag",
            and: "{first} e {second}",
        },
        event: {
            created: "Lead creato",
            createdInClose: "Lead creato in Close",
            createdDetails: "Status: {status} · Owner: {owner}",
            imported: "Lead importato da Close",
            joinedFromClose: "Storia di Close aggiunta: stesso cellulare",
            // «Archivia» e «Ripristina» (piano M3 Task 12): il motivo scritto con l'archiviazione, se c'è.
            archived: "Lead archiviato",
            archivedReason: "Motivo: {reason}",
            restored: "Lead ripristinato",
            // «Unisci in un solo Lead» (piano M3 Task 18): sul Lead che resta chi è entrato, con il motivo della coppia
            // (`dataCleanup.samePhone` e `sameEmail`); sul Lead assorbito in chi è entrato. Senza nome, «un altro Lead».
            merged: "Unito con «{name}»",
            mergedNoName: "Unito con un altro Lead",
            mergedDetails: "Dentro ci sono anche le sue chiamate, note e modifiche.",
            mergedAway: "Unito in «{name}»",
            mergedAwayNoName: "Unito in un altro Lead",
            // La telefonia (piano M4, Task 12): l'esito arrivato quando la chiamata ne aveva già uno, con i valori proposti, e il
            // telefono chiamato segnato errato da «Numero errato» (il titolo del mock-up, `initLeadCard`).
            outcomeLate: "Esito arrivato tardi, non applicato",
            outcomeLateProposed: "Proposto: {outcome}",
            phoneMarkedWrong: "Numero segnato errato: {field} {number}",
            phoneMarkedWrongNumber: "Numero segnato errato: {number}",
            // Il Power Dialer (piano M5, Task 6): «Salta» con il motivo (`dialer.skipReasons`), «Lead successivo» senza chiamare.
            dialerSkipped: "Saltato nella cascata: {reason}",
            dialerPassed: "Passato al successivo senza chiamare",
            // La sequenza di chiamate (piano M5, Task 12; D18, ruling Q34): ogni fine è un solo `sequence.ended` con il motivo
            // (`callSequence.endWords`); fermata a mano e «Il Lead ha risposto» hanno il loro titolo. Il posto della telefonata
            // nella sequenza sta in fondo a «quando · chi».
            sequenceStarted: "Sequenza di chiamate partita",
            sequenceRestarted: "Sequenza ripartita da capo",
            // La ripartenza da sola di SEQ-14, con i giorni dell'impostazione di allora.
            sequenceRestartedAutomatically: "Sequenza ripartita da sola: {n} giorni lavorativi senza contatto",
            sequenceAttemptClosed: "Tentativo {n} chiuso con {calls} su {required}",
            sequenceViolated: "Sequenza non rispettata: {reason}",
            sequenceEnded: "Sequenza finita: {reason}",
            sequenceStopped: "Sequenza fermata a mano",
            sequenceAnsweredManually: "Il Lead ha risposto ({how}) · segnato a mano",
            callSlot: "tentativo {attempt} · chiamata {number}",
            // I richiami (piano M5, Task 17; D18): fissato (con «concordato con il Lead»), spostato con prima e dopo, fatto, annullato.
            taskCreated: "Richiamo fissato per {when}",
            taskCreatedAgreed: "Richiamo fissato per {when} · concordato con il Lead",
            taskRescheduled: "Richiamo spostato da {before} a {after}",
            taskCompleted: "Richiamo fatto",
            taskCanceled: "Richiamo annullato",
            // «Sposta» allo stesso orario che cambia soltanto «Concordato con il Lead» (questione 328).
            taskAgreed: "Richiamo per {when} · concordato con il Lead",
            taskNotAgreed: "Richiamo per {when} · non più concordato con il Lead",
            // «Non inviare WhatsApp» (piano M6, R1, Task 4b; D25): acceso e spento, con il titolo e il testo del mock-up (`mockup.js`).
            whatsappOptedOut: "Non inviare WhatsApp: acceso",
            whatsappOptedOutText: "Il Lead ha chiesto di non ricevere WhatsApp, per esempio scrivendo STOP. Le chiamate restano possibili.",
            whatsappOptedIn: "Non inviare WhatsApp: spento",
            whatsappOptedInText: "Il Lead ha chiesto di nuovo i messaggi su WhatsApp.",
            other: "Attività registrata",
            opportunity: {
                title: "Opportunità: fase cambiata",
                phases: "Da «{before}» a «{after}»",
                phase: "Fase: «{after}»",
                pipeline: "Pipeline: {name}",
                value: "Valore: {value}",
                monthly: "{value} al mese",
                annual: "{value} all'anno",
            },
            task: {
                title: "Task completato",
                due: "Scadenza: {date}",
                assignedTo: "Era di: {name}",
            },
            closeImportUpdate: "Aggiornato in Close da un'importazione",
            closeLeadMerge: "Unito in Close con un altro Lead",
            // Un'email di Close entrata come storia (22/10/2026): Gioia365 non manda email.
            closeEmail: {
                sent: "Email di Close mandata",
                received: "Email di Close ricevuta",
                other: "Email di Close",
                subject: "Oggetto: {subject}",
                noSubject: "Senza oggetto",
                status: "Stato in Close: {status}",
                statuses: {
                    draft: "bozza, mai mandata",
                    scheduled: "programmata, non mandata",
                    outbox: "in uscita, non mandata",
                    error: "non partita per un errore",
                },
                attachments: "Allegati rimasti in Close: {count}",
                truncated: "Il testo continua in Close: qui ne entrano i primi 100.000 caratteri.",
            },
            // Dall'importazione da GoHighLevel (INGR-30): un messaggio come storia, e il conteggio dei messaggi automatici in una riga.
            ghlMessage: {
                inbound: "{channel} da GoHighLevel, in arrivo",
                outbound: "{channel} da GoHighLevel, in uscita",
                other: "{channel} da GoHighLevel",
                channels: { email: "Email", whatsapp: "WhatsApp", instagram: "Messaggio Instagram", facebook: "Messaggio Facebook", sms: "SMS", call: "Chiamata" },
                subject: "Oggetto: {subject}",
                noSubject: "Senza oggetto",
                duration: "Durata: {minutes} min {seconds} s",
                truncated: "Il testo continua in GoHighLevel: qui ne entrano i primi 100.000 caratteri.",
                automated: "{channel} automatiche da GoHighLevel: {count}",
                automatedPeriod: "Dal {from} al {to}, newsletter e sequenze: non si leggono una per una.",
                automatedNew: "Di queste {total}, {count} entrate con questa importazione: le altre sono nelle righe di prima.",
            },
            meeting: {
                title: "Riunione",
                titled: "Riunione: {title}",
                start: "Inizio: {when}",
                duration: "Durata: {duration}",
                attendees: "Partecipanti: {names}",
                location: "Luogo: {place}",
                status: "Stato: {status}",
                statuses: {
                    completed: "svolta",
                    canceled: "annullata",
                    upcoming: "in programma",
                },
            },
            custom: {
                title: "Attività di Close",
                field: "{name}: {value}",
                unnamedField: "Campo senza nome",
            },
        },
    },
    // Le etichette dei campi della scheda. Il registro delle attività scrive queste chiavi come etichetta dei campi di
    // sistema (i campi dell'azienda hanno il loro nome): la Timeline le traduce e la sua ricerca le confronta nella
    // lingua di chi guarda.
    leadCard: {
        fields: {
            firstName: "Nome",
            lastName: "Cognome",
            salonName: "Nome Azienda Target",
            email: "Email",
            website: "Sito web",
            streetAddress: "Indirizzo",
            postalCode: "CAP",
            mobile: "Cellulare",
            landline: "Telefono fisso",
            secondHolder: "Secondo titolare",
            secondHolderFirstName: "Nome del secondo titolare",
            secondHolderLastName: "Cognome del secondo titolare",
            secondHolderEmail: "Email del secondo titolare",
            secondHolderMobile: "Cellulare del secondo titolare",
            status: "Status",
            city: "Città",
            // In sola lettura: vengono dalla città (decisione del 1° ottobre 2026).
            province: "Provincia",
            region: "Regione",
            country: "Nazione",
            owner: "Owner",
            tags: "Tag",
        },
        // La scheda (piano M2 Task 18, mock-up `scheda-lead.html`): testata, dati dal modello pubblicato con la modifica sul
        // posto, Timeline al centro e «Riepilogo» a destra. Dei sette pulsanti della testata ci sono «Chiama» (piano M4, Task 13:
        // `callDesk.*`) e «Nota»: gli altri arrivano con le loro milestone (questione aperta, proposta 19 dell'importazione da Close).
        backToList: "Torna ai Lead",
        eyebrow: "Lead",
        twoHolders: "{first} e {second}",
        ownerFact: "Owner: {name}",
        noOwner: "Senza owner",
        ownerInactive: "non più attivo, da riassegnare",
        status: "Status",
        tags: "Tag",
        noTags: "Nessun tag",
        editTags: "Modifica i tag",
        actions: "Azioni rapide",
        note: "Nota",
        // «Altro» (piano M6, R1, Task 4a; questione 390): le azioni della testata che non ci stanno accanto al nome, nel loro ordine.
        more: "Altro",
        moreLabel: "Altre azioni",
        loadingCard: "Carico la scheda…",
        colleague: "Questo Lead è di {name}. Puoi aggiornarlo: resta suo, e ogni modifica compare nella Timeline con il tuo nome.",
        colleagueReadOnly: "Questo Lead è di {name}. Puoi leggerne la scheda, non modificarla.",
        readOnly: "Puoi leggere questa scheda, non modificarla.",
        // I possibili doppioni sotto la testata (LEAD-28): `{link}` è il nome dell'altro Lead, con il link alla sua scheda; «e altri
        // {count}» porta a «Pulizia dati» chi la fa. Testi della riga e frase per chi non li risolve: scelta di Claude.
        duplicates: {
            label: "Possibili doppioni",
            samePhone: "Possibile doppione: stesso cellulare di {link}",
            sameEmail: "Possibile doppione: stessa email di {link}",
            merge: "Unisci",
            notDuplicates: "Non sono doppioni",
            more: "e altri {count}",
            readOnly: "Lo sistema chi fa la pulizia dei dati.",
            gone: "Questa coppia non c'è più: la scheda si è aggiornata.",
        },
        conflict: "Qualcun altro ha modificato questo Lead nel frattempo: la scheda adesso mostra i dati aggiornati, e la tua modifica non è stata salvata.",
        statusSaved: "Status cambiato: {name}. Resta nella Timeline.",
        data: {
            title: "Dati del Lead",
            help: "Clicca un dato per cambiarlo, poi Invio per salvare o Esc per annullare. Ogni modifica resta nella Timeline con il nome di chi l'ha fatta.",
            sections: {
                contact: "Contatto e responsabilità",
                salon: "Azienda Target e qualificazione",
                territory: "Territorio",
            },
            salonNote: "Problema manifestato e competitor si scrivono nelle note.",
            fromCity: "dalla città",
            provinceValue: "{name} · {abbreviation}",
            cityValue: "{name} ({abbreviation})",
            empty: "Aggiungi",
            editLabel: "Modifica {field}: {value}",
            editHint: "Invio salva · Esc annulla",
            editHintMultiline: "Invio salva · Maiusc+Invio va a capo · Esc annulla",
            saved: "«{field}» salvato: resta nella Timeline.",
            prefix: "Prefisso di {field}",
            choiceNone: "Nessuna scelta",
            euro: "€",
        },
        errors: {
            number: "Scrivi un numero, al massimo con due decimali: per esempio 38 oppure 38,50.",
            email: "Controlla l'email, per esempio nome@azienda.it.",
            city: "Scegli la città dall'elenco mentre scrivi.",
            phone: "Questo numero non va bene: controllalo, per esempio 347 123 4567.",
            looksLandline: "Sembra un numero fisso: scrivilo in «Telefono fisso».",
            looksMobile: "Sembra un cellulare: scrivilo in «Cellulare».",
            secondHolderLandline: "Sembra un numero fisso: il secondo titolare ha soltanto il cellulare.",
            conflict: "Qualcun altro ha modificato questo Lead mentre salvavi: la tua modifica è qui, non salvata. Controllala e premi Invio per salvarla.",
        },
        secondHolder: {
            add: "Aggiungi un altro titolare",
            remove: "Togli il secondo titolare",
            confirmTitle: "Togli il secondo titolare",
            confirmText: "Nome, cognome, cellulare ed email del secondo titolare escono dalla scheda. La modifica resta nella Timeline con il tuo nome.",
            confirm: "Togli",
            removed: "Secondo titolare tolto: resta nella Timeline.",
        },
        owner: {
            title: "Cambia owner",
            select: "Nuovo owner",
            none: "Senza owner",
            noOptions: "Non c'è nessun altro a cui darlo.",
            reason: "Motivo · obbligatorio",
            reasonPlaceholder: "Per esempio: ferie, cambio di zona, richiesta del Lead",
            reasonRequired: "Scrivi il motivo del cambio.",
            history: "Le chiamate, le note e i numeri passati restano a nome di chi li ha fatti.",
            submit: "Cambia owner",
            changed: "Owner cambiato: adesso è {name}.",
            removed: "Owner tolto: il Lead adesso è senza owner.",
        },
        tagsDialog: {
            title: "Tag del Lead",
            filter: "Cerca un tag",
            none: "Nessun tag per «{q}».",
            empty: "Non ci sono ancora tag.",
            hint: "Si sceglie fra i tag che ci sono già.",
            filterOrCreate: "Cerca o crea un tag",
            hintCreate: "Scegli fra i tag che ci sono già, oppure scrivi il nome di uno nuovo.",
            create: "Crea il tag «{name}»",
            created: "Tag «{name}» creato e aggiunto: la modifica resta nella Timeline.",
            submit: "Salva i tag",
            saved: "Tag salvati: la modifica resta nella Timeline.",
        },
        summary: {
            title: "Riepilogo",
            lastCall: "Ultima chiamata",
            lastCallTerm: "Quando, esito, chi",
            neverCalled: "Mai chiamato",
            inbound: "in entrata",
            calls: "Chiamate",
            made: "Fatte",
            received: "Ricevute",
            inCrm: "Nel CRM",
            created: "Creato",
            updated: "Ultima modifica",
            fromClose: "da Close",
            // Il prossimo tentativo dovuto della sequenza di chiamate (piano M5, Task 12; questioni 264 e 269).
            nextStep: "Prossimo passo",
        },
    },
    // «Chiama» e la «Postazione di chiamata» della scheda Lead, con la barra in alto quando si cambia pagina (piano M4, Task 13,
    // mock-up `scheda-lead.html`): le parole del mock-up alla lettera; le altre sono proposte (questioni 160 e 161, e i motivi
    // di «Chiama» spento, gli stessi della scheda e del rifiuto del server).
    callDesk: {
        title: "Postazione di chiamata",
        callerLabel: "Sta chiamando {name}",
        ready: "Pronto. Premi Chiama: a fine chiamata scegli l'esito e cosa fare dopo, senza lasciare la scheda.",
        call: "Chiama",
        pickLabel: "Scegli quale numero chiamare",
        pickMenu: "Quale numero chiamare",
        secondMobile: "Cellulare di {name}",
        live: "In chiamata",
        timer: "Durata della chiamata",
        ringing: "Squilla",
        ending: "Chiusura in corso…",
        closedEarly: "Chiusa presto: meno di 20 secondi di squillo. Non conta nella fila o nella sequenza.",
        hangupUnmeasured: "Non si riesce a controllare com'è finita la chiamata. Non conta nella fila o nella sequenza.",
        closureUnconfirmed: "La fine della chiamata non è ancora confermata. Riprova tra poco.",
        invalidNumber: "Il gestore delle chiamate dice che il numero non è valido. Vuoi segnarlo «Numero errato»?",
        unreachableNumber: "Il numero non è raggiungibile. Controllalo: se è errato, puoi segnarlo «Numero errato».",
        unreachableLabel: "Non raggiungibile",
        markWrongNumber: "Segna Numero errato",
        numberLater: "Controllo dopo",
        ringDuration: "Squillo: {seconds} s",
        ringDurationUnknown: "Squillo: durata non disponibile",
        earlyLabel: "Chiusa presto, non conta",
        unmeasuredLabel: "Chiusura non verificabile, non conta",
        invalidNumberLabel: "Numero non valido",
        hangUp: "Chiudi la chiamata",
        leaveWarning: "C'è una chiamata in corso: se chiudi la pagina si chiude anche la chiamata.",
        outcomeLegend: "Esito della chiamata · obbligatorio",
        callAgainNow: "Richiama ora",
        answered: "Risposta",
        noAnswer: "Nessuna risposta",
        wrongNumber: "Numero errato",
        howDidItGo: "Com'è andata?",
        notesLabel: "Appunti di questa chiamata",
        notesPlaceholder: "Cosa ti ha detto, cosa hai promesso…",
        reasonNoOutcome: "Scegli prima l'esito: senza esito non si prosegue.",
        reasonNoAnswered: "Scegli com'è andata la risposta.",
        reasonNoNote: "Con l'esito «Altro» scrivi una nota: è obbligatoria.",
        reasonStatus: "La chiamata è durata almeno {minutes} minuti e lo status è ancora «{status}»: scegline uno prima di chiudere.",
        close: "Chiudi la chiamata",
        saving: "Salvo l'esito…",
        retrying: "Non riesco a salvare l'esito: riprovo finché la pagina resta aperta.",
        missingOutcome: "Manca l'esito della chiamata delle {time}",
        afterOutcome: "Dopo «{outcome}»",
        statusQuestion: "Vuoi modificare lo status?",
        statusNow: "Adesso è «{status}».",
        newStatus: "Nuovo status",
        saveStatus: "Salva lo status",
        statusesUnavailable: "La lista degli status non si è caricata.",
        quickStatus: "Metti «{status}»",
        searchSalon: "Cerca l'azienda target su Google",
        searchHint: "Cerca l'azienda target per nome e città, controlla il numero sul sito o su Google Maps e guarda che non ci sia un errore di battitura.",
        fixPhone: "Correggi il numero",
        barLabel: "La tua chiamata",
        barLive: "In chiamata con {name}",
        barBack: "Torna alla scheda",
        barMissing: "Manca l'esito: torna alla scheda",
        // Il pulsante della barra dice che cosa manca davvero dopo l'esito (richiesta del product owner del 5 ottobre 2026; parole
        // proposte da Claude, in `DECISIONS.md`, «Confermate il 5 ottobre 2026, dopo la prima chiamata»).
        barMissingCallback: "Scegli quando richiamare: torna alla scheda",
        barMissingStatus: "Manca lo status (chiamata di almeno {minutes} minuti): torna alla scheda",
        barMissingStep: "Manca un passo obbligatorio: torna alla scheda",
        barSaved: "Esito salvato: torna alla scheda e chiudi la chiamata",
        // La chiamata è di un'altra azienda della stessa scheda del browser (minore di R2 per R3): proposte della questione 213.
        barOtherCompany: "Questa chiamata è di {company}: passa a quell'azienda per tornare alla scheda.",
        barOtherCompanyUnknown: "Questa chiamata è di un'altra azienda: passa a quell'azienda per tornare alla scheda.",
        busyCalling: "Chiamata in corso.",
        busyOutcome: "Registra prima l'esito della chiamata appena chiusa.",
        dismiss: "Chiudi l'avviso",
        microphone: "Il browser non lascia usare il microfono a Gioia365, e senza il microfono la chiamata non parte. Clicca sul lucchetto accanto all'indirizzo, consenti il microfono per questo sito e riprova.",
        // Riprovare nella stessa pagina fallirebbe di nuovo: di solito la pagina è di prima di un aggiornamento e il file del
        // telefono del browser che chiede non c'è più sul server. Parole proposte da Claude (questione 217).
        load: "Gioia365 è stato aggiornato: ricarica la pagina per chiamare.",
        reload: "Ricarica la pagina",
        notConnected: "La chiamata non è partita: riprova.",
        // L'esito di una chiamata che il server non trova più (`404 call_not_found`: il Lead eliminato per sempre nel frattempo).
        // Proposta della questione 213.
        callGone: "Questa chiamata non c'è più, forse perché il Lead è stato eliminato: l'esito non si può salvare.",
        providerError: "La chiamata si è fermata (codice {code}): riprova; se continua, segnala il codice.",
        inCallMine: "Sei già al telefono con questo Lead, forse da un'altra scheda del browser: chiudi prima quella chiamata.",
        // Perché «Chiama» è spento: gli stessi motivi della scheda e del rifiuto del server (`NOT_CALLABLE_REASONS`).
        reasons: {
            status_blocks: "Lo status del Lead blocca le chiamate.",
            phone_wrong: "Il numero è segnato errato: correggilo nei dati e «Chiama» torna.",
            no_phone: "Nessun numero da chiamare: aggiungilo nella scheda.",
            telephony_off: "La telefonia dell'azienda non è accesa: la accende il Super admin di Gioia365.",
            // Dal parco dei cellulari (Task 16 e 17) è la persona a non avere un cellulare: le stesse parole del rifiuto del server
            // (`errors.caller_number_missing`).
            no_caller_number: "Non hai un numero per chiamare: chiedi a chi gestisce i numeri di darti un cellulare, in Impostazioni → Team.",
            in_call: "In chiamata con {name} adesso",
            reserved: "Lo sta lavorando {name} adesso",
            no_feature: "Il tuo ruolo non può chiamare: lo decide chi gestisce i ruoli e i permessi.",
            not_editable: "Puoi soltanto guardare questo Lead: per chiamarlo serve poterlo modificare.",
            commercial_view: "Durante «Guarda come…» non si chiama: esci dalla vista per chiamare.",
            platform_context: "Come Super admin di Gioia365 non chiami da qui: si chiama con un'appartenenza all'azienda.",
        },
        // Il microfono e l'ascolto nella testata della postazione (richiesta del product owner del 6 ottobre 2026, in
        // `DECISIONS.md`, «Confermata il 6 ottobre 2026, il microfono si sceglie nella postazione»): il product owner ha approvato
        // il posto e il comportamento; tutte queste parole sono proposte di Claude (questione 216).
        audio: {
            title: "Microfono e ascolto",
            button: "Microfono e ascolto: {name}",
            microphone: "Microfono",
            output: "Ascolto",
            systemDefault: "Predefinito di sistema",
            systemDefaultNamed: "Predefinito di sistema · {name}",
            unnamed: "Dispositivo senza nome {number}",
            needsPermission: "Il browser dice i nomi di microfoni e cuffie soltanto dopo il permesso di usare il microfono.",
            allow: "Consenti il microfono",
            denied: "Il microfono non si è acceso: controlla che sia collegato e consentito dal lucchetto accanto all'indirizzo, poi riprova.",
            unsupported: "Questo browser non lascia scegliere il microfono: le chiamate usano quello di sistema.",
            inputMissing: "Le cuffie scelte non sono collegate: uso il microfono di sistema.",
            outputMissing: "L'ascolto scelto non è collegato: uso quello di sistema.",
            builtIn: "Stai usando il microfono del computer: con le cuffie ti sentono meglio.",
        },
    },
    // La barra «Power Dialer» nel guscio e le sue finestre (piano M5, Task 5; D16: le parole alla lettera del mock-up
    // `scheda-lead.html` e di `mockup.js`, le altre sono proposte della questione 269).
    dialer: {
        barLabel: "Sessione Power Dialer",
        bar: "Power Dialer · {source} · Adesso: {lead} · fatti {done} · ne restano {remaining} · Dopo: {next}",
        sourceSmartList: "Smart List «{name}»",
        sourceTasks: "Task «{view}»",
        // I Task di un collega o di tutto il team (il nome della scheda, poi la persona: la stessa di «Di chi»); i propri senza persona.
        sourceTasksWho: "Task «{view}» · {who}",
        nextNone: "fine della lista",
        // Per una cascata dai Task (piano M5, R4; questione 339): le parole dei Task al posto di quelle della lista.
        nextNoneTasks: "fine dei Task",
        active: "Attiva",
        paused: "In pausa",
        countdown: "La chiamata a {lead} parte tra {seconds} s",
        callNow: "Chiama subito",
        queue: "Coda",
        pause: "Pausa",
        resume: "Riprendi",
        skip: "Salta",
        interrupt: "Interrompi",
        interruptInCall: "Chiudi prima la chiamata in corso.",
        interruptBeforeOutcome: "Prima scegli l'esito e fai i passi obbligatori, poi «Interrompi».",
        next: "Lead successivo",
        pausedReason: "In pausa: premi Riprendi per continuare",
        // In pausa su un Lead già fatto o che si salta da solo: «Lead successivo» resta acceso e riprende la sessione (product owner, 9 ottobre 2026).
        pausedDone: "In pausa: «Lead successivo» riparte dal Lead dopo, «Riprendi» resta su questo.",
        beforeNext: "Prima scegli l'esito e fai i passi obbligatori, poi «Lead successivo».",
        allDone: "Fatto tutto: passa al Lead successivo con il pulsante nella barra in alto.",
        passedNow: "Questo Lead adesso si salta: {reason}. Premi «Lead successivo».",
        // Dopo «Chiudi la chiamata», e per un Lead che si salta da solo, il Lead successivo arriva da solo (parole approvate dal
        // product owner il 9 ottobre 2026); con un tentativo della sequenza a metà la riga dice che il passaggio lo chiude (`made` a
        // parole, come `callsWord` della finestra «Decidi tu»). «Resta su questo Lead» toglie il conto.
        advancing: "Lead successivo fra {seconds}…",
        advancingAttempt: "Lead successivo fra {seconds}…: il tentativo {n} si chiude con {made} su {required}.",
        stayHere: "Resta su questo Lead",
        // Le chiamate di fila da sole (decisione dell'11 ottobre 2026, TEL-32): la postazione che aspetta l'esito di Gioia365 (parole di
        // Claude) e la riga del richiamo (parole del product owner). L'attesa non blocca: «Scegli l'esito» riporta subito al passo
        // dell'esito di sempre (ruling S3 del controllore, parole di Claude).
        noAnswerWaiting: "Senza risposta: Gioia365 segna «Nessuna risposta».",
        chooseOutcome: "Scegli l'esito",
        redialing: "Richiamo fra {seconds}… (chiamata {n} di {required})",
        queueTitle: "La coda della sessione",
        queueNow: "Adesso",
        queueNext: "Poi, in quest'ordine",
        queueNone: "Nessuno: dopo questo Lead la lista è finita.",
        // Per una cascata dai Task (questione 339), come `nextNoneTasks`.
        queueNoneTasks: "Nessuno: dopo questo Lead i Task sono finiti.",
        queuePassed: "Si saltano da soli",
        queueWorked: "Già fatti in questa sessione",
        withReason: "{lead}: {reason}",
        queueResults: {
            called: "chiamato",
            skipped: "saltato, {reason}",
            passed: "passato al successivo senza chiamare",
        },
        skipTitle: "Salta questo Lead",
        skipLegend: "Perché lo salti?",
        skipReasons: {
            asked_later: "ha chiesto di essere richiamata più tardi",
            data_to_verify: "dati da verificare",
            colleague_follows: "la segue già un collega",
            other: "altro motivo",
        },
        skipHint: "Il motivo resta nella Timeline. Il Lead non torna in questa sessione e resta nella lista per la prossima volta.",
        // Per una cascata dai Task (questione 339): saltare non tocca il richiamo, che resta aperto nei Task.
        skipHintTasks: "Il motivo resta nella Timeline. Il Lead non torna in questa sessione e il suo richiamo resta nei Task per la prossima volta.",
        skipGo: "Salta e vai avanti",
        summaryTitle: "Sessione interrotta",
        summaryFinishedTitle: "Hai finito la lista",
        // Il riepilogo di una cascata dai Task (piano M5, Task 21, questione 339): le parole dei Task al posto di quelle della lista; il nome
        // della sorgente (`sourceText`, «Task «Oggi» · Luca») sta senza altre virgolette attorno.
        summaryFinishedTitleTasks: "Hai finito le telefonate",
        summaryOf: "Riepilogo della sessione su «{source}».",
        summaryFinished: "Non ci sono altri Lead da chiamare adesso in «{source}».",
        summaryOfTasks: "Riepilogo della sessione su {source}.",
        summaryFinishedTasks: "Non ci sono altri Lead da chiamare adesso in {source}.",
        summarySaved: "La sessione resta salvata. Quando vuoi, anche un altro giorno, apri la lista e premi «Riprendi a chiamare»: si riparte da {next}.",
        summarySavedTasks: "La sessione resta salvata. Quando vuoi, anche un altro giorno, apri i Task e premi «Riprendi a chiamare»: si riparte da {next}.",
        summaryStats: {
            leadsCalled: "Lead chiamati",
            calls: "Chiamate",
            answered: "Con risposta",
            minutes: "Minuti al telefono",
            skipped: "Saltati da te",
        },
        summarySkipped: "Saltati da te:",
        summaryPassedOver: "Saltati da soli, non si potevano chiamare:",
        summaryLeft: "Nella lista restano {total} Lead: {detail}.",
        summaryLeftOne: "Nella lista resta 1 Lead: {detail}.",
        summaryLeftNone: "Nella lista non restano altri Lead.",
        summaryLeftTasks: "Nei Task restano {total} Lead: {detail}.",
        summaryLeftOneTasks: "Nei Task resta 1 Lead: {detail}.",
        summaryLeftNoneTasks: "Nei Task non restano altri Lead.",
        summaryToCall: "{count} da chiamare",
        summaryToCallNone: "nessuno da chiamare",
        summaryAndPassed: "{toCall} e {count} che per ora si saltano da soli",
        summaryAndPassedOne: "{toCall} e 1 che per ora si salta da solo",
        backToList: "Torna alla lista",
        continue: "Continua a chiamare",
        passover: {
            status_blocks: "lo status non permette di chiamarlo",
            in_call: "al telefono con {name}",
            reserved: "lo sta lavorando {name}",
            no_phone: "nessun numero da chiamare",
            phone_wrong: "il numero è segnato errato",
            callback_later: "richiamo concordato alle {time}",
        },
        restored: "Sessione in corso su {source}",
        backToLead: "Torna alla scheda",
        leaveWithSession: "C'è una cascata in corso: resta salvata, la riprendi dalla lista.",
        leaveWithSessionTasks: "C'è una cascata in corso: resta salvata, la riprendi dai Task.",
        nextTitle: "Lead successivo",
        attemptPending: "Del tentativo {n} hai fatto {made} su {required}. Decidi tu",
        // Sotto la domanda (piano M5, Task 12; ruling Q50): la chiamata che manca, o quelle che mancano (questione 269).
        attemptPendingNote: "La chiamata che manca resta segnata come saltata, con il tuo nome.",
        attemptPendingNoteMany: "Le chiamate che mancano restano segnate come saltate, con il tuo nome.",
        stay: "Resta su questa scheda",
        openNext: "Apri il Lead successivo",
    },
    // La registrazione di una telefonata nella Timeline e «Ascolta» (piano M4, Task 12). Gli stati hanno le parole di `REC_TEXT`
    // del mock-up (`mockup.js`). Quella di Close senza audio copiato (mai trovato, non ancora cercato o sparito in Close) lo dice; l'audio di Close da copiare e la copia non
    // riuscita hanno le loro parole (INGR-27: Gioia365 copia l'audio di Close nel suo archivio); il titolo plurale dell'anomalia
    // («Registrazioni rimaste in Close») non vale per una chiamata sola. Quella di una chiamata della telefonia senza audio è una
    // proposta. Il riproduttore ha le parole di `initLeadCard`: «Ascolta · 6:12», «Riprendi · 0:12 / 6:12»,
    // «Ascolta di nuovo · 6:12» e «Velocità di ascolto».
    recordings: {
        states: {
            available: "Da ascoltare",
            processing: "In preparazione: pronta fra pochi minuti",
            live: "Si registra: la trovi qui a fine chiamata",
            expired: "Audio scaduto: restano dati e appunti",
            manual: "Nessuna registrazione: chiamata dal cellulare, inserita a mano",
            error: "Registrazione non riuscita: il provider non l'ha consegnata",
            none: "Senza risposta: niente da registrare",
            close: "Nessuna registrazione di Close in Gioia365",
            closeCopying: "Registrazione di Close: da copiare in Gioia365",
            closeError: "Copia da Close non riuscita",
            missing: "Nessuna registrazione: la chiamata non è stata registrata",
        },
        // Chi vede la chiamata di un collega ma non ha «Ascoltare le registrazioni dei colleghi»; anche il rifiuto `403`.
        notAllowed: "Non hai il permesso di ascoltare le registrazioni dei colleghi.",
        listen: "Ascolta",
        listenFor: "Ascolta · {duration}",
        loading: "Preparo l'audio…",
        clock: "{position} / {duration}",
        pause: "Pausa · {clock}",
        resume: "Riprendi · {clock}",
        again: "Ascolta di nuovo · {duration}",
        againShort: "Ascolta di nuovo",
        speed: "Velocità di ascolto",
        speeds: {
            normal: "1×",
            faster: "1,5×",
            fastest: "2×",
        },
        // La registrazione che non c'è più (`404`), e l'audio che il browser non riesce a riprodurre nemmeno con un indirizzo nuovo.
        gone: "La registrazione non è più disponibile.",
        playFailed: "L'audio non si è potuto ascoltare: riprova.",
    },
    // «Archivia» sulla scheda e «Archiviati (N)» sotto l'elenco Lead (piano M3 Task 12, D9; mock-up `scheda-lead.html`,
    // `lead.html` e `initLeadPage`). «Elimina per sempre» chiede di scrivere la parola che il server vuole («elimina»),
    // in ogni lingua.
    leadArchive: {
        archive: "Archivia",
        ask: "Archivi il Lead? Esce da elenchi e Smart List; si ripristina dagli Archiviati.",
        reason: "Motivo (facoltativo)",
        yes: "Sì, archivia",
        no: "No",
        done: "Lead archiviato: resta nella Timeline con il tuo nome e l'orario.",
        link: "Archiviati ({count})",
        title: "Archiviati",
        // La spiegazione in cima alla finestra, dal mock-up (`lead.html`), con «dell'azienda» come in `deleteOnlySuperAdmin`.
        intro: "I Lead archiviati non si cancellano: «Ripristina» li rimette negli elenchi com'erano, con owner, status e Timeline. Eliminarli per sempre lo può fare soltanto il Super admin dell'azienda.",
        caption: "Lead archiviati: non compaiono negli elenchi e nelle Smart List",
        search: "Cerca fra gli archiviati",
        columns: {
            pick: "Scegli",
            lead: "Lead",
            who: "Chi e quando",
            why: "Perché",
            actions: "Azioni",
        },
        pickOne: "Scegli {name}",
        ownerOf: "owner {name}",
        restore: "Ripristina",
        restorePicked: "Ripristina i selezionati",
        restored: "Ripristinato: {names}. Torna negli elenchi con owner, status e Timeline. Resta nella Timeline chi l'ha ripristinato.",
        restoredMany: "Ripristinati: {names}. Tornano negli elenchi con owner, status e Timeline. Resta nella Timeline chi li ha ripristinati.",
        // Ogni Lead che un'azione non ha cambiato, con il motivo (decisione P36).
        restoreFailed: "{name}: non ripristinato. {reason}",
        mergedInto: "Unito con «{name}» in Pulizia dati",
        // Il Lead che è rimasto è fuori dal perimetro di chi guarda: il suo nome non si dice.
        mergedIntoHidden: "Unito con un altro Lead in Pulizia dati",
        mergedNoRestore: "Un Lead unito a un altro non si ripristina.",
        deletePicked: "Elimina per sempre i selezionati",
        deleteOnlySuperAdmin: "Eliminare un Lead per sempre lo può fare soltanto il Super admin dell'azienda.",
        deleteWarning: "Eliminati per sempre, i Lead non tornano più, nemmeno la loro Timeline.",
        deleteAsk: "Elimini per sempre {count} Lead? Non tornano più. Scrivi «elimina» per confermare.",
        deleteWord: "elimina",
        deleteYes: "Sì, elimina per sempre",
        deleted: "Eliminato per sempre: {names}. L'eliminazione resta nel registro Attività con il tuo nome.",
        deleteFailed: "{name}: non eliminato. {reason}",
        // Il motivo di `deleteFailed` per un Lead in cui altri sono stati uniti (`409 invalid_state` con `mergedLeads`).
        mergedLeadsFirst: "In questo Lead sono stati uniti altri {count} Lead: elimina prima quelli, dagli Archiviati.",
        mergedLeadsFirstOne: "In questo Lead è stato unito un altro Lead: elimina prima quello, dagli Archiviati.",
        pickFirst: "Spunta prima i Lead.",
        empty: "Nessun Lead archiviato.",
        emptySearch: "Nessun Lead archiviato per «{q}».",
        more: "Mostra altri",
        phoneOfArchived: "È di un Lead archiviato: lo ripristini dagli «Archiviati».",
        openArchived: "Apri gli Archiviati",
    },
    // «Azioni multiple» nell'elenco Lead (piano M3 Task 14, D10; mock-up `lead.html`, `initLeadPage`): la barra con le
    // caselle, la finestra con il riepilogo e la conferma, l'esito nell'avviso.
    bulkActions: {
        button: "Azioni multiple",
        on: "Azioni multiple attive: spunta i Lead nella tabella.",
        off: "Azioni multiple chiuse.",
        selectedOne: "1 Lead selezionato",
        selectedMany: "{count} Lead selezionati",
        // L'articolo lo sceglie il codice (`italianCountArticle`, decisione P41): «gli» davanti a 8, 11, 80…, «i» altrimenti.
        selectAll: "Seleziona tutti i {count} risultati",
        selectAllGli: "Seleziona tutti gli {count} risultati",
        selectAllOne: "Seleziona l'unico risultato",
        // La casella nell'intestazione «Lead», con le parole del mock-up (`mockup.js`, decisione P41).
        selectPage: "Seleziona tutti i Lead mostrati",
        pickLead: "Seleziona {name}",
        deselect: "Deseleziona",
        pickFirst: "Spunta i Lead nella tabella, oppure «Seleziona tutti».",
        waitList: "Aspetta il nuovo elenco: poi restano spuntati soltanto i Lead che mostra.",
        actions: {
            change_owner: "Cambia owner",
            change_status: "Cambia status",
            add_tag: "Aggiungi tag",
            remove_tag: "Togli tag",
            archive: "Archivia",
        },
        summary: "Riguarda {count} Lead: {names}.",
        summaryOne: "Riguarda 1 Lead: {names}.",
        andOthers: "e altri {count}",
        allResults: "Riguarda tutti i {count} Lead della vista di adesso (ricerca e filtri compresi).",
        allResultsGli: "Riguarda tutti gli {count} Lead della vista di adesso (ricerca e filtri compresi).",
        allResultsOne: "Riguarda l'unico Lead della vista di adesso (ricerca e filtri compresi).",
        // La nota della finestra del mock-up (`lead.html`) senza l'annullamento, che arriva dopo M3 (questione 140, decisione P41).
        fixedNote: "Il gruppo di Lead è fissato adesso: non cambia se nel frattempo cambiano i filtri. L'operazione resta nel registro Attività con il tuo nome.",
        // Chi vede più Lead di quanti ne modifica (per esempio tutti, ma modifica soltanto i suoi): il server lascia fuori gli altri.
        onlyEditable: "Cambiano soltanto i Lead che puoi modificare: gli altri restano come sono.",
        newOwner: "Nuovo owner",
        noOwner: "Senza owner",
        reason: "Motivo · obbligatorio",
        reasonPlaceholder: "Per esempio: ferie, cambio di zona",
        reasonRequired: "Scrivi il motivo del cambio di owner.",
        newStatus: "Nuovo status",
        noStatuses: "Non ci sono status da scegliere.",
        tagToAdd: "Tag da aggiungere",
        // «Crea il tag «…»» (24/10/2026): la casella filtra i tag; un nome che non c'è propone il tag nuovo, che si aggiunge subito.
        tagSearch: "Cerca o crea un tag",
        tagNoMatch: "Nessun tag per «{q}».",
        createTag: "Crea il tag «{name}» e aggiungilo a {count} Lead",
        createTagOne: "Crea il tag «{name}» e aggiungilo a 1 Lead",
        tagToRemove: "Tag da togliere",
        tagCount: "{tag} · ce l'hanno {count} di {total}",
        tagCountOne: "{tag} · ce l'ha 1 di {total}",
        noTags: "I Lead selezionati non hanno tag.",
        // Con «Seleziona tutti i N risultati» i Lead non sono tutti caricati: i tag si scelgono fra quelli dell'azienda.
        tagsAllResults: "Con tutti i risultati si sceglie fra tutti i tag dell'azienda: i Lead che non hanno quel tag restano come sono.",
        archiveNote: "I Lead spariscono dagli elenchi e dalle Smart List, ma non si cancellano: si ripristinano dagli Archiviati.",
        confirm: {
            change_owner: "Assegna {count} Lead",
            change_status: "Cambia status a {count} Lead",
            add_tag: "Aggiungi il tag a {count} Lead",
            remove_tag: "Togli il tag a {count} Lead",
            archive: "Archivia {count} Lead",
        },
        confirmOne: {
            change_owner: "Assegna 1 Lead",
            change_status: "Cambia status a 1 Lead",
            add_tag: "Aggiungi il tag a 1 Lead",
            remove_tag: "Togli il tag a 1 Lead",
            archive: "Archivia 1 Lead",
        },
        done: "Fatto: {label} su {affected} Lead.",
        doneOne: "Fatto: {label} su 1 Lead.",
        doneUnchanged: " {unchanged} erano già così.",
        doneUnchangedOne: " 1 era già così.",
        doneSkipped: " {skipped} non si potevano cambiare.",
        doneSkippedOne: " 1 non si poteva cambiare.",
        doneDifferent: "Il gruppo era di {candidates} Lead, non {expected}: nel frattempo l'elenco è cambiato.",
        // Il server lascia fuori in silenzio i Lead che chi agisce vede ma non modifica: la risposta non li conta a parte.
        doneLeftOut: "{count} Lead della vista non sono stati toccati: non li puoi modificare, oppure nel frattempo sono usciti dall'elenco.",
        doneLeftOutOne: "1 Lead della vista non è stato toccato: non lo puoi modificare, oppure nel frattempo è uscito dall'elenco.",
        labels: {
            change_owner: "cambio owner",
            change_status: "cambio status",
            add_tag: "tag aggiunto",
            remove_tag: "tag tolto",
            archive: "Lead archiviati",
        },
        tooLarge: "Troppi Lead in una volta ({count}): restringi con i filtri, al massimo 5.000.",
        needsFeature: {
            change_owner: "Cambiare l'owner a più Lead richiede «Cambiare l'owner, con il motivo».",
            tags: "Aggiungere e togliere i tag richiede «Creare e cambiare i tag».",
            archive: "Archiviare richiede «Archiviare e ripristinare i Lead».",
        },
    },
    // «Pulizia dati» (piano M3, Task 16–18; mock-up `lead.html`, `m-clean-dialog`, e `initLeadPage`). `mergedNumbersNote` è il
    // testo della nota che l'unione di due Lead scrive sul Lead che resta, nella lingua dell'azienda, con i numeri dell'altro
    // Lead che non hanno trovato un posto libero. La finestra: «Doppioni (N)» con la tabella campo per campo e «Telefoni ed
    // email (N)» con le proposte. `intro` e `tabsLabel` vengono dal mock-up (con Gioia365 al posto di Gioia360).
    dataCleanup: {
        mergedNumbersNote: "Numeri dell'altro Lead: {numbers}",
        button: "Pulizia dati",
        // Il pulsante con il numero delle cose da sistemare (doppioni più telefoni ed email), soltanto quando ce ne sono.
        buttonCount: "Pulizia dati ({count})",
        title: "Pulizia dati",
        intro: "Gioia365 trova i doppioni (stesso cellulare o stessa email) e i telefoni o le email scritti male, e propone come sistemarli. Non cambia niente da solo: ogni unione e ogni correzione aspetta il tuo OK e resta nella Timeline del Lead.",
        tabsLabel: "Cosa controllare",
        tabs: {
            duplicates: "Doppioni ({count})",
            issues: "Telefoni ed email ({count})",
            // Finché i numeri non sono arrivati.
            duplicatesPlain: "Doppioni",
            issuesPlain: "Telefoni ed email",
        },
        samePhone: "Stesso cellulare: {value}",
        sameEmail: "Stessa email: {value}",
        caption: "Dove i valori sono diversi, scegli quale tenere",
        columns: {
            field: "Campo",
            stays: "Resta · ultima chiamata {when}",
            staysNoCall: "Resta · entrato il {when}",
            other: "Ultima chiamata {when}",
            otherNoCall: "Mai chiamato · entrato il {when}",
        },
        fields: {
            firstName: "Nome",
            lastName: "Cognome",
            salonName: "Nome Azienda Target",
            mobile: "Cellulare",
            landline: "Telefono fisso",
            email: "Email",
            city: "Città",
            status: "Status",
            owner: "Owner",
        },
        empty: "vuoto",
        callsRow: "Chiamate",
        callsText: "{a} + {b}: restano tutte, con la Timeline dei due",
        tagsRow: "Tag",
        noTags: "nessuno",
        // Senza la funzione «Cambiare l'owner, con il motivo» il server rifiuterebbe l'unione che cambia l'owner.
        ownerNeedsFeature: "Tenere l'owner dell'altro Lead richiede «Cambiare l'owner, con il motivo».",
        merge: "Unisci in un solo Lead",
        notDuplicates: "Non sono doppioni",
        merged: "Uniti: resta un solo Lead, «{name}», con tutte le chiamate e le note. L'unione resta nella Timeline e l'altro è tra gli archiviati.",
        // Che cosa è passato dall'altro Lead (`moved` della risposta del server), dopo `merged`: «Dall'altro Lead: 3 chiamate e 1 nota.»
        mergedMoved: " Dall'altro Lead: {items}.",
        movedCalls: "{count} chiamate",
        movedCallsOne: "1 chiamata",
        movedNotes: "{count} note",
        movedNotesOne: "1 nota",
        dismissed: "Segnati come Lead diversi: non te li propongo più insieme.",
        noDuplicates: "Nessun doppione: ogni cellulare e ogni email compaiono una volta sola.",
        conflict: "Uno dei due Lead è cambiato nel frattempo: ricontrolla i valori e riprova.",
        // Un valore scelto dell'altro Lead che la scheda oggi non accetta (uno status che non si sceglie più, un fisso nel posto
        // del cellulare, …): l'unione non parte, e la frase nomina il campo.
        valueRefused: "La scheda oggi non accetta il valore di «{field}» dell'altro Lead: tieni quello del Lead che resta, oppure correggilo sulla scheda dell'altro Lead.",
        more: "Mostra altri",
        issuesCaption: "Telefoni ed email da sistemare",
        issueColumns: {
            lead: "Lead",
            field: "Campo",
            now: "Adesso",
            problem: "Problema",
            proposal: "Proposta",
            actions: "Azioni",
        },
        issueFields: {
            mobile: "Cellulare",
            landline: "Telefono fisso",
            secondMobile: "Cellulare del secondo titolare",
            email: "Email",
            secondHolderEmail: "Email del secondo titolare",
        },
        problems: {
            landline_in_mobile_slot: "È un fisso nel posto del cellulare",
            mobile_in_landline_slot: "È un cellulare nel posto del fisso",
            raw_now_valid: "Numero da verificare che ora si legge",
            length_out_of_range: "Numero troppo corto o troppo lungo",
            case_or_spaces: "Maiuscole o spazi",
            domain_typo: "Dominio scritto male",
            invalid: "Non sembra un'email",
        },
        moveTo: "Sposta in «{slot}» come {value}",
        verify: "Da verificare con il Lead",
        fix: "Correggi",
        fixAll: "Correggi tutte le proposte ({count})",
        fixAllConfirm: "Conferma: correggi {count}",
        fixAllWarning: "Controlla l'elenco: le correzioni restano nella Timeline di ogni Lead.",
        keep: "Tieni così",
        kept: "Lasciato com'è: non lo segnalo più.",
        fixed: "Corretto: {field} di {name}. Resta nella Timeline del Lead.",
        fixedMany: "Corretti {count} dati. Ogni correzione resta nella Timeline del suo Lead.",
        // Dopo `fixed` o `fixedMany`; da solo, quando non si è corretto nulla. Per uno solo, il singolare (decisione P41).
        // L'elenco si rilegge da sé dopo ogni correzione: «l'elenco è aggiornato» al posto di «ricarica l'elenco» del piano
        // (questione aperta 159).
        fixedSkipped: " {count} non si sono potuti correggere: l'elenco è aggiornato.",
        fixedSkippedOne: " 1 non si è potuto correggere: l'elenco è aggiornato.",
        noIssues: "Tutti i telefoni e le email sono in ordine.",
        openLead: "Apri il Lead",
    },
    // Impostazioni → Campi della scheda (piano M2 Task 20, mock-up `regole.html?sezione=campi`): le sezioni della scheda
    // con i loro campi, in una bozza che si pubblica con «Salva…». «Incasso mensile» non c'è finché la questione 52 è aperta.
    leadFields: {
        about: {
            title: "A cosa serve",
            text: "Decide com'è fatta la scheda del Lead in tutta {organization}: le sezioni e il loro ordine, quali campi ci sono e quali si vedono, e i campi dell'azienda, con il loro tipo e, per quelli a scelta, le voci.",
            whyTitle: "Perché sta nelle Impostazioni",
            why: "I campi dell'azienda sono le sue domande di qualificazione: servono a capire se un'azienda è in target e finiscono in filtri, colonne e Report. Un'altra azienda ne avrà di diversi. Li cambiano il Super admin e l'Admin, e ogni pubblicazione resta registrata.",
        },
        readOnly: "Li vedi soltanto: li cambiano il Super admin e l'Admin di {organization}.",
        readOnlyPlatform: "Sono regole di {organization}: le cambia il suo Super admin o il suo Admin, non il Super admin di Gioia365.",
        version: "Versione pubblicata: {version}.",
        section: {
            up: "Sposta su la sezione «{section}»",
            down: "Sposta giù la sezione «{section}»",
            visible: "Nella scheda",
            visibleNamed: "Sezione «{section}» nella scheda",
            locked: "Si vede sempre: serve almeno un telefono, il cellulare o il fisso.",
            caption: "Campi della sezione «{section}»",
            empty: "Nessun campo in questa sezione.",
        },
        table: {
            order: "Ordine",
            field: "Campo",
            type: "Tipo",
            options: "Voci",
            visible: "Nella scheda",
            more: "Altre azioni",
        },
        field: {
            up: "Sposta su: {field}",
            down: "Sposta giù: {field}",
            name: "Nome del campo: {field}",
            system: "campo di Gioia365",
            fromCity: "campo di Gioia365: viene dalla città, non si scrive",
            mobile: "campo di Gioia365: basta questo o il telefono fisso",
            landline: "campo di Gioia365: basta questo o il cellulare",
            secondHolder: "nome, cognome, cellulare ed email del secondo titolare: compaiono sulla scheda soltanto quando si aggiunge un secondo titolare",
            usedBy: "{count} Lead con un valore",
            usedByOne: "1 Lead con un valore",
            unused: "nessun Lead con un valore",
            isNew: "nuovo, non ancora salvato",
            visible: "Nella scheda",
            visibleNamed: "Nella scheda: {field}",
            always: "Sempre",
            typeLabel: "Tipo di «{field}»",
            typeLocked: "non si cambia: ci sono valori",
            sectionLabel: "Sezione di «{field}»",
            archive: "Archivia",
            archiveNamed: "Archivia «{field}»",
            removeNew: "Togli",
            removeNewNamed: "Togli il campo nuovo «{field}»",
        },
        types: {
            number: "Numero",
            currency_eur: "Euro",
            choice: "Scelta da un elenco",
            text: "Testo",
        },
        typesInText: {
            number: "numero",
            currency_eur: "euro",
            choice: "scelta da un elenco",
            text: "testo",
        },
        option: {
            name: "Voce «{option}» di «{field}»",
            selectable: "Si sceglie",
            selectableNamed: "«{option}» di «{field}» si sceglie",
            hidden: "nascosta",
            remove: "Togli la voce «{option}»",
            newLabel: "Nuova voce per «{field}»",
            add: "Aggiungi",
            addNamed: "Aggiungi la voce a «{field}»",
            none: "Nessuna voce.",
        },
        add: "Nuovo campo",
        notes: {
            type: "Il tipo di un campo si cambia soltanto finché nessun Lead ha un valore nel campo, contando anche i Lead archiviati o uniti a un altro: dopo rovinerebbe i dati già scritti.",
            options: "Una voce scelta da un Lead non si toglie: si nasconde, e resta sui Lead che l'hanno.",
            hidden: "Un campo nascosto o archiviato non cancella i dati: i valori dei Lead restano salvati. Un campo archiviato esce dalla scheda.",
            phones: "Cellulare e Telefono fisso sono sempre nella scheda, con la loro sezione: un Lead ha bisogno di almeno un telefono, il cellulare o il fisso, e la scheda deve poter mostrare quello che ha.",
        },
        archived: {
            title: "Campi archiviati",
            text: "Sono fuori dalla scheda, e i valori che i Lead avevano restano salvati.",
            item: "{field} · {usedBy}",
            pending: "si archivia quando salvi",
        },
        outside: {
            title: "Campi fuori dalla scheda",
            text: "Ci sono, ma la scheda non li mostra.",
            sectionLabel: "Metti «{field}» nella sezione",
            choose: "Scegli la sezione",
        },
        create: {
            title: "Nuovo campo",
            name: "Nome del campo",
            type: "Tipo",
            typeHint: "Il tipo si sceglie adesso: dopo si cambia soltanto finché nessun Lead ha un valore.",
            section: "Sezione",
            options: "Voci, una per riga",
            optionsHint: "Per esempio: Nessuno, Agenda di carta, Excel. Altre voci si aggiungono anche dopo.",
            cancel: "Annulla",
            submit: "Aggiungi il campo",
            errors: {
                name: "Scrivi il nome del campo.",
                nameTaken: "C'è già un campo con questo nome.",
                options: "Scrivi almeno una voce, una per riga.",
                optionsRepeated: "Due voci hanno lo stesso nome.",
                tooManyOptions: "Al massimo {max} voci.",
                optionTooLong: "Ogni voce ha al massimo {max} caratteri.",
            },
        },
        // Le modifiche di una bozza a parole, per «Cosa cambia per il team»: ogni frase è una modifica.
        changes: {
            sectionOrder: "L'ordine delle sezioni diventa: {order}.",
            sectionHidden: "La sezione «{section}» non si vede più nella scheda: i dati restano.",
            sectionShown: "La sezione «{section}» torna nella scheda.",
            fieldOrder: "Cambia l'ordine dei campi in «{section}».",
            created: "Nuovo campo «{field}» ({type}) nella sezione «{section}».",
            createdChoice: "Nuovo campo «{field}» ({type}: {options}) nella sezione «{section}».",
            renamed: "«{before}» si chiama «{after}».",
            retyped: "«{field}» diventa un campo di tipo {type}.",
            retypedDropsOptions: "«{field}» diventa un campo di tipo {type}: le sue voci se ne vanno.",
            optionAdded: "«{field}»: nuova voce «{option}».",
            optionRenamed: "«{field}»: la voce «{before}» si chiama «{after}».",
            optionHidden: "«{field}»: la voce «{option}» non si sceglie più, e resta sui Lead che l'hanno.",
            optionShown: "«{field}»: la voce «{option}» si sceglie di nuovo.",
            movedTo: "«{field}» passa nella sezione «{section}».",
            fieldHidden: "«{field}» non si vede più nella scheda: i dati restano.",
            fieldShown: "«{field}» torna nella scheda.",
            enteredHidden: "«{field}» entra nella scheda nascosto: non si vede finché non torna «Nella scheda».",
            archived: "«{field}» si archivia: esce dalla scheda e i valori dei Lead restano salvati.",
        },
        problems: {
            noName: "Ogni campo ha bisogno di un nome.",
            sameName: "Due campi si chiamano «{field}»: dai a ognuno un nome diverso.",
            noOptions: "Il campo a scelta «{field}» ha bisogno di almeno una voce.",
            noOptionName: "Ogni voce di «{field}» ha bisogno di un nome.",
            sameOption: "Due voci di «{field}» si chiamano «{option}».",
        },
        saved: "Pubblicato: la scheda dei Lead cambia per tutta l'azienda.",
        conflict: "Qualcun altro ha pubblicato i campi della scheda mentre li cambiavi. La pagina adesso parte dalla versione nuova, con sopra le tue modifiche: controllale e salva di nuovo.",
        errors: {
            typeInUse: "Il tipo di «{field}» resta {type}: {count} Lead hanno un valore in quel campo, contando anche quelli archiviati o uniti a un altro.",
            typeInUseOne: "Il tipo di «{field}» resta {type}: 1 Lead ha un valore in quel campo, contando anche quelli archiviati o uniti a un altro.",
        },
    },
    // Impostazioni → Chi vede i Lead (piano M2 Task 20, mock-up `regole.html?sezione=perimetro`): «Tutti i Lead» oppure
    // «Soltanto i suoi» per i ruoli di livello 1; «misto» quando non sono d'accordo (questione aperta 72).
    leadVisibility: {
        about: {
            title: "A cosa serve",
            text: "Decide quali Lead vede un Commerciale, cioè chi usa Gioia365 con il ruolo User o con un ruolo copiato da lui: tutti i Lead di {organization}, oppure soltanto quelli affidati a lui, di cui è owner.",
            whyTitle: "Perché sta nelle Impostazioni",
            why: "L'owner è la persona a cui è affidato il Lead, e resta quella anche se un collega lo chiama. Chi guida il team (Super user, Admin e Super admin) vede sempre tutti i Lead. La scelta la fanno il Super admin e l'Admin.",
        },
        readOnly: "La vedi soltanto: la scelgono il Super admin e l'Admin di {organization}.",
        readOnlyPlatform: "È una regola di {organization}: la sceglie il suo Super admin o il suo Admin, non il Super admin di Gioia365.",
        title: "I Lead che vede un Commerciale",
        legend: "Chi vede i Lead",
        all: "Tutti i Lead dell'azienda: ognuno vede, chiama e aggiorna anche i Lead affidati ai colleghi, che restano loro",
        own: "Soltanto i suoi: ognuno vede i Lead di cui è owner",
        appliesTo: "Vale per lo User e per i ruoli copiati da lui: chi guida il team vede sempre tutti i Lead.",
        note: "Vale per tutta l'azienda: nell'elenco Lead, nelle Smart List e nei Task. In «Ruoli e permessi» la riga «Lead → Vedere» di questi ruoli segue questa scelta.",
        mixed: "Oggi i Commerciali non vedono tutti allo stesso modo: un ruolo è stato cambiato in «Ruoli e permessi», oppure un ruolo non vede nessun Lead. Scegli una delle due e salva per allinearli; un ruolo che non vede nessun Lead resta com'è.",
        stillMixed: "Salvato. Un ruolo che non vede nessun Lead è rimasto com'era, quindi qui resta «misto».",
        saved: "Salvato: vale per tutta l'azienda dalla prossima pagina che si apre.",
        changes: {
            all: "I Commerciali vedono tutti i Lead dell'azienda, anche quelli affidati ai colleghi.",
            own: "Ogni Commerciale vede soltanto i Lead di cui è owner.",
        },
    },
    // La sezione «Sequenza di chiamate» della scheda Lead (piano M5, Task 12; D8, D16): la riga, le caselle con la legenda, i comandi
    // e «Prossimo passo», con le parole della guida della sequenza e di `sequenceLine` e `renderProtocol` del mock-up alla lettera.
    // «Lead successivo» con un tentativo da finire usa le parole della cascata (`dialer.attemptPending`, ruling Q50). Le parole di un
    // motivo di fine («numero errato», «chiamate bloccate», «unito a un doppione») e di come ha risposto il Lead vengono dal mock-up;
    // «tutti i tentativi senza risposta» nella Timeline è una proposta (questione 269).
    callSequence: {
        title: "Sequenza di chiamate",
        lineAttempt: "Sequenza: tentativo {n} di {total} · {judged}",
        lineWithVerdict: "{line} · {verdict}",
        judgedNew: "Lead nuovo",
        judgedStarted: "appena iniziata",
        judgedRestarted: "ripartita da capo",
        respected: "rispettata ✓",
        violated: "non rispettata: {reason}",
        endAnswered: "Sequenza: finita al tentativo {n} · il Lead ha risposto",
        endStopped: "Sequenza: fermata a mano",
        endWhatsapp: "Sequenza: finita · il Lead ha risposto su WhatsApp",
        endCalledBack: "Sequenza: finita · il Lead ha richiamato",
        endManualOther: "Sequenza: finita · il Lead ha risposto",
        endBlocked: "Sequenza: fermata al tentativo {n} · {reason}",
        endArchived: "Sequenza: finita · Lead archiviato",
        endMerged: "Sequenza: finita · unito a un doppione",
        endExhausted: "Sequenza: finita, {total} tentativi senza risposta",
        endWords: {
            booked: "appuntamento prenotato",
            answered: "il Lead ha risposto",
            answered_callback: "il Lead ha richiamato",
            answered_whatsapp: "il Lead ha risposto su WhatsApp",
            answered_manually: "il Lead ha risposto",
            wrong_number: "numero errato",
            blocked_status: "chiamate bloccate",
            exhausted: "tutti i tentativi senza risposta",
            stopped_manually: "fermata a mano",
            archived: "Lead archiviato",
            merged: "unito a un doppione",
        },
        legendLabel: "Legenda delle chiamate",
        // Le parole delle caselle di SEQ-7: «Saltata» una chiamata del tentativo non fatta, «Fermata con motivo» quelle dopo una fine
        // che non è una risposta (a mano, numero errato, status che blocca, archivio, unione).
        legend: { due: "Da fare", now: "Adesso", done: "Fatta", answered: "Ha risposto", not_needed: "Non serve più", not_made: "Saltata", stopped: "Fermata con motivo" },
        attempt: "Tentativo {n}",
        attemptNow: "Tentativo {n} · adesso",
        box: "Chiamata {number} · tentativo {attempt}: {state}",
        boxAt: "Chiamata {number} · tentativo {attempt}: {state}, {at}",
        stop: "Ferma la sequenza",
        stopAsk: "Fermi la sequenza?",
        stopYes: "Sì, fermala",
        stopNo: "No",
        restart: "Riparti con la sequenza",
        answered: "Il Lead ha risposto",
        answeredAsk: "Come ha risposto il Lead?",
        answeredHow: { whatsapp: "Su WhatsApp", called_back: "Ha richiamato", other: "In un altro modo" },
        answeredHowWords: { whatsapp: "su WhatsApp", called_back: "ha richiamato", other: "in un altro modo" },
        reasons: {
            first_call_late: "prima chiamata in ritardo, dopo {duration}",
            first_call_late_after_opening: "prima chiamata in ritardo, {duration} dopo l'apertura delle {time}",
            first_call_missing: "prima chiamata in ritardo: nessuna chiamata dopo {duration}",
            first_call_missing_since: "prima chiamata in ritardo: nessuna chiamata da {halfDay}",
            half_day_missed: "{halfDay} nessun tentativo",
            attempt_short: "al tentativo {n} {calls} su {required}",
        },
        callsWord: { none: "nessuna chiamata", one: "una chiamata", many: "{count} chiamate" },
        halfDay: { morning: "mattina", afternoon: "pomeriggio" },
        halfDayWords: "{day} {halfDay}",
        duration: { minute: "1 minuto", minutes: "{count} minuti", hour: "un'ora", hours: "{count} ore", withMinutes: "{hours} e {minutes}" },
        nextStepAttempt: "Chiamata della sequenza · tentativo {n} di {total} · {when}",
        // Il richiamo aperto viene prima del tentativo (piano M5, Task 16; mock-up: «Richiamo · {quando}»).
        nextStepCallback: "Richiamo · {when}",
        whenNow: "adesso",
        seeInTimeline: "Vedi nella Timeline",
    },
    // «Richiama dopo», «Scegli quando richiamare» e «Richiamo» (piano M5, Task 17, D13, D16; mock-up `scheda-lead.html`): le parole
    // del brief alla lettera. `invalid` sono i motivi di `422 callback_slot_invalid` (`details.reason`), uno per codice.
    callbacks: {
        title: "Richiama dopo",
        agreed: "Concordato con il Lead",
        agreedHint: "Spuntala se l'orario l'avete deciso insieme: il richiamo avrà l'orologio e all'ora compare un avviso.",
        soon: "Tra qualche ora",
        days: "Nei prossimi giorni",
        custom: "Altro giorno e ora",
        customDay: "Giorno",
        customTime: "Ora",
        save: "Fissa il richiamo",
        step: "Scegli quando richiamare",
        stepOpen: "Scegli l'orario",
        stepDone: "Richiamo fissato per {when}",
        later: "Richiama dopo",
        headerButton: "Richiamo",
        exists: "C'è già un richiamo per {when}: lo sposti?",
        existsNoMove: "C'è già un richiamo per {when}.",
        move: "Sposta",
        saved: "Richiamo fissato per {when}.",
        // Le parole dei blocchi e dei giorni del mock-up (`mockup.js`, `renderCallbackOptions`; D16): «+30 min», «+1 h», «+1 h 30»; un
        // blocco in un altro giorno con il giorno della settimana abbreviato («gio 09:00»); i giorni con il nome e la data in numeri
        // («Domani, giovedì 08/10/2026», «Venerdì 09/10/2026»), dai nomi dei giorni del calendario (questione 327).
        preset: { minutes: "+{minutes} min", hours: "+{hours} h", hoursHalf: "+{hours} h 30" },
        otherDay: "{weekday} {time}",
        weekdayShort: { "1": "lun", "2": "mar", "3": "mer", "4": "gio", "5": "ven", "6": "sab", "7": "dom" },
        tomorrow: "Domani, {weekday} {date}",
        dayTitle: "{weekday} {date}",
        invalid: {
            past: "L'orario è già passato.",
            closed_day: "Quel giorno l'azienda è chiusa.",
            outside_hours: "I richiami si fissano fra le {from} e le {to}.",
            not_quarter: "Scegli un orario a quarti d'ora.",
            too_far: "Troppo lontano: scegli un giorno più vicino.",
        },
    },
    // «Registra attività» (piano M5, Task 19, D15; mock-up `scheda-lead.html`): la telefonata fatta fuori dal CRM. Le parole del brief
    // alla lettera; l'esito in due passi, gli appunti e i loro motivi sono quelli della postazione (`callDesk.*`). `invalid` sono i
    // motivi di `422 manual_call_invalid` (`details.reason`), uno per codice; `minutesInvalid` è nuova (questione 334).
    manualCall: {
        button: "Registra attività",
        title: "Telefonata fuori dal CRM",
        intro: "Una chiamata fatta dal cellulare o da un altro telefono: resta segnata come inserita a mano, con il tuo nome.",
        day: "Giorno",
        time: "Ora",
        minutes: "Minuti di conversazione",
        phone: "Numero chiamato",
        save: "Registra",
        saved: "Telefonata registrata: la trovi nella Timeline, inserita a mano.",
        minutesInvalid: "Scrivi i minuti di conversazione, da 0 a 240.",
        invalid: { future: "L'ora è nel futuro.", before_lead: "Il Lead non c'era ancora." },
    },
    // «Le cose da fare» (piano M5, Task 18; mock-up `task.html` e guida dei Task; D16): le parole del brief e del mock-up alla
    // lettera. «Quali Task» (il nome del gruppo delle schede), «Azione» (la colonna dei pulsanti, letta soltanto dagli screen reader)
    // e «Mostra altri» vengono dal mock-up e dagli Archiviati.
    tasks: {
        title: "Le cose da fare",
        todayCount: "{count} oggi",
        views: { today: "Oggi", overdue: "Scaduti", upcoming: "Prossimi giorni", done: "Completati" },
        viewsLabel: "Quali Task",
        columns: {
            when: "Quando",
            what: "Cosa",
            lead: "Lead",
            city: "Città",
            status: "Status",
            latestCall: "Ultima chiamata",
            assignee: "Assegnato a",
            owner: "Owner",
            action: "Azione",
        },
        whatCallback: "Richiamo · {when}",
        agreed: "concordato",
        overdue: "scaduta",
        priorityHigh: "Priorità alta",
        who: "Di chi",
        wholeTeam: "Tutto il team",
        kind: "Cosa",
        kinds: { all: "Tutto", calls: "Telefonate" },
        sort: "Ordina",
        sorts: { due: "Come vanno fatti", priority: "Priorità", lead: "Lead dalla A alla Z", status: "Status" },
        call: "Chiama",
        open: "Apri",
        backToTasks: "Torna ai Task",
        // «Inizia a chiamare» dai Task (piano M5, Task 21; mock-up `task.html`): le parole del brief alla lettera; il pulsante, «Riprendi a
        // chiamare», «Ricomincia da capo» e «Torna ai Task» riusano le chiavi che hanno già lo stesso testo (ruling Q50). Il singolare di
        // `from` e il titolo del numero accanto al nome (dal mock-up) sono nella questione 339.
        start: {
            from: "Chiami {count} telefonate in cascata, da {lead}.",
            fromOne: "Chiami 1 telefonata in cascata, da {lead}.",
            offView: "La cascata parte da «Oggi» o da «Scaduti».",
            offEmpty: "Nessuna telefonata da fare adesso.",
            teamWarning: "Chiameresti anche i Task dei colleghi.",
            position: "Posto {position} nella cascata",
            // La finestra di `smartLists.page.otherSession` per una cascata dai Task: il nome (`sourceText`) senza virgolette attorno.
            otherSession: "Hai una cascata in corso su {source}: la interrompi per chiamare da qui?",
        },
        doneNow: "Fatta adesso",
        doneAt: "{when} · {outcome}",
        empty: {
            today: "Niente da fare oggi.",
            overdue: "Nessun Task scaduto.",
            upcoming: "Nessun Task nei prossimi giorni.",
            done: "Nessun Task completato.",
        },
        emptyHint: "I richiami si fissano dalla postazione con «Richiama dopo» o dalla scheda con «Richiamo».",
        onlyManual: "Qui ci sono soltanto le cose prese a mano: le chiamate della sequenza si fanno dalle Smart List.",
        more: "Mostra altri",
        // Il banner all'ora del richiamo concordato (piano M5, Task 20; D14; mock-up `mockup.js`, `renderAlerts`), alla lettera. Senza
        // il salone la seconda frase comincia dall'ora (`textNoSalon`, questione 335: il mock-up ha sempre il salone).
        banner: {
            title: "Sono le {time}: richiamo con {lead}",
            text: "{salon}, fissato per le {time}. L'avete deciso insieme: il banner resta finché non chiami.",
            textNoSalon: "Fissato per le {time}. L'avete deciso insieme: il banner resta finché non chiami.",
            call: "Chiama adesso",
            open: "Apri i Task",
            label: "Richiami concordati con l'ora arrivata",
            announce: "È l'ora del richiamo concordato con {lead}, fissato per le {time}.",
        },
    },
    // «Conversazioni» (piano M4, Task 19, D14; mock-up `conversazioni.html` e `initConversations` di `mockup.js`): le parole del
    // mock-up alla lettera (dal piano M6, R3, passo 12b, anche «e i WhatsApp» dell'introduzione, con la scheda «WhatsApp»). I periodi
    // sono quelli di SEZ-3, più «Tutte»: «Settimana» è oggi e i 6 giorni prima, «Mese» oggi e i 29 giorni prima (decisione del 28
    // settembre 2026), «Personalizzato» chiede «Dal» e «Al»; sotto, i giorni del periodo. «Mostra altre telefonate», la scadenza
    // dell'audio e i due perché degli appunti sono proposte della questione 213.
    conversations: {
        title: "Le conversazioni",
        // Con la scheda «WhatsApp» (piano M6, R3, passo 12b) la frase intera del mock-up (`conversazioni.html`).
        intro: "Le telefonate, con la registrazione da ascoltare e gli appunti, i WhatsApp e le email. Sono gli stessi eventi della Timeline di ogni Lead.",
        tabsLabel: "Cosa vedere",
        calls: "Telefonate",
        whatsappTab: "WhatsApp",
        emailTab: "Email",
        periodLabel: "Periodo",
        periods: { today: "Oggi", yesterday: "Ieri", last7: "Settimana", last30: "Mese", custom: "Personalizzato", all: "Tutte" },
        fromDay: "Dal",
        toDay: "Al",
        periodDays: "Dal {from} al {to}",
        periodDay: "Il {day}",
        who: "Di chi",
        wholeTeam: "Tutto il team",
        direction: "Direzione",
        all: "Tutte",
        outbound: "In uscita",
        inbound: "In entrata",
        outcome: "Esito",
        anyone: "Tutti",
        ownerThen: "Owner allora",
        recording: "Registrazione",
        // Le voci di «Registrazione»: le parole di `REC_TEXT` del mock-up fino ai due punti.
        recordingFilters: {
            available: "Da ascoltare",
            processing: "In preparazione",
            expired: "Audio scaduto",
            missing: "Nessuna registrazione",
            error: "Registrazione non riuscita",
            none: "Senza risposta",
        },
        audioOnly: "Solo audio ascoltabile",
        search: "Cerca un Lead o un'azienda target",
        caption: "Le telefonate del periodo, le più recenti in cima",
        columns: {
            when: "Quando",
            lead: "Lead",
            direction: "Direzione",
            outcome: "Esito",
            duration: "Durata",
            caller: "Chi ha chiamato",
            ownerThen: "Owner allora",
            recording: "Registrazione",
            action: "Azione",
        },
        manual: "inserita a mano",
        liveDuration: "in corso",
        ownerToday: "oggi: {name}",
        notesOne: "1 appunto",
        notesMany: "{count} appunti",
        listen: "Ascolta",
        open: "Apri",
        closeRow: "Chiudi",
        notesTitle: "Appunti sulla chiamata",
        noNotes: "Nessun appunto.",
        addNote: "Aggiungi un appunto",
        saveNote: "Salva l'appunto",
        savingNote: "Salvo l'appunto…",
        noteRequired: "Scrivi l'appunto prima di salvarlo.",
        noteSaved: "Appunto salvato: lo vedi anche nella Timeline del Lead.",
        openLead: "Apri il Lead",
        noteHint: "Un appunto salvato non si modifica e non si cancella: resta con il tuo nome e l'orario, anche nella Timeline del Lead.",
        manualHint: "Chiamata inserita a mano dopo averla fatta dal cellulare: conta nei numeri e resta riconoscibile.",
        expiresAt: "L'audio resta fino al {when}: poi restano la chiamata e gli appunti.",
        notesReadOnly: "Puoi leggere gli appunti, ma per aggiungerne uno serve poter modificare il Lead.",
        leadOutOfSight: "Questo Lead adesso è fuori dai Lead che vedi: non lo apri e non gli aggiungi appunti.",
        empty: "Nessuna telefonata con questi filtri.",
        emptyHint: "Cambia il periodo o i filtri, o togli «Solo audio ascoltabile».",
        more: "Mostra altre telefonate",
        // La scheda «WhatsApp» (piano M6, R3, passo 12b; mock-up `conversazioni.html?vista=whatsapp` e `mockup.js`, `WA_LOG`,
        // `WA_CHANNEL_TEXT`, `renderWhatsapp`, `waStateText`): le parole alla lettera. Sono parole nuove (questione 424) «Solo da leggere»
        // (il filtro «Da leggere», controllo preliminare A29), «Preparato» (un messaggio soltanto preparato non è «Inviato»), «Segna tutti
        // come letti» senza il numero (quando la lista ha altre pagine e il numero non si sa), «Mostra altri WhatsApp» e le parole del
        // numero accanto a «Conversazioni» per gli screen reader; «Numero non in Gioia365» è della questione 357.
        whatsapp: {
            unreadOnly: "Solo da leggere",
            caption: "I WhatsApp del periodo, i più recenti in cima",
            note: "Le risposte dei Lead arrivano qui soltanto con il WhatsApp ufficiale. Con WhatsApp Agile e con il modo manuale le risposte restano sul WhatsApp del Commerciale.",
            columns: {
                when: "Quando",
                lead: "Lead",
                what: "Cosa",
                message: "Messaggio",
                channel: "Con quale WhatsApp",
                state: "Stato",
                person: "Di chi",
                action: "Azione",
            },
            outbound: "Inviato",
            prepared: "Preparato",
            quoted: "«{text}»",
            template: "Modello «{name}»",
            channels: { meta: "WhatsApp ufficiale", agile: "WhatsApp Agile", manual: "A mano" },
            declaredBy: "Dichiarato inviato da {name}",
            unknownNumber: "Numero non in Gioia365",
            reply: "Rispondi",
            markAll: "Segna tutti come letti ({count})",
            markAllUnknown: "Segna tutti come letti",
            markAllHint: "Quelli da leggere che vedi qui, con questi filtri.",
            markedAll: "WhatsApp segnati come letti.",
            empty: "Nessun WhatsApp con questi filtri.",
            emptyHint: "Cambia il periodo.",
            more: "Mostra altri WhatsApp",
            unreadOne: "1 WhatsApp da leggere",
            unreadMany: "{count} WhatsApp da leggere",
        },
        // La scheda «Email» (piano dell'ingresso del 12 ottobre 2026, I5, D5): gli eventi delle email di GoHighLevel dei Lead, con le parole
        // della Timeline; parole nuove, come la nota sulle aperture (le anteprime automatiche dei programmi di posta).
        email: {
            caption: "Gli eventi delle email del periodo, i più recenti in cima",
            note: "Le email le manda GoHighLevel: qui arrivano consegne, aperture, clic, rimbalzi, segnalazioni di spam, disiscrizioni e risposte. Un'apertura può essere l'anteprima automatica di un programma di posta.",
            columns: { when: "Quando", lead: "Lead", event: "Evento", subject: "Oggetto" },
            quoted: "«{text}»",
            link: "Link:",
            empty: "Nessun evento delle email con questi filtri.",
            emptyHint: "Cambia il periodo.",
            more: "Mostra altri eventi delle email",
        },
    },
    // I WhatsApp (piano M6, R1): `dayAndTime` è il valore di `{giorno e ora}` nei modelli, scritto nella lingua dell'azienda dal
    // server che prepara il messaggio e dalla finestra che ne mostra l'anteprima: il giorno della settimana, la data e l'ora in numeri
    // nel fuso dell'azienda, come nel mock-up («venerdì 25/09/2026 alle 10:00»).
    whatsapp: {
        dayAndTime: "{weekday} {date} alle {time}",
        // La conferma che Gioia365 manda da sé al Lead che ha scritto «STOP» (piano M6, R3, passo 11b; questioni 394 e 420), nella lingua
        // dell'azienda, dal numero che ha ricevuto lo «STOP» e senza la riga «scrivi STOP»: il testo della questione 394.
        stopConfirmation: "Fatto: non riceverai più messaggi da {organization}.",
        // «WhatsApp» nella testata della scheda (piano M6, R1, Task 4a; ruling B5): spento, dice sempre perché. Le parole dello status
        // che blocca, del numero errato e di «Non inviare WhatsApp» sono quelle del mock-up (`mockup.js`); le altre seguono quelle di
        // «Chiama» (`callDesk.reasons`) e sono proposte, come il Lead senza cellulare e il numero che non è internazionale.
        button: "WhatsApp",
        reasons: {
            do_not_contact: "WhatsApp bloccato: status «{status}».",
            wrong_number: "WhatsApp fermo: il numero è errato. Correggi il cellulare per scrivere al Lead.",
            no_mobile: "WhatsApp fermo: il Lead non ha un cellulare. Aggiungilo nei dati per scrivergli.",
            whatsapp_opt_out: "Non inviare WhatsApp è acceso: il Lead ha chiesto di non ricevere messaggi. Le chiamate restano.",
            no_feature: "Il tuo ruolo non può mandare WhatsApp: lo decide chi gestisce i ruoli e i permessi.",
            not_editable: "Puoi soltanto guardare questo Lead: per scrivergli serve poterlo modificare.",
            commercial_view: "Durante «Guarda come…» non si mandano WhatsApp: esci dalla vista per scrivere.",
            platform_context: "Come Super admin di Gioia365 non scrivi da qui: si scrive con un'appartenenza all'azienda.",
            invalid_number: "Il cellulare del Lead non è un numero internazionale: correggilo nei dati per scrivergli.",
            // «Rispondi su WhatsApp» con un testo libero dopo le 24 ore (piano M6, R3, passo 12a; `409 whatsapp_blocked`): la frase del
            // mock-up (`mockup.js`, la finestra della risposta), alla lettera.
            outside_service_window: "Sono passate più di 24 ore dal suo ultimo messaggio: Meta permette soltanto un modello approvato.",
        },
        // La finestra (mock-up `scheda-lead.html`, `#m-whatsapp`, e `mockup.js`): le parole alla lettera; i campi che mancano, il testo
        // troppo lungo, l'attesa e il testo registrato diverso da quello aperto sono proposte.
        dialog: {
            title: "WhatsApp a {names}",
            twoNames: "{first} o {second}",
            to: "A chi scrivi",
            recipient: "{name} · {number}",
            template: "Modello · i testi li scrive il Super admin in Impostazioni",
            preview: "Anteprima",
            text: "Messaggio · puoi ritoccarlo prima di inviarlo",
            empty: "Il messaggio è vuoto: scrivi qualcosa prima di inviarlo.",
            missing: "Completa il messaggio prima di aprire WhatsApp: per questo Lead non c'è un valore per {fields}.",
            tooLong: "Il messaggio è troppo lungo: al massimo {max} caratteri, con la riga in fondo.",
            manualNote: "Il pulsante apre WhatsApp Desktop sulla chat del Lead, con il messaggio già scritto: l'invio lo fai tu, premendo Invio.",
            open: "Apri WhatsApp",
            sentQuestion: "Hai inviato il messaggio?",
            sentHint: "Il CRM non vede cosa succede dentro WhatsApp: registra l'invio soltanto se lo confermi tu.",
            preparing: "Registro il messaggio preparato…",
            reopen: "Riapri WhatsApp",
            otherText: "Il testo registrato è diverso da quello aperto in WhatsApp: premi «Riapri WhatsApp» e manda quello registrato.",
            notSent: "No, non l'ho inviato",
            sent: "Sì, inviato",
            sentDone: "Registrato: WhatsApp dichiarato inviato.",
            notSentDone: "Nessun invio registrato: resta soltanto «WhatsApp preparato».",
            // Il WhatsApp ufficiale nella finestra (piano M6, R2, Task 9b; D2, D19; questioni 409, 413, 414; mock-up `mockup.js`, `waRoute` e
            // `syncWaMode`): «Invia il WhatsApp», la nota del WhatsApp ufficiale e i perché del ripiego a mano alla lettera (senza «Nel
            // mock-up non parte niente»); «Il WhatsApp ufficiale non è pronto: per ora a mano» è la frase di D2. Il canale spento, il modello
            // con un campo vuoto, gli stati di Meta che il mock-up non ha, l'invio in corso, l'esito (anche con l'avviso del tetto che ripete il
            // server), il rifiuto di Meta e l'avviso del tetto sono proposte (questione 409).
            send: "Invia il WhatsApp",
            officialNote: "Parte dal WhatsApp ufficiale, dal tuo numero {number}, con il modello approvato da Meta.",
            sending: "Mando il messaggio a Meta… Aspetta la risposta prima di chiudere la finestra.",
            sentToMeta: "Preso in carico da Meta: come va lo vedi nella Timeline.",
            sentToMetaCap: "Preso in carico da Meta: come va lo vedi nella Timeline. Oggi il Lead aveva già ricevuto {cap} WhatsApp o più.",
            metaRefused: "Meta non ha accettato il messaggio: il motivo è nella Timeline. Puoi mandarlo a mano con «Apri WhatsApp».",
            dailyCap: "Oggi il Lead ha già ricevuto {count} WhatsApp: al massimo {cap} al giorno alla stessa persona, per non far bloccare il numero. Puoi mandarlo lo stesso.",
            // WhatsApp Agile nella finestra (piano M6, R9, Task 27b; WA-5, WA-6, WA-7, WA-10): la nota del mock-up (`mockup.js`, `syncWaMode`,
            // senza «Nel mock-up non parte niente.»); l'invio in corso, l'esito «Preso in carico da WhatsApp Agile» (mai «consegnato»), il
            // messaggio che il fornitore non ha preso o di cui non si sa (può essere partito: prima di riscriverlo a mano si guarda la
            // Timeline) e il testo ritoccato con un campo da completare sono parole nuove.
            agileNote: "Parte da solo con WhatsApp Agile dal tuo numero {number}.",
            sendingAgile: "Mando il messaggio a WhatsApp Agile… Aspetta la risposta prima di chiudere la finestra.",
            sentToAgile: "Preso in carico da WhatsApp Agile: lo trovi nella Timeline.",
            // La stessa richiesta che torna mentre il fornitore non ha ancora risposto alla prima (revisione finale di R9, M1): né preso né no.
            queuedAtAgile: "In invio con WhatsApp Agile: l'esito lo trovi nella Timeline.",
            agileRefused: "WhatsApp Agile non ha preso in carico il messaggio, o non ha risposto: il motivo è nella Timeline. Prima di mandarlo a mano con «Apri WhatsApp», controlla lì che non sia partito.",
            missingSend: "Completa il messaggio prima di inviarlo: per questo Lead non c'è un valore per {fields}.",
            fallback: {
                senderNotReadyMeta: "Il tuo numero non è ancora registrato sul WhatsApp ufficiale: per ora si apre in WhatsApp Desktop.",
                senderNotReadyAgile: "Il tuo WhatsApp Agile non è collegato: per ora si apre in WhatsApp Desktop.",
                channelDisabledMeta: "La tua azienda non usa più il WhatsApp ufficiale: per ora si apre in WhatsApp Desktop.",
                channelDisabledAgile: "La tua azienda non usa più WhatsApp Agile: per ora si apre in WhatsApp Desktop.",
                templateNotApproved: "Il modello «{template}» non è ancora approvato da Meta ({status}): per ora si apre in WhatsApp Desktop.",
                missingValues: "Il modello «{template}» ha un campo senza valore per questo Lead: completalo nel messaggio, per ora si apre in WhatsApp Desktop.",
                notReady: "Il WhatsApp ufficiale non è pronto: per ora a mano.",
                // WhatsApp Agile al momento dell'invio (piano M6, R9): i numeri ammessi, il tetto, il ritmo del numero, il canale, il fornitore
                // (parole nuove: il mock-up non le ha).
                recipientNotAllowed: "Numero non ammesso nell'azienda di prova: il WhatsApp automatico non parte, per ora si apre in WhatsApp Desktop.",
                dailyCap: "Questo Lead ha già ricevuto oggi i {cap} WhatsApp del giorno: con WhatsApp Agile il prossimo non parte, per ora si apre in WhatsApp Desktop.",
                // Il tetto detto dal server (`409 whatsapp_daily_cap`) con il conteggio di oggi, quando il server l'ha letto (27b).
                dailyCapCount: "Oggi il Lead ha già ricevuto {count} WhatsApp: con WhatsApp Agile al massimo {cap} al giorno, quindi questo non parte. Per ora si apre in WhatsApp Desktop.",
                paced: "Dal tuo numero è partito un WhatsApp Agile da meno di 8 minuti: per ora si apre in WhatsApp Desktop.",
                // Il ritmo con l'ora del prossimo invio (`route.nextAt`, nel fuso dell'azienda; 27b).
                pacedAt: "Dal tuo numero è partito un WhatsApp Agile da meno di 8 minuti: il prossimo può partire alle {time}. Per ora si apre in WhatsApp Desktop.",
                channelDown: "Il tuo WhatsApp Agile non sta consegnando: va collegato di nuovo con il codice QR. Per ora si apre in WhatsApp Desktop.",
                providerUnreachable: "WhatsApp Agile non risponde in questo momento: per ora si apre in WhatsApp Desktop.",
            },
            metaStatus: {
                none: "da inviare",
                pending: "in revisione",
                rejected: "rifiutato",
                paused: "sospeso",
                disabled: "spento",
            },
        },
        // «Invia WhatsApp» dopo l'esito, nella postazione (piano M6, R1, Task 4b; ruling A4): il passo con il nome del modello proposto
        // e «· facoltativo», come nel mock-up (`mockup.js`, `flowStepLabel`), e il pulsante «Invia WhatsApp» della postazione, che apre la
        // finestra. `questionAny`, il passo finché i modelli dell'azienda non sono arrivati, è una proposta (questione 406).
        step: {
            question: "Invia il WhatsApp «{template}» · facoltativo",
            questionAny: "Invia un WhatsApp · facoltativo",
            open: "Invia WhatsApp",
        },
        // «Non inviare WhatsApp» sotto il cellulare (Task 4b; D25, questione 392; mock-up `scheda-lead.html` e `mockup.js`, pacchetto
        // #115): la riga, l'interruttore, i due avvisi e chi lo spegne alla lettera (senza «Nel mock-up: …»); chi lo accende, chi l'ha
        // acceso e quando sono proposte (questione 406).
        optOut: {
            row: "WhatsApp",
            label: "Non inviare WhatsApp",
            switchedOn: "Fatto: a questo Lead non partono più WhatsApp, con nessuno dei tre modi.",
            switchedOff: "Spento: il Lead torna a ricevere i WhatsApp.",
            onlyManagers: "Lo spengono un Super user, un Admin o il Super admin, quando il Lead chiede di nuovo i messaggi.",
            onlyEditors: "Lo accende chi può modificare questo Lead.",
            since: "Acceso il {when}.",
            sinceBy: "Acceso da {name} il {when}.",
        },
        // «Rispondi su WhatsApp» da «Conversazioni → WhatsApp» (piano M6, R3, passo 12b; questioni 419, 421 e 422; mock-up `mockup.js`, la
        // finestra `#m-wa-reply`): titolo, «A … dal WhatsApp ufficiale di …», «Il Lead ha scritto il …», «La tua risposta», «Modello
        // approvato da Meta», le due frasi delle 24 ore (`whatsapp.reasons.outside_service_window` è la seconda), «Invia» e «Scrivi la
        // risposta prima di inviarla.» alla lettera. Sono parole nuove (questione 424) la risposta dal proprio WhatsApp, il messaggio del
        // Lead che non è un testo, i perché del ripiego a mano quando il numero che ha ricevuto non è pronto (il mock-up non li ha), nessun
        // modello approvato e il telefono che non è più del Lead.
        reply: {
            title: "Rispondi su WhatsApp",
            to: "A {link}, dal WhatsApp ufficiale di {person}.",
            toManual: "A {link}, dal tuo WhatsApp.",
            wrote: "Il Lead ha scritto il {when}: «{text}»",
            wroteKind: "{kind} ({when})",
            text: "La tua risposta",
            withinWindow: "Ha scritto nelle ultime 24 ore: puoi rispondere con parole tue.",
            template: "Modello approvato da Meta",
            send: "Invia",
            required: "Scrivi la risposta prima di inviarla.",
            noApproved: "Sono passate più di 24 ore dal suo ultimo messaggio e nessun modello è ancora approvato da Meta: per ora si apre in WhatsApp Desktop.",
            numberGone: "Gioia365 non ha più il numero che ha ricevuto il messaggio: per ora si apre in WhatsApp Desktop.",
            numberNotReady: "Il numero di {person} non è pronto sul WhatsApp ufficiale: per ora si apre in WhatsApp Desktop.",
            numberOff: "Il numero di {person} non è più sul WhatsApp ufficiale: per ora si apre in WhatsApp Desktop.",
            phoneGone: "Il Lead ha scritto da un numero che non è più nella sua scheda: scrivigli dalla scheda del Lead.",
        },
    },
    // Impostazioni → «Sequenza di chiamate» (piano M5, Task 13; mock-up `regole.html?sezione=sequenza`): le parole del brief e del
    // mock-up alla lettera (D16). I problemi dei confini rispetto al calendario, l'avviso di sola lettura e il conflitto non sono nel
    // mock-up: sono proposte, come le altre parole di M5 senza mock-up (questione 269).
    callSequenceSettings: {
        title: "Sequenza di chiamate",
        about: "A cosa serve",
        aboutText: "Quante chiamate di fila fare a un Lead che non risponde, in quali mezze giornate, ed entro quanti minuti fare la prima: Gioia365 non obbliga il Commerciale, ma mostra se la regola è stata rispettata.",
        // Di partenza la regola è del Super admin (decisione del 28 settembre 2026, punto 3; ruling Q52, questione 317).
        readOnly: "La vedi soltanto: la cambia il Super admin di {organization}.",
        readOnlyPlatform: "È una regola di {organization}: la cambia il suo Super admin, non il Super admin di Gioia365.",
        attempts: "I tentativi",
        attempt: "Tentativo",
        attemptNumber: "Tentativo {n}",
        calls: "Chiamate di fila",
        callsOf: "Chiamate di fila nel tentativo {n}",
        callsOne: "1 chiamata",
        callsMany: "{count} chiamate",
        when: "Quando",
        whenFirst: "Entro {minutes} minuti da quando entra il Lead",
        whenNext: "La mezza giornata lavorativa dopo",
        remove: "Togli",
        addAttempt: "+ Aggiungi un tentativo",
        removeLast: "Togli l'ultimo tentativo",
        total: "{calls} chiamate in {days} giorni lavorativi",
        totalOneDay: "{calls} chiamate in 1 giorno lavorativo",
        totalOne: "1 chiamata in 1 giorno lavorativo",
        example: "Un Lead che entra adesso",
        exampleRow: "Tentativo {n}: {day} {halfDay}",
        exampleFirst: "Tentativo 1: {day} {halfDay}, prima chiamata entro le {time}",
        exampleDay: "{weekday} {date}",
        weekday: { "1": "lunedì", "2": "martedì", "3": "mercoledì", "4": "giovedì", "5": "venerdì", "6": "sabato", "7": "domenica" },
        halfDay: { morning: "mattina", afternoon: "pomeriggio" },
        halves: "Le mezze giornate",
        morningEnd: "La mattina finisce alle",
        afternoonStart: "Il pomeriggio comincia alle",
        fridayOne: "Il venerdì un tentativo solo, la mattina",
        halvesNote: "Inizio e fine della giornata vengono da «Calendario, fuso e lingua». Fra mattina e pomeriggio non parte nessuna chiamata della sequenza.",
        firstCall: "La prima chiamata",
        firstCallMinutes: "entro {minutes} minuti",
        cascade: "Nella cascata, prima di ogni chiamata",
        cascadeAfter: "Nella cascata, dopo ogni chiamata",
        countdown: "Aspetta",
        countdownNone: "niente, chiama subito",
        countdownSeconds: "{seconds} secondi",
        countdownHint: "In quei secondi il Commerciale guarda la scheda e può saltare il Lead prima che il telefono squilli.",
        // «Dopo la chiamata, passa al Lead successivo» (decisione del 9 ottobre 2026): le parole del product owner alla lettera; la riga
        // sotto la tendina è una proposta.
        advance: "Dopo la chiamata, passa al Lead successivo",
        advanceHint: "Il conto parte con «Chiudi la chiamata», dopo i passi obbligatori. Nella barra «Resta su questo Lead» lo ferma.",
        advanceNow: "Subito",
        advanceSeconds: "Dopo {seconds} secondi",
        advanceManual: "Lo passo io",
        // «Senza risposta, richiama da solo…» (decisione dell'11 ottobre 2026): le parole del product owner alla lettera; la riga sotto
        // la casella è una scelta di Claude.
        autoRedial: "Senza risposta, richiama da solo fino alle chiamate di fila del tentativo",
        autoRedialHint: "Una chiamata senza risposta (squillo a vuoto o occupato) la segna Gioia365 «Nessuna risposta» e richiama lo stesso Lead dopo i secondi prima della chiamata, finché il tentativo non ha le sue chiamate di fila. «Lead successivo» passa oltre prima.",
        // «Senza contatto, la sequenza riparte da capo dopo» (SEQ-14, decisione dell'11 ottobre 2026: i 14 giorni lavorativi sono del
        // product owner; l'etichetta, le altre voci e la riga sotto sono scelte di Claude).
        restart: "Senza contatto, la sequenza riparte da capo dopo",
        restartDays: "{days} giorni lavorativi",
        restartNever: "Mai",
        restartHint: "Vale per le sequenze finite senza risposta dopo tutti i tentativi: contano i giorni lavorativi del calendario dell'azienda, chiusure escluse.",
        saved: "Regola salvata: vale per le sequenze che partono da adesso.",
        conflict: "Nel frattempo qualcuno ha cambiato le impostazioni dell'azienda: la pagina adesso parte dalla regola salvata, con sopra le tue modifiche. Controllale e salva di nuovo.",
        problems: {
            afternoonBeforeMorning: "Il pomeriggio deve cominciare quando finisce la mattina, o dopo.",
            dayInsidePause: "Nella pausa fra mattina e pomeriggio cade tutto l'orario {day} ({start}–{end}): sposta la fine della mattina o l'inizio del pomeriggio.",
        },
        changes: {
            attempts: "I tentativi passano da {before} a {after}.",
            newAttempt: "Nuovo tentativo {n}: {calls}, la mezza giornata dopo.",
            attemptCalls: "Tentativo {n}: {after} chiamate di fila invece di {before}.",
            morningEnd: "La mattina finisce alle {after} invece che alle {before}.",
            afternoonStart: "Il pomeriggio comincia alle {after} invece che alle {before}.",
            firstCall: "La prima chiamata va fatta entro {after} minuti da quando entra il Lead, invece di {before}.",
            fridayOneOn: "Il venerdì la sequenza ha un tentativo solo, la mattina.",
            fridayOneOff: "Il venerdì la sequenza ha due tentativi, mattina e pomeriggio, come gli altri giorni.",
            countdown: "Nella cascata, prima di ogni chiamata: {after} invece di {before}.",
            countdownNone: "nessuna attesa",
            advance: "Dopo la chiamata, il Lead successivo: {after} invece di {before}.",
            advanceNow: "subito",
            advanceSeconds: "dopo {seconds} secondi",
            advanceManual: "«lo passo io»",
            autoRedial: "Senza risposta, richiama da solo: {after} invece di {before}.",
            yes: "sì",
            no: "no",
            restart: "Senza contatto, riparte dopo: {after} invece di {before}.",
            restartDays: "{days} giorni lavorativi",
            restartNever: "«mai»",
        },
    },
    // Impostazioni → «Invio dei WhatsApp» (piano M6, R1, Task 5a; D2; questioni 391, 403, 404, 405; mock-up `whatsapp.html` e
    // `mockup.js`, `initWaChannel`, `bindWaSetup` e la cella «WhatsApp» del Team): le parole del mock-up alla lettera, con Gioia365
    // al posto di Gioia360 e il nome dell'azienda al posto di «Academy», senza articolo (come in `team`), e senza «Nel mock-up …».
    // Sono proposte (questione 406): «Arriva con il prossimo rilascio» (questione 404), «Nessun numero» per il segno vuoto, il nome
    // di «Imposta» per chi legge lo schermo, i due conflitti di versione e la colonna del Team che non si legge. `dialog.notUsed` è il
    // titolo del mock-up per una scelta che l'azienda non usa, con «in cima a «Invio dei WhatsApp»» perché la finestra si apre anche
    // dal Team. Il riquadro «Business
    // Manager di Meta», la registrazione su Meta e il codice QR arrivano con R2 e R9.
    whatsappSendingSettings: {
        title: "Come si mandano i WhatsApp",
        about: "A cosa serve",
        aboutText: "Qui si decide, per ogni Commerciale, quale WhatsApp usa e da quale numero partono i suoi messaggi. Le possibilità sono tre: il WhatsApp ufficiale di Meta, il consigliato; WhatsApp Agile, come in GioiaFlow; oppure a mano, da WhatsApp Desktop.",
        whoDecidesTitle: "Chi decide",
        whoDecides: "Il Super admin dell'azienda o il Super admin di Gioia365, che imposta anche il WhatsApp per il Commerciale: i Commerciali non devono collegare niente. Ogni modifica resta nel registro Attività con autore e orario.",
        readOnly: "Quale WhatsApp usa ogni persona lo decidono e lo impostano Super user, Admin e Super admin dell'azienda, o il Super admin di Gioia365: tu non devi collegare niente.",
        // I tre WhatsApp (`WA_KINDS`): il nome, il segno accanto, la riga della pagina, quella della finestra «Imposta» e il nome breve
        // della cella del Team.
        channels: {
            meta: {
                label: "WhatsApp ufficiale di Meta",
                tag: "consigliato",
                text: "Il messaggio parte dal numero registrato sul WhatsApp ufficiale di Meta, con i modelli approvati da Meta. Gioia365 sa se è consegnato e letto, e le risposte del Lead arrivano nel CRM.",
                choice: "Numero registrato su Meta, modelli approvati da Meta, consegna e lettura visibili, risposte nel CRM.",
                short: "Ufficiale",
            },
            agile: {
                label: "WhatsApp Agile",
                tag: "come in GioiaFlow",
                text: "Il messaggio parte da solo dal numero collegato con il codice QR, con lo stesso sistema di GioiaFlow. Il testo si ritocca prima di inviare; Gioia365 sa soltanto che il provider l'ha preso in carico.",
                choice: "Numero collegato con il codice QR; il messaggio parte da solo e si ritocca prima di inviare.",
                short: "Agile",
            },
            manual: {
                label: "A mano, da WhatsApp Desktop",
                tag: "come oggi",
                text: "Gioia365 apre WhatsApp Desktop sul computer del Commerciale, con il messaggio già scritto. Lui preme Invio e poi «Sì, inviato»: il CRM non vede se è arrivato.",
                choice: "Si apre WhatsApp Desktop sul suo computer; lui preme Invio e poi «Sì, inviato».",
                short: "A mano",
            },
        },
        // Il primo livello: i WhatsApp che usa l'azienda (D2, questioni 391, 403 e 404).
        company: {
            title: "I WhatsApp che usa {organization}",
            text: "Primo passo: il Super admin sceglie quali WhatsApp usa l'azienda. Secondo passo, qui sotto: per ogni persona si sceglie quale di questi usa e con quale numero.",
            readOnly: "Questa scelta la fanno il Super admin di {organization} e il Super admin di Gioia365.",
            always: "Resta sempre: è la riserva quando gli altri non sono pronti.",
            nextRelease: "Arriva con il prossimo rilascio",
            // Senza le quattro variabili di Meta sul server (ruling «Regole che valgono per tutti i Task di R2»).
            metaUnavailable: "Il WhatsApp ufficiale non è ancora collegato a Gioia365",
            // Senza la chiave di WhatsApp Agile sul server (piano M6, R9; `agileSignup.available`): «non disponibile», con il perché.
            agileUnavailable: "Non disponibile: WhatsApp Agile non è ancora collegato a Gioia365",
            switchedOn: "{channel} acceso per {organization}: ora si può scegliere per ogni persona con «Imposta».",
            switchedOff: "{channel} spento per {organization}. La modifica resta nel registro Attività.",
            switchedOffOne: "{channel} spento per {organization}: 1 persona passa a mano finché non la imposti di nuovo. La modifica resta nel registro Attività.",
            switchedOffMany: "{channel} spento per {organization}: {count} persone passano a mano finché non la imposti di nuovo. La modifica resta nel registro Attività.",
            conflict: "Nel frattempo qualcuno ha cambiato le impostazioni dell'azienda: qui sopra c'è la scelta salvata. Controllala e riprova.",
        },
        // Il secondo livello: il WhatsApp di ogni persona.
        people: {
            title: "Il WhatsApp di ogni Commerciale",
            text: "Per ognuno si sceglie quale WhatsApp usa e da quale numero partono i suoi messaggi. Si sceglie fra i WhatsApp che usa {organization}. Un Commerciale nuovo parte con il WhatsApp ufficiale, il consigliato, se {organization} lo usa; altrimenti a mano.",
            caption: "WhatsApp e numero di ogni Commerciale",
            columns: {
                person: "Commerciale",
                channel: "WhatsApp",
                number: "Numero",
                state: "Stato",
                action: "Azione",
            },
            you: "tu",
            noNumber: "Nessun numero",
            setup: "Imposta",
            setupNamed: "Imposta il WhatsApp di {name}",
            autoTitle: "Succede da solo:",
            autoText: "prima di ogni invio Gioia365 controlla che il WhatsApp del Commerciale sia pronto e, per il WhatsApp ufficiale, che il modello sia approvato da Meta. Se non lo è, il messaggio si apre in WhatsApp Desktop come a mano: un WhatsApp non risulta mai inviato se non è partito davvero.",
        },
        // Lo stato di ogni riga, nella pagina e, in breve, nella cella del Team. Per il WhatsApp ufficiale non pronto (R2, `notReadyReason`)
        // le parole del mock-up non bastano: sono proposte (questione 409), con «Il cellulare è stato tolto dal parco» di D9.
        states: {
            manual: "WhatsApp Desktop sul suo computer",
            metaReady: "Registrato su Meta",
            metaPending: "Da registrare: per ora a mano",
            metaFailed: "Registrazione su Meta non riuscita: per ora a mano",
            metaCallerRemoved: "Il cellulare è stato tolto dal parco",
            metaNotConnected: "Collegamento con Meta da finire: per ora a mano",
            metaNotConfigured: "Il WhatsApp ufficiale non è ancora collegato a Gioia365",
            agileReady: "Collegato con il codice QR",
            agilePending: "Non collegato: per ora a mano",
            // WhatsApp Agile dall'ultimo stato salvato del suo canale (piano M6, R9, Task 27b; `agileHealth`): mai controllato, giù da
            // meno di 10 minuti (i messaggi vanno a mano), giù da più tempo (il prossimo invio lo chiede di nuovo al fornitore). Parole nuove.
            agileUnchecked: "Collegato con il codice QR, non ancora controllato",
            agileDown: "Non consegna dal {since}: per ora a mano",
            agileDownStale: "Non consegnava al controllo del {checked}: il prossimo invio lo ricontrolla",
        },
        // Nella cella del Team il modo è già scritto in grassetto: la seconda riga dice soltanto lo stato, e a mano non c'è.
        team: {
            metaReady: "registrato su Meta",
            metaPending: "da registrare",
            metaFailed: "registrazione non riuscita",
            metaCallerRemoved: "cellulare tolto dal parco",
            metaNotConnected: "collegamento con Meta da finire",
            metaNotConfigured: "non collegato a Gioia365",
            agileReady: "collegato",
            agilePending: "da collegare",
            agileUnchecked: "non ancora controllato",
            agileDown: "non consegna dal {since}",
            agileDownStale: "non consegnava al controllo del {checked}",
            failed: "Non riesco a leggere il WhatsApp delle persone, quindi qui manca la colonna «WhatsApp». Riprova.",
        },
        // La finestra «Imposta» (`#m-wa-setup`): «A mano», da R2 il WhatsApp ufficiale di Meta, da R9 WhatsApp Agile.
        dialog: {
            title: "Il WhatsApp di {name}",
            legend: "Quale WhatsApp usa",
            number: "Numero WhatsApp del suo WhatsApp Desktop",
            placeholder: "+39 300 000 0000",
            numberHint: "Spazi, punti e trattini si tolgono da soli. Serve il prefisso, per esempio +39.",
            manualNote: "Non c'è niente da collegare: il Commerciale scrive da questo numero con WhatsApp Desktop sul suo computer.",
            effect: "Cosa cambia:",
            effectManual: "{name} manda i WhatsApp a mano, da WhatsApp Desktop, e conferma con «Sì, inviato».",
            save: "Salva",
            numberInvalid: "Scrivi il numero con il prefisso, per esempio +39 300 000 0101.",
            numberTaken: "Questo numero è già di {name}: ogni persona ha il suo.",
            notUsed: "{organization} non usa questo WhatsApp: lo accende il Super admin, in cima a «Invio dei WhatsApp».",
            conflict: "Nel frattempo qualcuno ha cambiato il WhatsApp di {name}: nella tabella c'è quello salvato adesso. Per tenere il numero che hai scritto, salva di nuovo.",
            saved: "Salvato. {effect} Resta nel registro Attività.",
            // Con il WhatsApp ufficiale (R2, Task 7b; mock-up `bindWaSetup`).
            numberMeta: "Numero WhatsApp del suo telefono di lavoro",
            effectMeta: "I WhatsApp di {name} partono dal WhatsApp ufficiale, con i modelli approvati da Meta.",
            saveMeta: "Registra su Meta e salva",
            // Con WhatsApp Agile (R9, Task 27b; mock-up `bindWaSetup`): «Cosa cambia:» e il pulsante alla lettera.
            effectAgile: "I WhatsApp di {name} partono da soli con WhatsApp Agile.",
            saveAgile: "Ho inquadrato il codice, salva",
        },
        // WhatsApp Agile nella finestra «Imposta» (piano M6, R9, Task 27b; mock-up `whatsapp.html`, `#m-wa-setup-qr`): i primi due passi del
        // codice QR alla lettera; il terzo dice che il codice QR si apre nella scheda nuova, perché dentro un'altra pagina il collegamento non
        // riesce (lezione di GioiaFlow del 5 agosto 2026). Il codice di Agile, il collegamento di nuovo dello stesso telefono, l'avviso sui
        // messaggi che il fornitore teneva in coda, il controllo durante il salvataggio e l'avviso della pagina sono parole nuove. Chi imposta
        // senza «Invio dei WhatsApp» non ha «Collega di nuovo il telefono» (il codice QR salvato è di quella sola funzione): i suoi suggerimenti
        // dicono di scrivere di nuovo il codice; un codice già di un collega si dice sul campo del codice (revisione finale di R9, I2 e M2).
        agile: {
            code: "Codice di WhatsApp Agile",
            codeHint: "Il codice di questo numero, dal pannello di WhatsApp Agile. Puoi incollare anche il link intero: il codice si ricava da lì.",
            codeSavedHint: "Il codice salvato non si mostra. Per collegare di nuovo lo stesso telefono premi «Collega di nuovo il telefono»; per un altro numero scrivi il suo codice.",
            codeMissing: "Scrivi il codice di WhatsApp Agile di questo numero.",
            codeSavedHintNoRepair: "Il codice salvato non si mostra: per collegare di nuovo il telefono scrivi di nuovo il suo codice.",
            codeMissingSaved: "Scrivi il codice di WhatsApp Agile, oppure premi «Collega di nuovo il telefono».",
            codeMissingSavedNoRepair: "Scrivi il codice di WhatsApp Agile di questo numero.",
            codeTaken: "Questo codice è già di {name}.",
            codeInvalid: "Il codice ha soltanto lettere, cifre, «_» e «-»: controlla di averlo copiato intero.",
            qrTitle: "Il codice QR",
            step1: "Prendi il telefono di lavoro del Commerciale e apri WhatsApp.",
            step2: "Vai in Impostazioni → Dispositivi collegati → Collega un dispositivo.",
            step3: "Inquadra il codice QR che si apre in una scheda nuova con «Apri il codice QR».",
            openQr: "Apri il codice QR",
            openQrFirst: "Scrivi prima il codice: il codice QR si apre da lì.",
            repair: "Collega di nuovo il telefono",
            repairing: "Leggo il codice QR del numero salvato…",
            repairReady: "Il codice QR del numero salvato è pronto: aprilo e inquadralo con il telefono di lavoro.",
            releaseOne: "Collegando di nuovo il telefono, WhatsApp Agile manda subito i messaggi che teneva in coda: 1 preso in carico nelle ultime 24 ore da questo numero.",
            releaseMany: "Collegando di nuovo il telefono, WhatsApp Agile manda subito i messaggi che teneva in coda: {count} presi in carico nelle ultime 24 ore da questo numero.",
            saving: "Controllo il codice con WhatsApp Agile…",
            // L'avviso della pagina dice soltanto ciò che vale all'ultimo controllo: dopo 10 minuti la finestra offre di nuovo l'invio (WA-20).
            downOne: "Il WhatsApp Agile di {name} non consegna: va collegato di nuovo con il codice QR.",
            downMany: "Il WhatsApp Agile di {names} non consegna: va collegato di nuovo con il codice QR.",
        },
        // «Registra su Meta e salva» nella finestra «Imposta» (R2, Task 7b): il riquadro del mock-up (`#m-wa-setup-meta`, senza «Nel
        // mock-up la finestra di Meta non si apre.»), il blocco del tetto dei numeri, e le parole nuove (questione 409): la registrazione in
        // corso, la finestra di Meta chiusa, il passo e il motivo di una registrazione non riuscita, detti in parole semplici dal codice
        // (mai il codice grezzo né il messaggio di Meta).
        meta: {
            registrationTitle: "Registrazione su Meta:",
            registrationText: "si apre la finestra di Meta dentro Gioia365 e il numero entra nel Business Manager dell'azienda. Il numero resta anche nell'app WhatsApp Business del telefono (Meta la chiama «coesistenza»): niente codice SMS, niente cancellazioni.",
            registeredCount: "Numeri registrati: {count} di {cap}.",
            capReached: "Il Business Manager ha già {count} numeri registrati: per aggiungerne altri serve una richiesta a Meta.",
            registering: "Registrazione su Meta in corso…",
            windowOpen: "Completa i passi nella finestra di Meta: appena finisci, Gioia365 registra il numero.",
            failed: "Registrazione su Meta non riuscita: {reason}",
            failedAtStep: "Registrazione su Meta non riuscita al passo «{step}»: {reason}",
            retry: "Riprova",
            retryNamed: "Riprova a registrare il numero di {name} su Meta",
            openWindow: "Apri la finestra di Meta",
            steps: {
                token: "scambio del codice con Meta",
                webhook: "indirizzo dei messaggi di Meta",
                subscribed: "iscrizione ai messaggi di Meta",
                phone_number: "lettura dei numeri su Meta",
            },
            reason: {
                noResponse: "Meta non ha risposto in tempo e non si sa se il passo è riuscito: «Riprova» lo rifà senza danni.",
                lockLost: "un'altra operazione sul WhatsApp dell'azienda l'ha interrotta: riprova fra poco.",
                tokenRejected: "Meta non accetta più il collegamento dell'azienda: «Riprova» riapre la finestra di Meta.",
                rateLimited: "Meta chiede di rallentare: riprova fra qualche minuto.",
                metaDown: "Meta ha un guasto in questo momento: riprova fra qualche minuto.",
                permission: "Meta non dà a Gioia365 il permesso per questo passo: va controllata l'app di Meta.",
                invalidResponse: "Meta ha risposto in un modo che Gioia365 non si aspetta: riprova; se succede ancora, avvisa chi segue Gioia365.",
                generic: "Meta ha rifiutato il passo: riprova; se succede ancora, avvisa chi segue Gioia365.",
            },
            windowClosed: {
                cancelled: "La finestra di Meta si è chiusa prima della fine. Se non si è aperta, il browser l'ha bloccata: consenti le finestre di Gioia365 e premi «Apri la finestra di Meta».",
                incomplete: "La finestra di Meta non ha mandato tutto quello che serve: riaprila e completa i passi.",
                error: "La finestra di Meta si è fermata con un errore: riaprila e riprova.",
                sdkUnavailable: "La finestra di Meta non si apre: controlla la connessione, o che il browser non blocchi Facebook, e riprova.",
            },
        },
        // Il riquadro «Business Manager di Meta» (questione 416; mock-up `initWaChannel`, `#m-wa-meta`), letto da Meta alla registrazione
        // e dal giro dei 15 minuti; «Modelli approvati da Meta: N di 6» dagli stati dei modelli su Meta (Task 8b; `{link}` è il
        // collegamento a «Modelli WhatsApp»). Proposte (questione 409): il collegamento non ancora fatto, non finito o non riuscito, il
        // nome non ancora letto e quando si è letto.
        business: {
            title: "Business Manager di Meta",
            verified: "azienda verificata da Meta",
            nameUnknown: "Il nome su Meta non è ancora stato letto",
            numbers: "Numeri registrati sul WhatsApp ufficiale: {count} di {cap}. Prima della verifica di Meta se ne registrano al massimo 2, dopo 20; per averne di più si chiede a Meta.",
            numbersUnknown: "Numeri registrati sul WhatsApp ufficiale: non ancora letti da Meta. Prima della verifica di Meta se ne registrano al massimo 2, dopo 20; per averne di più si chiede a Meta.",
            perDayTitle: "Quante persone al giorno",
            perDayText: "Il limite vale per tutto il Business Manager, non per numero: conta a quante persone diverse scrivete per primi in 24 ore. Si parte da 250 e sale da solo con la verifica e con la qualità dei messaggi.",
            none: "Nessun numero è ancora registrato su Meta: si comincia con «Imposta» su un Commerciale, scegliendo «WhatsApp ufficiale di Meta».",
            unfinished: "Una registrazione su Meta non è finita: si riprende con «Imposta» e «Registra su Meta e salva».",
            failed: "L'ultima registrazione su Meta non è riuscita: {reason} Si riprende da «Imposta», sulla riga del Commerciale, con «Riprova» o «Registra su Meta e salva».",
            readAt: "Letto da Meta il {when}.",
            templatesApproved: "Modelli approvati da Meta: {approved} di {total}",
            templatesText: "Si scrivono e si mandano in approvazione in {link}. Ogni messaggio consegnato si paga, con prezzi diversi per i modelli marketing e di utilità.",
        },
    },
    // Impostazioni → «Modelli WhatsApp» (piano M6, R1, Task 5a; D5, D25; questioni 395 e 401; mock-up `modelli-whatsapp.html` e
    // `mockup.js`, `initTemplates`): le parole del mock-up alla lettera, con «tutta l'azienda» al posto di «tutta l'Academy» e senza
    // «Nel mock-up …». Il mock-up dice «Lo aggiungi a un percorso in «Esiti e percorsi».», una pagina che non c'è: la frase si ferma
    // prima. Sono proposte (questione 406): la riga «scrivi STOP» con le sue parole (questione 395), il conflitto di versione e il testo
    // troppo lungo con la riga in fondo. «Nuovo modello» arriva dopo (questione 401). Con il WhatsApp ufficiale (R2, Task 8b) lo stato
    // presso Meta, la categoria e «Invia a Meta per l'approvazione» (`meta`, sotto).
    whatsappTemplatesSettings: {
        intro: "I messaggi standard dell'azienda, che i Commerciali mandano con un clic dopo la chiamata. Li scrive il Super admin e valgono per tutta l'azienda; ogni modifica resta nel registro Attività.",
        readOnly: "Solo Admin e Super admin dell'azienda scrivono e cambiano i modelli: i Commerciali li usano così come sono.",
        variablesTitle: "Parole che si riempiono da sole",
        // Il significato di ogni variabile (`WA_VARIABLES`, con i nomi di WA-13 dal 17/10/2026); la variabile stessa, fra graffe, non si
        // traduce.
        variables: {
            nome: "nome della titolare",
            aziendaTarget: "nome dell'azienda target",
            commerciale: "chi manda il messaggio",
            nostraAzienda: "nome della nostra azienda",
            dayAndTime: "del richiamo, della disco o della demo",
        },
        template: {
            name: "Nome del modello",
            // `{outcomes}` è una o più volte `after`, separate da una virgola.
            suggested: "Si propone {outcomes}. Sempre disponibile da «Invia WhatsApp».",
            after: "dopo «{outcome}»",
            notSuggested: "Non è in nessun percorso: si manda da «Invia WhatsApp».",
            text: "Testo",
            insert: "Inserisci nel testo",
            preview: "Come arriva a Giulia Ferri",
            save: "Salva",
            nameMissing: "Dai un nome al modello.",
            textMissing: "Scrivi il testo del messaggio.",
            tooLong: "Il testo è troppo lungo: con la riga «scrivi STOP» in fondo un WhatsApp ha al massimo {max} caratteri, e qui sono {count}.",
            saved: "Modello «{name}» salvato: vale subito per tutta l'azienda.",
            conflict: "Nel frattempo qualcuno ha cambiato questo modello: la pagina adesso parte da quello salvato, con sopra le tue modifiche. Controllale e salva di nuovo.",
        },
        // L'esempio dell'anteprima (`sample` del mock-up), con un'azienda target inventata (WA-13, 17/10/2026); il nome della nostra azienda
        // è quello vero.
        sample: {
            nome: "Giulia",
            aziendaTarget: "Studio Aurora",
            commerciale: "Luca",
            dayAndTime: "venerdì 25/09/2026 alle 10:00",
        },
        // La riga «scrivi STOP» dell'azienda (D25, questione 395): al massimo 60 caratteri, si cambia ma non si toglie.
        stopLine: {
            title: "La riga «scrivi STOP»",
            text: "In fondo a ogni WhatsApp, anche a mano, c'è questa riga: dice al Lead come smettere di ricevere messaggi. Si cambia, ma non si toglie.",
            label: "Testo della riga",
            hint: "Al massimo {max} caratteri, su una riga sola.",
            empty: "Scrivi la riga: ogni WhatsApp deve dire come smettere di riceverli.",
            tooLong: "Con questa riga il modello «{name}» supera i {max} caratteri di un WhatsApp: accorcia il modello o la riga.",
            save: "Salva",
            saved: "Riga salvata: vale subito per tutti i WhatsApp.",
            conflict: "Nel frattempo qualcuno ha cambiato la riga: la pagina adesso parte da quella salvata, con sopra la tua modifica. Controllala e salva di nuovo.",
            // Con il WhatsApp ufficiale (R2, Task 8b; D25, E1): la riga è il piè di pagina dei modelli su Meta. `{names}` è una o più
            // volte `meta.quoted`, separate da una virgola.
            metaWarning: "Questa riga va a Meta in fondo a ogni modello: salvarla rimanda in revisione i modelli già su Meta, e nel frattempo si mandano a mano.",
            savedInReview: "Riga salvata: vale subito per tutti i WhatsApp. Tornano in revisione da Meta: {names}; nel frattempo si mandano a mano.",
            notResubmitted: "Da mandare di nuovo a Meta: {names}. Si mandano a mano finché non premi «Invia a Meta per l'approvazione» sul modello.",
        },
        // I modelli sul WhatsApp ufficiale di Meta (R2, Task 8b; ruling B4, A4c; questioni 409 e 411; mock-up `initTemplates`, `metaLine`),
        // visibili soltanto quando l'azienda usa il WhatsApp ufficiale e Gioia365 è collegata a Meta. Dal mock-up alla lettera: «Meta: da
        // inviare / in revisione / approvato», le categorie, «Invia a Meta per l'approvazione», i due avvisi dopo il salvataggio e l'invio
        // (senza «Nel mock-up…») e la spiegazione di come parte il messaggio (da R9 con WhatsApp Agile, Task 27b). Le altre sono
        // proposte (questione 409): «rifiutato», «sospeso» e «spento» con il motivo, la categoria decisa da Meta, l'ultimo invio non
        // riuscito, il testo da salvare prima, il collegamento con Meta che manca, il conflitto e la lettura dei WhatsApp dell'azienda.
        meta: {
            howItLeaves: "Come parte il messaggio dipende dal WhatsApp di ogni Commerciale, scelto in «Invio dei WhatsApp». Con il WhatsApp ufficiale parte soltanto un modello approvato da Meta, così com'è: chi usa un modello non ancora approvato lo manda a mano. Con WhatsApp Agile parte da solo e si può ritoccare nella postazione. A mano si apre in WhatsApp Desktop già scritto e si ritocca lì.",
            status: {
                none: "Meta: da inviare",
                pending: "Meta: in revisione",
                approved: "Meta: approvato",
                rejected: "Meta: rifiutato",
                paused: "Meta: sospeso",
                disabled: "Meta: spento",
            },
            category: {
                utility: "Utilità",
                marketing: "Marketing",
            },
            categoryChanged: "Categoria decisa da Meta: {decided} (Gioia365 aveva proposto {proposed}).",
            // Il motivo di un rifiuto (`rejected_reason` di Meta), in parole: mai il codice di Meta.
            rejected: "Motivo di Meta: {reason} Cambia il testo e salvalo: torna da solo in revisione.",
            rejectedReason: {
                abusiveContent: "il testo ha un contenuto che Meta non ammette.",
                incorrectCategory: "la categoria non corrisponde al testo.",
                invalidFormat: "il formato del testo non va bene (le variabili, gli a capo o i caratteri).",
                promotional: "è un testo promozionale per la sua categoria.",
                scam: "Meta lo considera una possibile truffa.",
                tagContentMismatch: "il testo non corrisponde alla categoria o alla lingua.",
                unknown: "Meta non l'ha detto.",
            },
            paused: "Meta l'ha sospeso per la qualità dei messaggi: finché resta così, chi usa il WhatsApp ufficiale lo manda a mano.",
            disabled: "Meta l'ha spento: chi usa il WhatsApp ufficiale lo manda a mano finché non lo mandi di nuovo a Meta.",
            // L'ultimo invio non riuscito (`metaError`): il motivo in parole dal solo codice, come per la registrazione su Meta.
            lastError: "L'ultimo invio a Meta non è riuscito: {reason}",
            failure: {
                noResponse: "Meta non ha risposto in tempo: riprova.",
                lockLost: "un'altra operazione sul WhatsApp dell'azienda l'ha interrotto: riprova fra poco.",
                connection: "Meta non accetta più il collegamento dell'azienda: rifai la registrazione su Meta in «Invio dei WhatsApp».",
                permission: "Meta non dà a Gioia365 il permesso di mandare i modelli: va controllata l'app di Meta.",
                rateLimited: "Meta chiede di rallentare: riprova fra qualche minuto.",
                metaDown: "Meta ha un guasto in questo momento: riprova fra qualche minuto.",
                generic: "Meta non l'ha accettato: controlla il testo e riprova; se succede ancora, avvisa chi segue Gioia365.",
            },
            submit: "Invia a Meta per l'approvazione",
            submitted: "Inviato a Meta: di solito l'approvazione arriva in qualche ora.",
            saveFirst: "Salva prima il testo: a Meta va il testo salvato.",
            textChanged: "Un testo cambiato torna in revisione da Meta: finché non è approvato, chi usa il WhatsApp ufficiale lo manda a mano.",
            savedInReview: "Modello «{name}» salvato. Il testo è cambiato: torna in revisione da Meta e, finché non è approvato, chi usa il WhatsApp ufficiale lo manda a mano.",
            notResubmitted: "Il testo è salvato ma non è ripartito per Meta: {reason} Finché non lo mandi con «Invia a Meta per l'approvazione», si manda a mano.",
            notConnected: "Il WhatsApp ufficiale dell'azienda non è ancora collegato a Meta: registra prima un numero con «Registra su Meta e salva», in «Invio dei WhatsApp».",
            conflict: "Il testo è cambiato mentre Meta lo riceveva: la pagina adesso mostra quello salvato. Se è quello giusto, mandalo di nuovo a Meta.",
            channelsFailed: "Non riesco a leggere i WhatsApp che usa l'azienda: qui manca lo stato dei modelli su Meta.",
            quoted: "«{name}»",
        },
    },
    // Impostazioni → «Assegnazione dei Lead» (piano M6, Task 13; mock-up `regole.html?sezione=assegnazione`): le parole del mock-up
    // alla lettera (D16). Le righe sul turno che si salva e basta, sull'ordine alfabetico, su chi è invitato, il conflitto e il rifiuto
    // della persona unica non sono nel mock-up: sono proposte (questioni 450–453).
    // Impostazioni → «Obiettivi» (piano M7, Task 6; D9; SEZ-16): le parole del piano e, dove il piano tace, scelte di Claude.
    goalsSettings: {
        about: "A cosa serve",
        aboutText: "Gli obiettivi del mese, persona per persona, e le percentuali con cui il Report colora i numeri e risale dalle vendite alle chiamate. Li vede e li cambia soltanto chi ha «Obiettivi» fra i permessi del suo ruolo: di partenza il Super admin.",
        readOnlyPlatform: "Sono gli obiettivi di {organization}: li cambia il suo Super admin, non il Super admin di Gioia365.",
        noAccess: "Gli obiettivi li vede e li cambia soltanto chi ha «Obiettivi» fra i permessi del suo ruolo: di partenza il Super admin.",
        month: "Mese",
        monthLocked: "Salva o annulla le modifiche prima di cambiare mese.",
        averageSale: "Valore medio di una vendita",
        averageSaleHint: "In euro, per l'azienda e per ogni mese: dall'obiettivo di vendita dà le chiusure che servono.",
        goalsTitle: "Obiettivo di vendita del mese",
        goalsHint: "In euro, una riga per Commerciale, per {month}. Vuoto vuol dire nessun obiettivo.",
        noGoal: "Nessun obiettivo",
        noPeople: "Nel team non c'è ancora nessun Commerciale.",
        inactive: "{name} (non più attivo)",
        targetsTitle: "Obiettivi delle percentuali",
        targetsHint: "Il Report colora in verde i numeri dal «Da» in su e risale dalle vendite alle chiamate con il «Da». Valgono per tutta l'azienda.",
        from: "Da",
        to: "A",
        decided: "deciso, non si cambia",
        range: "{min}–{max}%",
        atLeast: "almeno {min}%",
        saved: "Obiettivi salvati: il Report li usa da adesso.",
        conflict: "Nel frattempo qualcuno ha cambiato gli obiettivi: la pagina adesso parte da quelli salvati, con sopra le tue modifiche. Controllale e salva di nuovo.",
        problems: {
            averageSale: "Il valore medio di una vendita va scritto in euro, da 0,01 a 10.000.000, senza i punti delle migliaia.",
            goal: "L'obiettivo di {name} va scritto in euro, da 0 a 10.000.000, senza i punti delle migliaia.",
            percent: "{name}: le percentuali vanno da 0,1 a 100, con al più un decimale.",
            minMissing: "{name}: scrivi il «Da».",
            minOverMax: "{name}: il «Da» non può essere più alto dell'«A».",
        },
        changes: {
            averageSale: "Valore medio di una vendita: da {before} a {after}.",
            averageSaleSet: "Valore medio di una vendita: {after}.",
            averageSaleRemoved: "Valore medio di una vendita tolto (era {before}).",
            goal: "{name}, {month}: da {before} a {after}.",
            goalSet: "{name}, {month}: {after}.",
            goalRemoved: "{name}, {month}: nessun obiettivo (era {before}).",
            target: "{name}: da {before} a {after}.",
        },
    },
    assignmentSettings: {
        title: "Assegnazione dei Lead",
        about: "A cosa serve",
        aboutText: "Decide a chi va un Lead nuovo che arriva da Meta o da un'importazione: a turno fra le persone scelte, tutti a una persona, oppure a nessuno, e allora lo assegna a mano un Super user, un Admin o il Super admin.",
        aboutTeam: "È una regola del team, non del singolo: evita che due Commerciali lavorino lo stesso Lead e che un Lead resti senza nessuno.",
        aboutNow: "Per ora la regola vale per «Nuovo Lead», quando non scegli un owner; i Lead che arrivano da GoHighLevel e dai file la useranno appena quegli ingressi sono pronti.",
        readOnly: "La vedi soltanto: la cambiano il Super admin e l'Admin di {organization}.",
        readOnlyPlatform: "È una regola di {organization}: la cambiano i suoi Super admin e Admin, non il Super admin di Gioia365.",
        newLeads: "I Lead nuovi",
        how: "Come si assegnano",
        modeRoundRobin: "A turno fra le persone scelte",
        modeSingle: "Tutti a una persona",
        modeManual: "A nessuno: li assegna a mano un Super user, un Admin o il Super admin",
        whoJoins: "Chi entra nel turno",
        suspended: "{name} (sospeso)",
        noCandidates: "Nel team non c'è ancora nessun Commerciale da mettere nel turno.",
        orderNote: "Il turno segue l'ordine alfabetico dei nomi. Chi è invitato compare qui quando accetta l'invito.",
        weightLabel: "Lead di fila a {name}",
        weightOption: "{count} di fila",
        weightNote: "Accanto a ogni persona scegli quanti Lead nuovi riceve di fila prima che tocchi alla successiva: con 2 e 1, la prima ne riceve due e la seconda uno, poi si ricomincia.",
        toWhom: "A chi",
        choosePerson: "Scegli una persona",
        nextLeads: "I prossimi 6 Lead nuovi: {names}. Chi è sospeso salta il turno da solo.",
        nextNone: "I Lead nuovi arrivano senza owner, e si vedono nell'elenco Lead con «Senza owner», finché un Super user, un Admin o il Super admin non li assegna. Chi è sospeso salta il turno da solo.",
        returning: "Un Lead che torna",
        returningLegend: "Se arriva di nuovo un Lead che c'è già (stesso cellulare)",
        returningKeep: "Resta al suo owner; se l'owner è sospeso o archiviato, si assegna come un Lead nuovo",
        returningAsNew: "Si assegna come un Lead nuovo",
        returningNote: "Un Lead che torna si riconosce soltanto dal cellulare: un'email uguale è al massimo un doppione da controllare in «Pulizia dati». Per ora questa scelta si salva e basta: la userà l'ingresso dei Lead da GoHighLevel, che arriva dopo.",
        saved: "Regola salvata: vale dal prossimo Lead nuovo.",
        conflict: "Nel frattempo qualcuno ha cambiato le impostazioni dell'azienda: la pagina adesso parte dalla regola salvata, con sopra le tue modifiche. Controllale e salva di nuovo.",
        problems: {
            needPerson: "Per il turno scegli almeno una persona attiva.",
            needSingle: "Per «Tutti a una persona» scegli una persona attiva.",
        },
        changes: {
            mode: "I Lead nuovi vanno {after} (prima {before}).",
            modeRoundRobin: "a turno fra le persone scelte",
            modeSingle: "tutti a una persona",
            modeManual: "a nessuno, li assegna a mano un Super user, un Admin o il Super admin",
            people: "Nel turno: {names}.",
            weights: "Lead di fila: {list}.",
            single: "I Lead nuovi vanno tutti a {name}.",
            returningKeep: "Un Lead che torna resta al suo owner.",
            returningAsNew: "Un Lead che torna si assegna come un Lead nuovo.",
        },
    },
    // Impostazioni → «Ingressi dei Lead» (piano dell'ingresso del 10 ottobre 2026, I2, Task 4; mock-up `regole.html?sezione=ingressi`):
    // le porte da cui i Lead entrano da soli, gli indirizzi, il pezzo di codice del modulo, il Lead di prova e gli ultimi arrivi.
    leadIntakeSettings: {
        about: "A cosa serve",
        aboutText: "Qui si collegano le porte da cui i Lead entrano da soli in Gioia365: i moduli di Meta, i moduli del sito e delle landing e, finché restano accese, le landing di GoHighLevel.",
        aboutSame: "Ogni Lead entra dallo stesso passaggio di «Nuovo Lead»: se il cellulare c'è già non si raddoppia, si aggiornano i suoi dati e si aggiungono i tag; un Lead nuovo prende l'owner dalla regola di «Assegnazione dei Lead» e la sua sequenza di chiamate parte subito.",
        aboutSecret: "Sono collegamenti dell'azienda: si impostano una volta sola e valgono per tutti. Gli indirizzi sono segreti come una password: chi li conosce può far entrare Lead in {organization}.",
        readOnly: "La vedi soltanto: gli ingressi li impostano il Super admin di {organization} e il Super admin di Gioia365.",
        meta: "Moduli di Meta",
        metaUnavailable: "Il collegamento con Meta non è attivo su questo server.",
        metaText: "I Lead dei moduli di Meta entrano direttamente in Gioia365, senza passare da GoHighLevel: ogni minuto Gioia365 legge i moduli della pagina Facebook collegata.",
        metaRules: "Un Lead nuovo prende l'owner dalla regola di «Assegnazione dei Lead» e il tag «Facebook» o «Instagram»; chi risponde «no» a «Sei titolare, hai un salone?» non diventa un Lead. Entrano i Lead arrivati dal momento del collegamento: quelli di prima restano dove sono.",
        metaNone: "Nessuna pagina collegata.",
        metaConnect: "Collega la pagina Facebook",
        metaReconnect: "Collega di nuovo la pagina",
        metaConnectHint: "Entra con un account che amministra la pagina e ha un ruolo sull'app di Meta, e lascia attivi tutti i permessi che Facebook chiede.",
        metaCancelled: "La finestra di Facebook si è chiusa prima della fine: niente è cambiato.",
        metaSdkUnavailable: "La finestra di Facebook non si è aperta: controlla che il browser non blocchi Facebook e riprova.",
        metaPermissions: "Facebook non ha dato i permessi per leggere i moduli: riprova e lascia attivi tutti i permessi che chiede.",
        metaNoPages: "Questo account non amministra nessuna pagina su Facebook: entra con l'account che amministra la pagina.",
        metaChooseTitle: "Scegli la pagina",
        metaChooseLegend: "La pagina Facebook da cui entrano i Lead",
        metaChooseText: "I Lead dei moduli della pagina scelta entreranno in {organization}. Una pagina si collega a un'azienda sola.",
        metaChooseConfirm: "Collega questa pagina",
        metaConnected: "Collegata: «{page}», dal {when}.",
        metaConnectedDone: "Pagina collegata: i Lead dei suoi moduli entrano da adesso.",
        metaRoundNone: "La prima lettura dei moduli parte entro un minuto.",
        metaRoundOk: "Ultima lettura dei moduli: {when}.",
        metaRoundFailed: "L'ultima lettura dei moduli, il {when}, non è riuscita: Gioia365 riprova da sola ogni minuto.",
        metaRoundTokenRejected: "Meta non accetta più il collegamento: collega di nuovo la pagina.",
        metaDisconnect: "Scollega la pagina",
        metaDisconnectTitle: "Scolleghi la pagina?",
        metaDisconnectText: "I Lead dei moduli di «{page}» smettono di entrare in Gioia365. I Lead già entrati restano. Se la pagina non si legge più, ricollegala invece di scollegarla: così entrano anche i Lead arrivati nel frattempo.",
        metaDisconnectConfirm: "Sì, scollegala",
        metaDisconnected: "Pagina scollegata: i Lead dei moduli di Meta non entrano più.",
        metaConflict: "Nel frattempo qualcuno ha cambiato il collegamento con Meta: il riquadro adesso mostra quello salvato.",
        web: "Moduli del sito e delle landing",
        webActive: "Ricevi i Lead dai moduli del sito e delle landing",
        webAddress: "L'indirizzo da mettere nel modulo",
        webOwner: "I Lead dei moduli prendono l'owner dalla regola di «Assegnazione dei Lead».",
        ghl: "GoHighLevel",
        ghlActive: "Ricevi i Lead da GoHighLevel",
        ghlAddress: "L'indirizzo da mettere in GoHighLevel",
        addressHidden: "Il pezzo finale è segreto: si vede per intero soltanto quando lo copi.",
        addressNone: "L'indirizzo nasce quando accendi l'ingresso e salvi.",
        off: "Spento: l'indirizzo risponde «non autorizzato» e nessun Lead entra. I Lead già entrati restano.",
        copy: "Copia l'indirizzo",
        copiedWeb: "Indirizzo copiato: è anche dentro «Copia il codice», qui sotto.",
        copiedGhl: "Indirizzo copiato: incollalo nell'azione «Webhook» di GoHighLevel.",
        copyFailed: "Il browser non lascia copiare: l'indirizzo intero è nel campo, selezionalo e copialo a mano.",
        rotate: "Cambia l'indirizzo",
        rotateTitle: "Cambi l'indirizzo?",
        rotateTextWeb: "L'indirizzo di adesso smette subito di funzionare: dopo, rimetti il pezzo di codice nuovo in tutti i moduli del sito e delle landing. I Lead già entrati restano.",
        rotateTextGhl: "L'indirizzo di adesso smette subito di funzionare: dopo, incolla quello nuovo in ogni flusso di GoHighLevel che lo usa. I Lead già entrati restano.",
        rotateConfirm: "Sì, cambialo",
        rotated: "Indirizzo cambiato: quello di prima non funziona più. Copia quello nuovo.",
        origins: "Siti da cui arrivano i moduli",
        originsHint: "Scrivi l'indirizzo del sito come lo vedi nel browser, per esempio https://www.example.it: soltanto le pagine di questi siti possono leggere la risposta di Gioia365 e dire «Grazie» a chi compila.",
        originsNone: "Nessun sito: i moduli fanno entrare lo stesso i Lead, ma la pagina non può dire «Grazie».",
        originField: "Indirizzo del sito",
        originAdd: "Aggiungi",
        originRemove: "Togli {origin}",
        originInvalid: "Scrivi soltanto l'inizio dell'indirizzo, con https://, per esempio https://www.example.it.",
        originTaken: "Questo sito c'è già.",
        originsMax: "Al massimo {count} siti.",
        snippet: "Il pezzo di codice da mettere nella pagina",
        snippetText: "Un modulo pronto, con i campi che Gioia365 legge, il campo nascosto contro i programmi e l'ora in cui la pagina si apre. Mettilo nella pagina del sito o della landing: le etichette si possono cambiare, i nomi dei campi no.",
        snippetLabel: "Codice del modulo",
        snippetCopy: "Copia il codice",
        snippetCopied: "Codice copiato, con l'indirizzo vero dentro: incollalo nella pagina.",
        snippetPlaceholder: "INDIRIZZO-DEL-MODULO",
        form: {
            firstName: "Nome",
            lastName: "Cognome",
            phone: "Cellulare",
            email: "Email",
            salon: "Nome dell'azienda",
            city: "Città",
            consent: "Voglio essere ricontattato",
            send: "Invia",
            thanks: "Grazie! Ti ricontattiamo presto.",
            phoneInvalid: "Scrivi un numero di cellulare (con il prefisso, se non è italiano).",
            tooMany: "Troppi invii da qui: riprova fra qualche minuto.",
            error: "Non è stato possibile inviare: riprova.",
        },
        ghlSteps: "Cosa fare in GoHighLevel, una volta sola",
        ghlStep1: "In GoHighLevel apri «Automazioni» e il flusso che riceve i Lead dei moduli di Meta.",
        ghlStep2: "Aggiungi l'azione «Webhook», metodo POST, e incolla l'indirizzo copiato qui sopra.",
        ghlStep3: "Nella sezione «Custom Data» dell'azione puoi aggiungere campaign_name e form_name (e, se li hai, campaign_id, adset_name, ad_name, form_id): diventano la provenienza del Lead.",
        ghlStep4: "Salva il flusso. Il primo Lead che arriva compare qui sotto, in «Gli ultimi Lead arrivati».",
        owner: "Chi diventa owner",
        ownerLegend: "Chi diventa owner di un Lead nuovo da GoHighLevel",
        ownerTag: "Quello scritto nel tag «Owner: Nome Cognome», se è una persona attiva del team; altrimenti la regola di «Assegnazione dei Lead»",
        ownerRule: "Sempre la regola di «Assegnazione dei Lead»",
        ownerNote: "Un Lead che c'era già resta al suo owner, come dice «Assegnazione dei Lead». Il tag «Owner: …» non resta fra i tag del Lead.",
        test: "Fai entrare un Lead di prova",
        testText: "Entra un Lead inventato, con il tag «Prova ingresso», dallo stesso passaggio dei Lead veri: lo trovi qui sotto e in cima all'elenco Lead.",
        testOnlyDemo: "C'è soltanto nelle aziende di prova: qui ogni Lead che entra è vero.",
        testDone: "È entrato un Lead di prova: lo trovi qui sotto, in «Gli ultimi Lead arrivati».",
        recent: "Gli ultimi Lead arrivati",
        recentCaption: "Gli ultimi 50 Lead arrivati, dal più recente",
        recentOnlyEditors: "Li vede chi imposta gli ingressi: ci sono i nomi dei Lead di tutta l'azienda.",
        recentEmpty: "Non è ancora arrivato nessun Lead.",
        refresh: "Aggiorna",
        columns: {
            when: "Quando",
            from: "Da dove",
            lead: "Lead",
            what: "Cosa è successo",
            owner: "Owner",
        },
        providers: {
            web: "Sito",
            ghl: "GoHighLevel",
            meta: "Meta",
        },
        results: {
            created: "Nuovo Lead",
            updated: "C'era già con lo stesso cellulare: dati aggiornati e tag aggiunti",
            duplicate: "Doppio invio: lo stesso contenuto è arrivato nelle ultime 24 ore, niente di nuovo",
            discarded: "Scartato: {reason}",
            pending: "In lavorazione",
            retrying: "Da rifare: il database dell'azienda non ha risposto, Gioia365 riprova da sola (tentativi: {attempts})",
            failed: "Non è entrato: il database dell'azienda non ha risposto per {attempts} tentativi",
        },
        discardReasons: {
            phone_missing: "manca il telefono",
            invalid_phone: "il telefono non si legge",
            phone_invalid: "il telefono non è un cellulare valido",
            archived_lead: "il cellulare è di un Lead archiviato",
            not_an_object: "il contenuto non si legge",
            honeypot: "l'ha compilato un programma (il campo nascosto è pieno)",
            too_fast: "inviato meno di 3 secondi dopo l'apertura della pagina",
            not_owner: "ha risposto «no» a «Sei titolare, hai un salone?»",
            other: "un motivo che Gioia365 non sa dire",
        },
        notes: {
            tag_unknown: "il tag «Owner: …» non è di una persona del team, ha deciso la regola",
            tag_ambiguous: "il tag «Owner: …» vale per più persone, ha deciso la regola",
            tag_inactive: "il tag «Owner: …» è di una persona sospesa, ha deciso la regola",
            fill_time_missing: "senza l'ora di apertura della pagina",
            clock_ahead: "con l'orologio del computer avanti",
        },
        withNote: "{what} · {note}",
        ownerVia: {
            tag: "{name} (dal tag)",
            rule: "{name} (dalla regola)",
            kept: "{name} (resta suo)",
            chosen: "{name}",
        },
        noOwner: "Senza owner",
        none: "—",
        changes: {
            webOn: "I Lead dei moduli del sito e delle landing entrano da soli.",
            webOff: "I moduli del sito e delle landing non fanno più entrare Lead: l'indirizzo risponde «non autorizzato».",
            origins: "Siti da cui arrivano i moduli: {list}.",
            originsNone: "Nessun sito da cui arrivano i moduli.",
            ghlOn: "I Lead da GoHighLevel entrano da soli.",
            ghlOff: "GoHighLevel non fa più entrare Lead: l'indirizzo risponde «non autorizzato».",
            ownerTag: "Un Lead nuovo da GoHighLevel prende l'owner dal tag «Owner: …», altrimenti dalla regola.",
            ownerRule: "Un Lead nuovo da GoHighLevel prende sempre l'owner dalla regola.",
        },
        saved: "Ingressi salvati: valgono dal prossimo Lead che arriva.",
        conflict: "Nel frattempo qualcuno ha cambiato gli ingressi: la pagina adesso parte da quelli salvati, con sopra le tue modifiche. Controllale e salva di nuovo.",
    },
    // Impostazioni → «Importazione ed esportazione» (richiesta del product owner del 1° ottobre 2026): i modi per far entrare e
    // uscire i Lead. Quelli che non ci sono ancora si dicono «in arrivo», con una riga su cosa faranno e quando arrivano.
    importExport: {
        about: {
            title: "A cosa serve",
            text: "Da qui i Lead entrano in Gioia365 e, più avanti, ne escono. Puoi importare da CSV o consultare l'importazione guidata da Close. L'esportazione arriva più avanti.",
            whoTitle: "Chi la vede",
            who: "Il Super admin e l'Admin di {organization}, e il Super admin di Gioia365.",
        },
        denied: "Importazione ed esportazione la vedono il Super admin e l'Admin di {organization}, e il Super admin di Gioia365: con il tuo ruolo non la vedi.",
        ways: "Modi per importare ed esportare",
        later: "In arrivo",
        close: {
            title: "Importazione guidata da Close",
            text: "Il rapporto della prova senza salvare e dell'importazione da Close: quanti Lead entrano, chi diventa owner, come passa ogni campo e cosa c'è da controllare. Le avvia il Super admin di Gioia365, oppure Gioia365 da sola ogni sera alle 21:00.",
            open: "Apri l'importazione guidata da Close",
        },
        ghl: {
            title: "GoHighLevel",
            text: "La chiave di sola lettura del sotto-account di GoHighLevel e la prova di lettura: quanti contatti e conversazioni ci sono. Per ora niente entra in Gioia365. La salva il Super admin di Gioia365.",
            open: "Apri GoHighLevel",
        },
        file: {
            title: "Importazione da file CSV",
            text: "Importa i Lead da un CSV. Per Excel, salva prima il foglio come CSV.",
            when: "Arriva con gli altri ingressi dei Lead, insieme a GoHighLevel.",
        },
        export: {
            title: "Esportazione",
            text: "Scaricare i Lead in un file Excel o CSV.",
            when: "Arriva più avanti: quando, non è ancora deciso.",
        },
        backToSection: "Torna a Importazione ed esportazione",
    },
    // Impostazioni → Importazione da Close (piano M2 Task 21, mock-up `importazione-close.html`, proposte 1–15 del 1° ottobre
    // 2026): le esecuzioni e il rapporto di una prova senza salvare o di un'importazione, soltanto in lettura. Nel rapporto ci sono
    // numeri, valori dei campi a scelta, riferimenti di Close e nomi del team e degli utenti di Close: mai dati dei clienti.
    closeImport: {
        about: {
            title: "A cosa serve",
            text: "Prima di lasciare Close si fa una prova senza salvare: Gioia365 legge tutto da Close e ti mostra qui cosa entrerebbe e a chi andrebbe, senza salvare niente. Leggi quanti Lead entrano, chi diventa owner, come passa ogni campo e cosa c'è da controllare. Quando tutto torna si fa l'importazione vera, e il rapporto è lo stesso.",
            whoTitle: "Chi la vede",
            who: "Il Super admin e l'Admin di {organization}, e il Super admin di Gioia365. Il rapporto non mostra mai il testo delle note né i nomi dei clienti: soltanto numeri e riferimenti di Close e, dopo l'importazione, «Apri il Lead».",
        },
        denied: "L'importazione da Close la vedono il Super admin e l'Admin di {organization}, e il Super admin di Gioia365: con il tuo ruolo non la vedi.",
        whoStartsTitle: "Chi le avvia.",
        whoStartsText: "La prova senza salvare e l'importazione le avvia il Super admin di Gioia365 da «Ogni sera da Close», qui sopra; con l'importazione di ogni sera accesa, Gioia365 la fa da sola alle 21:00. Una prova senza salvare non cambia niente in Gioia365. Mentre una prova è in corso, questa pagina si aggiorna da sola ogni 5 secondi.",
        // «Ogni sera da Close» (INGR-12, 18/10/2026): chiave, prova senza salvare, importazione e interruttore della sera, soltanto per il Super
        // admin di Gioia365; gli altri leggono se è accesa, la prossima e l'ultima. La chiave non si rivede mai.
        nightly: {
            title: "Ogni sera da Close",
            intro: "Finché il team lavora ancora in Close, Gioia365 importa da sola i dati del giorno ogni sera alle 21:00, ora italiana: rilegge tutto da Close e scrive soltanto ciò che è cambiato. Così i report si riempiono ogni notte.",
            keyTitle: "Chiave",
            keyLabel: "Chiave API di Close",
            keyHint: "La crei in Close, nelle impostazioni, alla voce «API Keys». Gioia365 la prova con Close prima di salvarla e la conserva cifrata: dopo non si rivede più, né qui né altrove.",
            keySave: "Salva la chiave",
            keySaving: "La provo con Close…",
            keySaved: "Chiave salvata il {date} alle {time} da {person}.",
            keySavedBySomeone: "Chiave salvata il {date} alle {time}.",
            keyNone: "Nessuna chiave salvata.",
            keyRemove: "Togli la chiave",
            keyRemoveConfirm: "Togli la chiave? L'importazione di ogni sera si spegne e la chiave non si recupera: per riaccenderla servono una chiave nuova e una prova senza salvare.",
            keyRemoveYes: "Sì, togli la chiave",
            keySavedToast: "Chiave salvata.",
            keySavedOffToast: "Chiave salvata. Con una chiave nuova serve una nuova prova senza salvare: l'importazione di ogni sera è spenta.",
            keyRemovedToast: "Chiave tolta: l'importazione di ogni sera è spenta.",
            dryRunTitle: "Prova senza salvare",
            dryRunText: "Legge tutto da Close e ti mostra cosa entrerebbe in Gioia365 e a chi andrebbe, senza salvare niente.",
            dryRunStart: "Prova senza salvare",
            dryRunDone: "La prova senza salvare con questa chiave è finita il {date} alle {time}.",
            dryRunRunning: "La prova senza salvare con questa chiave è in corso: la segui qui sotto.",
            dryRunStopped: "L'ultima prova senza salvare con questa chiave si è fermata: fanne un'altra.",
            dryRunMissing: "Manca una prova senza salvare finita con questa chiave.",
            dryRunToast: "Prova senza salvare avviata: la segui qui sotto.",
            eveningTitle: "Importazione",
            switchLabel: "Importa ogni sera alle 21:00",
            switchHint: "Si accende dopo una prova senza salvare finita con la chiave di adesso.",
            importNow: "Importa adesso",
            importNowText: "Fa subito l'importazione vera, la stessa della sera.",
            importToast: "Importazione avviata: la segui qui sotto.",
            onToast: "Importazione di ogni sera accesa.",
            offToast: "Importazione di ogni sera spenta.",
            nextToday: "Prossima importazione: oggi alle 21:00",
            nextTomorrow: "Prossima importazione: domani alle 21:00",
            nextSoon: "Prossima importazione: stasera, entro pochi minuti",
            notReady: "L'importazione di ogni sera è accesa, ma non parte: manca una prova senza salvare finita con questa chiave.",
            off: "L'importazione di ogni sera è spenta.",
            last: "Ultima importazione della sera: {date} alle {time}, {outcome}.",
            outcome: {
                running: "in corso",
                completed: "finita",
                interrupted: "fermata dal riavvio del server, riprende da sola",
                failed: "fermata con errore",
            },
            // Perché l'ultima della sera si è fermata, dal suo codice; gli altri codici: «lo controlla il team» con il codice in piccolo.
            reason: {
                close_auth_failed: "Close non accetta più la chiave: salvane una nuova.",
                close_key_unreadable: "La chiave salvata non si legge più: salvala di nuovo.",
                close_dry_run_required: "Manca una prova senza salvare finita con questa chiave.",
                close_unavailable: "Close non rispondeva: la prossima sera riprova da sola.",
                other: "Si è fermata con un errore: lo controlla il team di Gioia365.",
            },
            reasonCode: "Codice: {code}",
            busy: "C'è un'importazione da Close in corso: aspetta che finisca.",
            readOnlyOn: "Importazione da Close ogni sera alle 21:00: accesa.",
            readOnlyOff: "Importazione da Close ogni sera alle 21:00: spenta.",
            readOnlyWho: "La accende e la spegne il Super admin di Gioia365.",
            // Il Super admin di Gioia365 che è nell'azienda come persona del team: passa al contesto di piattaforma e torna qui.
            platformShortcut: "Per la chiave e i pulsanti entra come Super admin di Gioia365:",
            platformShortcutButton: "Entra come Super admin di Gioia365",
        },
        // «Pronti a spegnere Close?» (M8, 22/10/2026): la verifica del passaggio, soltanto per il Super admin di Gioia365. Soltanto numeri.
        handover: {
            title: "Pronti a spegnere Close?",
            intro: "Prima della disdetta: dall'ultima importazione finita, quanti dati ci sono in Close e quanti sono già in Gioia365, e perché qualcuno manca. I numeri vengono da ciò che l'importazione ha già salvato: guardarli non chiede niente a Close, e quindi non vede ciò che è entrato in Close dopo. Per questo il controllo vale soltanto dopo che Close è in sola lettura per il team e dopo l'ultima importazione.",
            base: "Ultima importazione finita: {date} alle {time}.",
            ready: "Tutto a posto",
            readyText: "In Gioia365 c'è tutto ciò che l'ultima importazione ha letto da Close, audio e allegati compresi. Se Close era già in sola lettura prima di quell'importazione, si può disdire.",
            notReady: "Non ancora",
            notReadyText: "Prima della disdetta manca:",
            item: {
                no_import: "Un'importazione da Close finita: non ce n'è ancora una.",
                import_old: "Un'importazione di oggi: l'ultima finita è del {date} alle {time}.",
                unexplained: "{resource}: {count} in Close che non si trovano in Gioia365 e non si sa perché. Lo guarda il team di Gioia365.",
                new_after_run: "{resource}: {count} in Close dopo l'ultima importazione, che entrano con la prossima.",
                unknown_type: "{count} attività di Close di un tipo che Gioia365 non conosce: non sono entrate e con la disdetta si perdono. Da decidere: farle entrare (va costruito) oppure lasciarle in Close.",
                audio_copy_off: "L'audio di {count} chiamate è ancora soltanto in Close e la copia è spenta: manca lo spazio dove salvarlo.",
                audio_to_copy: "L'audio di {count} chiamate è ancora da copiare: la copia va avanti da sola, ogni minuto.",
                audio_failed: "L'audio di {count} chiamate non si è copiato dopo tutti i tentativi: lo guarda il team di Gioia365.",
                counted_only: "{resource}: {count} in Close che non entrano in Gioia365, per ora soltanto contati. Da decidere prima della disdetta.",
                counted_only_savedSearches: "Ricerche salvate: {count} in Close che non sono diventate Smart List e non sono ancora decise; con la disdetta si perdono. Per ognuna, qui sotto: «Rifatta a mano» oppure «Lasciata perdere».",
                attachments_copy_off: "Allegati delle note ancora soltanto in Close: {count}, e la copia è spenta: manca lo spazio dove salvarli.",
                attachments_to_copy: "Allegati delle note ancora da copiare: {count}. La copia va avanti da sola, ogni minuto.",
                attachments_failed: "Allegati delle note non copiati dopo tutti i tentativi, o più grandi di 50 MB: {count}. Li guarda il team di Gioia365; se serve si scaricano a mano da Close prima della disdetta.",
                lead_not_updatable: "{resource}: {count} in Close su un Lead che in Gioia365 non c'è più (eliminato per sempre) o che è stato archiviato o unito proprio mentre l'importazione girava: non sono entrati. La prossima importazione riprova; su un Lead eliminato per sempre non entrano più.",
            },
            caption: "Close e Gioia365 a confronto",
            what: "Cosa",
            inClose: "In Close",
            inGioia365: "In Gioia365",
            difference: "La differenza",
            notEntering: "non entrano",
            noDifference: "Nessuna",
            resource: {
                leads: "Lead",
                calls: "Chiamate",
                notes: "Note",
                emails: "Email",
                events: "Eventi della storia",
                opportunities: "Opportunità",
                otherActivities: "SMS e altre attività",
                openTasks: "Task aperti",
                savedSearches: "Ricerche salvate",
                people: "Persone di Close",
            },
            resourceHint: {
                events: "Cambi di status, riunioni, Task completati, aggiornamenti e unioni fatti in Close e il resto della storia.",
                emails: "Entrano nella Timeline del Lead come storia, con oggetto e testo: Gioia365 non le manda.",
                openTasks: "Entrano come richiami nella sezione Task; quelli scaduti da più di 30 giorni o che non possono, in una nota sulla scheda del Lead.",
                savedSearches: "Entrano come Smart List quando i loro filtri ci sono anche in Gioia365; le altre, con il motivo, sono qui sotto.",
                people: "Gli utenti di Close, anche quelli che non ci sono più.",
            },
            reason: {
                no_phone: "{count} senza un numero valido: non entrano",
                merged: "{count} uniti a un altro Lead: la loro storia è sul Lead che resta",
                lead_not_imported: "{count} di un Lead che non è entrato",
                lead_not_updatable: "{count} su un Lead eliminato per sempre, o archiviato o unito durante l'importazione: non entrati",
                invalid_date: "{count} senza una data valida",
                in_note: "{count} in una nota sulla scheda del Lead",
                too_old: "{count} scaduti da più di 30 giorni: in una nota sulla scheda del Lead",
                out_of_scope: "{count} SMS e riepiloghi di conversazioni email (le email entrano una a una): non fanno parte di Gioia365",
                unknown_type: "{count} di un tipo che Gioia365 non conosce",
                new_after_run: "{count} arrivati dopo l'ultima importazione: entrano con la prossima",
                counted_only: "{count} da rifare a mano o lasciare perdere",
                decided: "{count} decise: rifatte a mano o lasciate perdere",
                historic_author: "{count} restano soltanto come autori delle loro attività",
                invited: "{count} invitati nel team, non hanno ancora accettato",
            },
            unexplained: "{count} non spiegati",
            audioTitle: "Audio delle chiamate",
            audioWithAudio: "Chiamate con l'audio in Close",
            audioCopied: "Copiate in Gioia365",
            audioToCopy: "Da copiare",
            audioFailed: "Non riuscite",
            audioMissing: "Non più in Close",
            audioOff: "La copia dell'audio è spenta: manca lo spazio dove salvarlo. La accende il team di Gioia365.",
            attachmentsTitle: "Allegati delle note",
            attachmentsTotal: "Allegati delle note di Close",
            attachmentsCopied: "Copiati in Gioia365",
            attachmentsToCopy: "Da copiare",
            attachmentsFailed: "Non riusciti",
            attachmentsMissing: "Non più in Close",
            attachmentsOff: "La copia degli allegati è spenta: manca lo spazio dove salvarli, lo stesso dell'audio. La accende il team di Gioia365.",
            savedSearchesTitle: "Ricerche salvate di Close da rifare",
            savedSearchesText: "Quelle che non sono diventate Smart List, con il motivo. Per ognuna: «Rifatta a mano» quando c'è la Smart List, «Lasciata perdere» se non serve più. Una decisa non ferma più la disdetta, e la scelta si può annullare. Mai i filtri di Close.",
            savedSearchUnnamed: "Ricerca senza nome",
            savedSearchRebuilt: "Rifatta a mano",
            savedSearchDropped: "Lasciata perdere",
            savedSearchUndo: "Annulla",
            savedSearchDecided: "{decision}: {name}, il {date} alle {time}",
            savedSearchActions: "Decisione su «{name}»",
            savedSearchReason: {
                not_lead: "non cerca Lead",
                text_query: "è una ricerca a testo",
                user_dependent: "dipende da chi la guarda («i miei Lead»)",
                nesting: "ha più livelli di filtri di quanti una Smart List ne tenga",
                unknown_clause: "ha un filtro che le Smart List non hanno (date, attività, testo)",
                field: "cerca un campo che in Gioia365 è una nota",
                status: "cerca uno status che in Gioia365 non c'è",
                owner: "cerca un owner che in Gioia365 non è un Commerciale",
                tag: "cerca un tag che in Gioia365 non c'è",
                value: "cerca una voce che in Gioia365 non c'è",
                too_long: "diventerebbe un filtro troppo lungo",
                no_owner: "è di chi non è una persona attiva del team",
                name_taken: "il suo owner ha già una lista con quel nome",
                not_examined: "non ancora esaminata: con la prossima importazione",
            },
            savedSearchesMore: "e altre {count}",
            after: "L'ordine, deciso da Lucio: Close in sola lettura per il team, l'ultima importazione, l'audio e gli allegati copiati, «Tutto a posto» qui, poi la disdetta.",
        },
        when: {
            dryRun: "Prova senza salvare del {date} alle {time}",
            apply: "Importazione del {date} alle {time}",
        },
        duration: {
            seconds: "{count} s",
            minutes: "{count} min",
            hours: "{hours} h {minutes} min",
        },
        runs: {
            title: "Esecuzioni",
            intro: "Dalla più recente. Clicca la data per aprire il rapporto.",
            caption: "Prove senza salvare e importazioni da Close",
            when: "Quando",
            what: "Che cosa",
            state: "Stato",
            duration: "Durata",
            empty: "Per ora non c'è nessuna prova e nessuna importazione. Si comincia con una prova senza salvare, che avvia il Super admin di Gioia365.",
            dryRun: "Prova senza salvare",
            apply: "Importazione",
            synthetic: "con dati inventati, per provare la pagina",
            dryRunSub: "legge Close e mostra cosa entrerebbe, senza salvare niente",
            applySub: "scrive in Gioia365 Lead, storico e note",
            running: "in corso",
            completed: "finita",
            failed: "fermata con errore",
            aborted: "interrotta",
            runningFor: "in corso da {duration}",
            leadsRead: "{count} Lead letti da Close",
        },
        phases: {
            label: "Fasi",
            extract: "Legge i dati da Close",
            plan: "Confronta con Gioia365",
            apply: "Scrive in Gioia365",
            done: "Scrive il rapporto",
            stateDone: "fatto",
            stateNow: "adesso",
            stateTodo: "dopo",
        },
        running: {
            subDryRun: "{when}, in corso. In Gioia365 non cambia niente.",
            subApply: "{when}, in corso. Nella fase «Scrive in Gioia365» i Lead entrano un blocco alla volta.",
            leadsRead: "Lead letti da Close: {count}",
            activitiesRead: "Attività lette da Close (chiamate, note e le altre): {count}",
            starting: "Sta cominciando a leggere da Close.",
            phaseNow: "Fase in corso: {phase}.",
            heartbeat: "Ultimo segnale dell'esecuzione: {time}.",
            silent: "Nessun segnale dalle {time}: forse si è fermata. La riprende dal punto in cui era arrivata la prossima prova o importazione dello stesso tipo.",
            reportLaterDryRun: "Il rapporto completo arriva quando la prova finisce.",
            reportLaterApply: "Il rapporto completo arriva quando l'importazione finisce.",
        },
        stopped: {
            failed: "Fermata con errore dopo {duration}, nella fase «{phase}».",
            aborted: "Interrotta dopo {duration}, nella fase «{phase}».",
            dryRun: "In Gioia365 non è cambiato niente: una prova senza salvare non scrive mai. Se ne fa un'altra con «Prova senza salvare».",
            applyBeforeWriting: "In Gioia365 non è cambiato niente: si è fermata prima di scrivere. La prossima importazione rilegge tutto da Close.",
            applyWhileWriting: "Ciò che aveva già scritto resta in Gioia365. La prossima importazione rilegge tutto da Close e scrive soltanto ciò che manca o è cambiato.",
            newer: "Apri l'esecuzione successiva, del {date} alle {time}",
            reasonAuth: "Close non ha accettato la chiave.",
            reasonAbandoned: "Chiusa per far posto a un'esecuzione nuova.",
            reasonCode: "Codice dell'errore: {code}.",
        },
        unreadable: "Il rapporto di questa esecuzione non si legge: lo controlla il team di Gioia365. L'esecuzione resta nell'elenco.",
        jump: {
            label: "Vai a una parte del rapporto",
            lead: "Vai a:",
            summary: "Riepilogo",
            users: "Utenti di Close",
            variables: "Variabili",
            check: "Da controllare",
        },
        summary: {
            title: "Riepilogo",
            subDryRun: "{when}: cosa succederebbe. In Gioia365 non è cambiato niente. Durata: {duration}.",
            subApply: "{when}: cosa è entrato in Gioia365. Durata: {duration}.",
            leads: {
                title: "Lead",
                sub: "In Close {count} Lead.",
                create: "Nuovi",
                createSubDryRun: "non ancora in Gioia365: entrerebbero",
                createSubApply: "non erano in Gioia365: sono entrati",
                update: "Aggiornati",
                updateSub: "già in Gioia365, con qualcosa di nuovo in Close: cambiano soltanto i campi che in Gioia365 nessuno ha toccato",
                unchanged: "Invariati",
                unchangedSub: "uguali all'ultima importazione: non si toccano",
                skipped: "Non importati",
                skippedSub: "senza nessun numero di telefono, nemmeno nelle chiamate o negli altri contatti",
                missing: "Non più in Close",
                missingSub: "in Gioia365 restano: un Lead non si cancella da solo",
            },
            history: {
                title: "Storico di Close",
                sub: "Entra nella Timeline di ogni Lead, con autore e data originali.",
                subAgain: "Soltanto ciò che è nuovo rispetto all'importazione precedente.",
                calls: "Chiamate",
                callsSub: "giorno, ora, durata, esito, chi ha chiamato e gli appunti",
                callsInvalid: "giorno, ora, durata, esito, chi ha chiamato e gli appunti; {count} non riuscite per un errore tecnico, che non contano",
                notes: "Note",
                notesSub: "scritte in Close, con autore e data, e le note fatte dai campi di Close",
                statusChanges: "Cambi di status",
                // Le email di Close entrano come storia (22/10/2026).
                emails: "Email di Close",
                emailsSub: "nella Timeline del Lead, con direzione, oggetto e testo; Gioia365 non le manda",
                other: "Altri eventi",
                otherSub: "riunioni, Task completati, attività come «Qualification Call», cambi di fase delle opportunità, aggiornamenti da un'importazione e unioni di Lead fatti in Close",
                // Le opportunità di Close (INGR-26): nuove, aggiornate da Close, rimaste fuori in una nota sulla scheda.
                opportunities: "Opportunità",
                opportunitiesSub: "con fase, valore e chi le segue; aggiornate da Close: {update}; rimaste fuori, in una nota sulla scheda: {skipped}",
                // I Task aperti di Close (22/10/2026): richiami nuovi, aggiornati, chiusi perché completati in Close, rimasti fuori in una nota.
                // Le disco e le demo storiche di Close (22/10/2026).
                appointments: "Disco e demo storiche",
                appointmentsSub: "appuntamenti già chiusi, a chi li ha prenotati, nel giorno della prenotazione; aggiornati da Close: {update}; rimasti fuori (già in Gioia365, o senza nessuno del team): {skipped}; riunioni che non si capisce se siano disco o demo, soltanto nella Timeline: {ambiguous}",
                tasks: "Task aperti",
                tasksSub: "come richiami nella sezione Task; aggiornati da Close: {update}; chiusi perché completati in Close: {completed}; rimasti fuori, in una nota sulla scheda: {skipped}, di cui scaduti da più di 30 giorni: {tooOld}",
            },
            later: {
                title: "Smart View di Close",
                sub: "Diventano Smart List quando i loro filtri ci sono anche in Gioia365; prima quelle di Mirko.",
                savedSearches: "Smart View in Close",
                savedSearchesSub: "nuove Smart List: {create}; aggiornate da Close: {update}; da rifare a mano, con il motivo in «Pronti a spegnere Close?»: {skipped}",
            },
            notImported: {
                title: "Non si importano",
                sub: "Contati, restano in Close.",
                email: "Email",
                emailThread: "Conversazioni email",
                sms: "SMS",
                emailSub: "gli SMS non fanno parte di Gioia365; delle conversazioni email entrano le singole email",
                otherSub: "un tipo di attività che Gioia365 non conosce",
                recordings: "Registrazioni delle chiamate",
                recordingsSub: "i dati della chiamata entrano, l'audio si copia dopo, in coda, nell'archivio di Gioia365",
            },
        },
        users: {
            title: "Utenti di Close",
            intro: "Ogni utente di Close e a chi corrisponde in Gioia365. Si abbinano per email: se una persona del team usa un'altra email, l'abbinamento si fa a mano prima della prova successiva. Chi non è nel team entra come persona sospesa, con il nome che ha in Close.",
            peopleDryRun: "Persone di Close che non ci sono più: entrerebbero come sospese {count}.",
            peopleApply: "Persone di Close che non ci sono più: entrate come sospese {count}.",
            peopleExisting: "Già in Gioia365 da un'importazione precedente, sospese o come le ha messe il Team dopo (riattivate, archiviate): {count}.",
            caption: "Utenti di Close e persone di Gioia365",
            closeUser: "Utente di Close",
            inGioia: "In Gioia365",
            how: "Come si abbinano",
            leadsOwned: "Owner in Close di",
            calls: "Chiamate in Close",
            notes: "Note in Close",
            effect: "Cosa succede ai suoi Lead",
            historic: "autore storico, non nel team",
            historicNoEmail: "autore storico: in Close non ha un'email valida",
            historicPlatform: "autore storico: è il gestore della piattaforma",
            historicNoRole: "autore storico: l'azienda non ha il ruolo User",
            invitedPill: "invitato: non ha ancora accettato",
            newSuspended: "entrerebbe come persona sospesa",
            newSuspendedApply: "entra come persona sospesa alla prossima importazione",
            commercial: "Commerciale: può essere owner",
            leader: "guida il team: non diventa owner",
            inactive: "non è attivo nel team",
            suspended: "sospeso: resta owner dei suoi Lead",
            suspendedFromClose: "sospeso, da Close: resta owner dei suoi Lead",
            archived: "archiviato: non riceve Lead",
            byEmail: "stessa email",
            byHand: "abbinato a mano",
            none: "nessuno nel team con la sua email",
            effectOwner: "Restano suoi, con chiamate e note.",
            effectInactive: "Entrano senza owner, da assegnare: la persona non è attiva nel team. Chiamate e note restano sue.",
            effectLeader: "Entrano senza owner, da assegnare: owner può essere soltanto un Commerciale (User). Chiamate e note restano sue.",
            effectLeadsTo: "I suoi Lead vanno a {name}, per la regola del passaggio da Close, se in Gioia365 nessuno ha già cambiato l'owner. Chiamate e note restano sue.",
            effectNotLinked: "Entrano senza owner, da assegnare; sulla scheda resta «Owner in Close: {name}». Chiamate e note entrano con il suo nome e il segno «da Close».",
            effectSuspended: "Restano suoi, con chiamate e note, finché qualcuno non li riassegna dal Team. La persona è sospesa: non riceve Lead nuovi e non occupa un posto; se viene da Close torna nel team soltanto con un invito che accetta lei.",
            effectNewSuspended: "Entra come persona sospesa con il nome di Close: i Lead restano suoi, chiamate e note pure, e i report la mostrano per nome. Non riceve Lead nuovi e non occupa un posto; torna nel team soltanto con un invito che accetta lei.",
            effectNewSuspendedLater: "In questa importazione non è nata: i suoi Lead sono entrati senza owner, con «Owner in Close: {name}». Nasce sospesa con la prossima, che le dà i Lead che nessuno ha cambiato.",
            effectArchived: "Entrano senza owner, da assegnare: la persona è archiviata. Chiamate e note restano sue.",
            effectInvited: "Entrano senza owner finché non accetta l'invito: dall'importazione dopo sono suoi. Chiamate e note entrano con il suo nome.",
            nobody: "Nessuno",
            nobodyHow: "Lead senza owner in Close",
            nobodyEffect: "Entrano senza owner, come in Close.",
            countsNote: "I numeri sono quelli di Close: i Lead di cui è owner in Close, le chiamate che ha fatto e le note che ha scritto in Close. Una persona sospesa da Close si riattiva o si archivia dal Team, come le altre.",
        },
        variables: {
            title: "Come passano le variabili",
            intro: "Una riga per campo di Close: dove va in Gioia365, i valori trovati e quanti Lead li hanno. In rosso, con la ✕, i valori che non hanno ancora una corrispondenza: non si perdono, restano in una nota sulla scheda.",
            caption: "Come passano i campi di Close in Gioia365",
            closeField: "Campo di Close",
            inGioia: "In Gioia365",
            values: "Valori trovati",
            filled: "Lead con un valore",
            bandData: "Diventano dati della scheda",
            bandNote: "Diventano note sulla scheda, con «data originale non nota»",
            bandOther: "Servono ad altro o non si copiano",
            unmappedOne: "1 campo ha valori senza corrispondenza. Valori che vanno in una nota sulla scheda: {notes}.",
            unmappedMany: "{count} campi hanno valori senza corrispondenza. Valori che vanno in una nota sulla scheda: {notes}.",
            allMapped: "Tutti i valori hanno la loro corrispondenza.",
            onlyUnmapped: "Soltanto i campi con valori senza corrispondenza",
            noneUnmapped: "Nessun campo con valori senza corrispondenza: tutti i valori hanno la loro voce.",
            empty: "Questa esecuzione non ha trovato campi di Close da passare.",
            unmapped: "{value} → nessuna corrispondenza · {leads} · resta in una nota",
            mapped: "{value} → {label}",
            leads: "{count} Lead",
            freeText: "Testo libero: il testo non si mostra, soltanto quanti Lead lo hanno.",
            noteValues: "Va nella nota così com'è.",
            ignored: "Non si copia: il valore resta in Close.",
            ownerInfo: "Vedi «Utenti di Close» qui sopra.",
            regionInfo: "Serve a riconoscere la città quando ci sono più comuni con lo stesso nome.",
            showAll: "Mostra tutti i {count} valori",
            showFewer: "Mostra meno valori",
            to: {
                tags: "Tag, con lo stesso nome",
                salonName: "Nome Azienda Target",
                owner: "Owner",
                createdAt: "Data d'ingresso",
                city: "Non diventa un campo",
                note: "Una nota: Campo «{label}» di Close",
                ignored: "Non si copia",
            },
        },
        check: {
            title: "Da controllare",
            introDryRun: "I casi che la prova ha trovato, gruppo per gruppo. Ogni gruppo si apre con i riferimenti di Close; dopo l'importazione, accanto a ognuno c'è «Apri il Lead».",
            introApply: "I casi che l'importazione ha trovato, gruppo per gruppo. Ogni gruppo si apre con i riferimenti di Close e «Apri il Lead» per i Lead che vedi.",
            look: "Da guardare",
            lookSub: "Avvisi: qui c'è da decidere qualcosa, oppure da sistemare un dato dopo l'importazione.",
            know: "Solo da sapere",
            knowSub: "Informazioni: l'importazione sa già cosa fare.",
            noCases: "Nessun caso: {names}.",
            group: "{name}: {count}",
            what: "Cosa succede:",
            caption: "{name}: i casi",
            ref: "Riferimento in Close",
            detail: "Che cosa",
            inGioia: "In Gioia365",
            open: "Apri il Lead",
            notImported: "non importato",
            notYet: "non ancora in Gioia365",
            shown: "Mostrati {shown} su {total}.",
            all: "Tutti i {total} casi.",
            perUser: "Una riga per utente di Close.",
            more: "Mostra altri {count}",
            empty: "Nessun caso da mostrare.",
            refs: {
                lead: "Lead {id}",
                activity: "Attività {id}",
                user: "Utente di Close {id}",
                opportunity: "Opportunità {id}",
                task: "Task {id}",
                appointment: "Disco o demo {id}",
                saved_search: "Smart View {id}",
                other: "{resource} {id}",
            },
        },
        // Un gruppo di «Da controllare» per ogni anomalia dell'importatore (`apps/server/src/close-import/anomalies.ts`): il nome
        // in italiano semplice e «Cosa succede» (proposta 13); le ultime due non erano nel mock-up.
        anomalies: {
            no_phone: { name: "Lead senza telefono", what: "Senza nessun numero, nemmeno nelle chiamate o negli altri contatti, un Lead non entra: è già deciso. Resta in Close." },
            duplicate_phone: { name: "Stesso cellulare su due Lead", what: "Entrano tutti e due, ognuno con il suo storico: il numero è anche di un altro Lead di Close, o di più Lead di Gioia365. Se sono la stessa persona si uniscono con «Pulizia dati»." },
            joined_by_mobile: { name: "Unito a un Lead che c'era già", what: "Il cellulare era già di un Lead di Gioia365 entrato da un'altra parte (Meta, GoHighLevel, un file, a mano): la storia di Close va su quel Lead, che tiene status e owner; niente doppione." },
            invalid_phone: { name: "Numero non valido", what: "Il numero non diventa il cellulare né il fisso: resta in una nota sulla scheda." },
            phone_from_calls: { name: "Numero preso dalle chiamate", what: "Il titolare non aveva un numero valido: vale il numero dell'ultima chiamata fatta in Close (questione aperta 48)." },
            phone_from_other_contact: { name: "Numero preso da un altro contatto", what: "Senza altri numeri vale il primo numero valido di un altro contatto del Lead (questione aperta 80)." },
            city_not_found: { name: "Città non riconosciuta", what: "Il Lead entra senza città; indirizzo e CAP restano. La città si sceglie poi sulla scheda." },
            city_ambiguous: { name: "Città con più comuni dello stesso nome", what: "Manca la provincia e i comuni con quel nome sono più di uno: il Lead entra senza città." },
            unknown_status: { name: "Status che Gioia365 non conosce", what: "Lo status diventa «No Type»." },
            unmapped_option: { name: "Valore senza corrispondenza", what: "Il campo resta vuoto e il valore va in una nota sulla scheda, finché non si decide la voce nella revisione delle variabili." },
            field_conflict: { name: "Due campi di Close che dicono cose diverse", what: "Vale il primo campo; il valore dell'altro va in una nota sulla scheda (questione aperta 53)." },
            owner_not_linked: { name: "Owner di Close che in Gioia365 non può essere owner", what: "Il Lead entra senza owner, da assegnare: owner può essere soltanto un Commerciale (User) del team, attivo o sospeso; chi in Close non ha un'email resta un nome. Sulla scheda resta scritto chi era l'owner in Close." },
            invalid_email: { name: "Email non valida", what: "Non diventa l'email del Lead: resta in una nota." },
            invalid_date: { name: "Data non valida", what: "La data non si scrive: vale la data successiva, oppure l'attività non entra." },
            missing_in_source: { name: "Lead che non c'è più in Close", what: "In Gioia365 resta com'era: un Lead non si cancella mai da solo (questione aperta 57)." },
            local_change_kept: { name: "Cambiato sia in Close sia in Gioia365", what: "Qualcuno l'ha cambiato in Gioia365 dopo l'importazione: resta quello di Gioia365 (questione aperta 57)." },
            source_changed_after_import: { name: "Attività cambiata in Close dopo l'importazione", what: "In Gioia365 resta com'era all'importazione; qui si vede che in Close è cambiata." },
            value_too_long: { name: "Valore troppo lungo per il campo", what: "Il campo resta vuoto e il valore intero va in una nota sulla scheda." },
            lead_not_updatable: { name: "Lead archiviato o unito in Gioia365", what: "L'importazione non ne cambia la scheda; la sua storia nuova di Close entra lo stesso, sul Lead che resta se è unito, e Task e opportunità nuovi in una nota." },
            // Le opportunità di Close (INGR-26).
            unknown_opportunity_status: { name: "Fase di un'opportunità che Gioia365 non conosce", what: "L'opportunità non entra: fase, valore, date e nota vanno in una nota sulla scheda del Lead." },
            task_not_imported: {
                name: "Task aperto rimasto fuori",
                what: "Non diventa un richiamo, perché il Lead ne ha già uno aperto, perché nessuno del team lo può avere o perché in Close non è una telefonata da fare: i suoi dati vanno in una nota sulla scheda del Lead.",
            },
            // Le ricerche salvate di Close (22/10/2026).
            saved_search_not_imported: {
                name: "Smart View di Close che non diventa Smart List",
                what: "La Smart List non nasce: un filtro di Close non c'è in Gioia365, oppure manca l'owner o il nome è già preso. Il nome e il motivo sono in «Pronti a spegnere Close?», per rifarla a mano.",
            },
            // Le disco e le demo storiche di Close (22/10/2026).
            appointment_not_imported: {
                name: "Disco o demo di Close non entrata",
                what: "Non diventa un appuntamento: c'è già lo stesso in Gioia365, oppure nessuno del team l'ha prenotata e il Lead non ha owner, oppure è una riunione di Close che non si capisce se sia una disco o una demo, che resta nella Timeline e non conta nei report.",
            },
            opportunity_not_imported: { name: "Opportunità rimasta fuori", what: "Non entra, perché un Lead ha al massimo un'opportunità aperta o perché nessuno del team la può seguire: i suoi dati vanno in una nota sulla scheda del Lead." },
            opportunity_incomplete: { name: "Opportunità con un dato che manca", what: "Entra lo stesso. Una vendita senza valore conta con zero euro; una vendita di chi non è nel team non conta nei report delle vendite." },
            name_split_uncertain: { name: "Nome e cognome da controllare", what: "Una parola sola, o più di tre: la divisione si controlla e si corregge sulla scheda." },
            extra_contacts: { name: "Più di due persone sullo stesso Lead", what: "La prima persona è il titolare, la seconda il secondo titolare; le altre vanno nella nota «Altri contatti da Close» (questione aperta 50)." },
            extra_phones: { name: "Numeri in più", what: "I numeri oltre cellulare e fisso vanno in una nota sulla scheda." },
            city_foreign: { name: "Indirizzo all'estero", what: "Il Lead entra senza città: le città sono i comuni italiani." },
            author_not_linked: { name: "Attività di chi non è nel team", what: "Entra con il nome di chi l'ha fatta e il segno «da Close», ma non è di nessuno del team." },
            created_on_used: { name: "Data d'ingresso presa da «Creato il»", what: "La data d'ingresso è quella del campo di Close «Creato il», non quella in cui il Lead è nato in Close (questione aperta 51)." },
            last_call_mismatch: { name: "Ultima chiamata diversa da quella scritta in Close", what: "Non cambia niente: l'ultima chiamata si ricava dalle chiamate importate. È soltanto un controllo." },
            activity_not_imported: { name: "Attività che non si importano", what: "Si contano e non entrano: le email, le conversazioni email e gli SMS non fanno parte di Gioia365, gli altri sono tipi di attività che Gioia365 non conosce." },
            recording_not_copied: { name: "Audio da copiare da Close", what: "I dati della chiamata entrano; l'audio si copia dopo, in coda, nell'archivio di Gioia365." },
            attachments_not_copied: { name: "Allegati da copiare da Close", what: "La nota entra e dice quanti allegati aveva; gli allegati si copiano dopo, in coda, nell'archivio di Gioia365." },
            nul_characters_removed: { name: "Caratteri non validi tolti dal testo", what: "Caratteri invisibili che il database non accetta: si tolgono e il resto del testo entra." },
            unknown: { name: "Altri casi ({code})", what: "Un caso che questa pagina non sa ancora spiegare: lo guarda il team di Gioia365." },
        },
        // «Che cosa» di ogni caso: soltanto valori dei campi a scelta, conteggi e riferimenti tecnici di Close.
        detail: {
            holderPrimary: "titolare",
            holderSecond: "secondo titolare",
            noPhone: "nessun numero valido; chiamate in Close: {calls}; numeri negli altri contatti: {others}",
            phoneFromCalls: "chiamate in Close: {calls}; vale il numero dell'ultima",
            phoneFromSecond: "preso dal secondo titolare",
            phoneFromContact: "preso dal contatto n. {contact} di Close",
            invalidPhone: "{holder}: {reason}",
            phoneReason: {
                too_short: "numero troppo corto",
                too_long: "numero troppo lungo",
                invalid_characters: "non è un numero",
                empty: "numero vuoto",
                other: "numero non valido",
            },
            duplicateClose: "lo stesso {phone} è su altri Lead di Close: {count}",
            duplicateGioia: "su Lead già in Gioia365: {count}",
            joined: "unito al Lead con lo stesso cellulare, entrato da un'altra parte",
            joinedArchived: "unito al Lead archiviato con lo stesso cellulare, che resta archiviato",
            phoneSlot: {
                primaryMobile: "cellulare del titolare",
                primaryLandline: "fisso del titolare",
                secondMobile: "cellulare del secondo titolare",
                other: "numero",
            },
            provinceWritten: "provincia scritta in Close: {province}",
            provinceEmpty: "provincia vuota",
            candidates: "comuni con lo stesso nome: {count}",
            country: "Paese: {country}",
            countryUnknown: "Paese non indicato",
            italy: "Italia",
            closeStatus: "status in Close: «{status}»",
            closeStatusUnknown: "status sconosciuto",
            option: "campo «{field}»: «{value}»",
            optionNoValue: "campo «{field}»",
            callOutcome: "esito della chiamata in Close: «{value}»",
            optionReason: {
                hidden_tag: "tag nascosto in Gioia365",
                field_missing: "il campo non c'è in Gioia365",
                field_not_choice: "il campo in Gioia365 non è a scelta",
                option_missing: "la voce non c'è più in Gioia365",
            },
            conflict: "«{field}» dice una cosa diversa da «{target}»",
            conflictNoTarget: "«{field}» dice una cosa diversa",
            ownerName: "owner in Close: {name}",
            ownerReason: {
                not_linked: "non è nel team",
                suspended: "non è attivo nel team",
                not_commercial: "non è un Commerciale",
                not_eligible: "non può essere owner",
            },
            ownerUnknown: "l'owner di Close non può essere owner in Gioia365",
            author: "attività di {name}: {count}",
            authorUnknown: "un utente di Close senza nome",
            nameOneWord: "{holder}: una parola sola, è nel Nome",
            nameWords: "{holder}: {count} parole",
            emailOf: "email del {holder}",
            dateActivity: "data dell'attività",
            dateCreated: "data di creazione in Close",
            dateField: "«{field}»",
            createdOn: "data d'ingresso presa dal campo di Close",
            lastCall: {
                no_call: "in Close l'ultima chiamata è scritta, ma non c'è nessuna chiamata",
                date: "in Close l'ultima chiamata è di un altro giorno",
                user: "in Close l'ultima chiamata è di un'altra persona",
                date_and_user: "in Close l'ultima chiamata è di un altro giorno e di un'altra persona",
            },
            missing: "non c'è più in Close",
            kept: "campo «{field}»: resta quello di Gioia365",
            keptReason: {
                phone_repeated_on_lead: "il numero è già sul Lead",
                phone_required: "serve almeno un telefono",
                open_exists: "il Lead ha già un'altra opportunità aperta",
            },
            changed: {
                call: "chiamata cambiata in Close",
                note: "nota cambiata in Close",
                other: "attività cambiata in Close",
                mapping_changed: "nota che ora si leggerebbe in un altro modo",
                not_in_source: "nota che in Close non c'è più",
            },
            closeType: "tipo in Close: {type}",
            closeTypeUnknown: "tipo sconosciuto",
            // I tipi di Close che Gioia365 conosce ma non importa (questione 47, chiusa), con il nome che hanno in Close.
            outOfScope: {
                Email: "email: le email non fanno parte di Gioia365",
                EmailThread: "riepilogo di una conversazione email: le sue email entrano una a una",
                SMS: "SMS: gli SMS non fanno parte di Gioia365",
            },
            recordingAndVoicemail: "registrazione e messaggio in segreteria",
            recording: "registrazione della chiamata",
            voicemail: "messaggio in segreteria",
            extraContacts: "persone in più: {count}",
            extraPhones: "numeri in più: {count}",
            attachments: "allegati: {count}",
            nul: "testi ripuliti: {count}",
            tooLong: "campo «{field}»: {length} caratteri, ne entrano {max}",
            notUpdatable: {
                archived: "archiviato in Gioia365",
                merged: "unito a un altro Lead",
                missing: "non c'è più in Gioia365",
            },
            opportunityStage: "fase in Close: «{stage}»",
            opportunityStageUnknown: "fase senza nome",
            keptOpportunity: "opportunità: resta quella di Gioia365",
            keptTask: "Task: resta quello di Gioia365",
            appointmentReason: {
                duplicate: "c'è già in Gioia365",
                no_person: "nessuno del team l'ha prenotata e il Lead non ha owner",
                ambiguous: "riunione che non si capisce se sia una disco o una demo",
            },
            appointmentKind: {
                disco: "disco",
                demo: "demo",
            },
            taskReason: {
                open_exists: "il Lead ha già un richiamo aperto",
                no_assignee: "nessuno del team lo può avere",
                unknown_type: "un tipo di Task di Close che non è una telefonata",
                too_old: "scaduto da più di 30 giorni",
                lead_not_updatable: "il Lead è archiviato o unito in Gioia365: in una nota sulla scheda",
            },
            opportunityReason: {
                open_exists: "il Lead ha già un'opportunità aperta",
                no_assignee: "nessuno del team la può seguire",
                lead_not_updatable: "il Lead è archiviato o unito in Gioia365: in una nota sulla scheda",
            },
            opportunityMissing: {
                value_missing: "venduta senza valore",
                value_invalid: "valore che Gioia365 non accetta",
                closer_not_linked: "venduta da chi non è nel team",
            },
        },
    },
    // Impostazioni → «Importazione ed esportazione» → «GoHighLevel» (INGR-29, scelta di Claude 24/10/2026): la chiave del sotto-account
    // e la prova di lettura, soltanto per il Super admin di Gioia365. Niente entra in Gioia365 (INGR-2); la prova dice soltanto numeri.
    ghlRead: {
        about: {
            title: "A cosa serve",
            text: "Gioia365 legge da GoHighLevel contatti, email e conversazioni per incrociarli con i Lead e completare la storia che manca da Close. Prima si prova senza salvare, poi si confermano i tag voce per voce, poi si importa: i campi dei Lead restano quelli di Close.",
            whoTitle: "Chi la vede",
            who: "Il Super admin e l'Admin di {organization}, e il Super admin di Gioia365. La chiave la salvano, la tolgono e la provano il Super admin di {organization} e il Super admin di Gioia365; importazione e scrittura su GoHighLevel soltanto il Super admin di Gioia365.",
        },
        denied: "GoHighLevel lo vedono il Super admin e l'Admin di {organization}, e il Super admin di Gioia365: con il tuo ruolo non lo vedi.",
        title: "Chiave e prova di lettura",
        intro: "Una chiave di sola lettura del sotto-account di GoHighLevel. Gioia365 la conserva cifrata e non la mostra più.",
        keyTitle: "Chiave",
        tokenLabel: "Private Integration Token",
        tokenHint: "Gioia365 lo prova con GoHighLevel prima di salvarlo e lo conserva cifrato: dopo non si rivede più, né qui né altrove.",
        locationLabel: "ID della posizione (Location ID)",
        locationHint: "Non è un segreto: identifica il sotto-account.",
        keySave: "Salva la chiave",
        keySaving: "La provo con GoHighLevel…",
        keySaved: "Chiave salvata il {date} alle {time} da {person}.",
        keySavedBySomeone: "Chiave salvata il {date} alle {time}.",
        keyLocation: "Posizione: {location}.",
        keyNone: "Nessuna chiave salvata.",
        keyActive: "Chiave salvata e attiva",
        keyChange: "Cambia la chiave",
        keyChangeCancel: "Lascia quella di adesso",
        keyRemove: "Togli la chiave",
        keyRemoveConfirm: "Togli la chiave? Gioia365 non potrà più leggere da GoHighLevel finché non ne salvi una nuova.",
        keyRemoveYes: "Sì, togli la chiave",
        keySavedToast: "Chiave salvata.",
        keyRemovedToast: "Chiave tolta.",
        howTitle: "Come creare la chiave in GoHighLevel",
        howStep1: "Entra nel sotto-account dell'azienda e apri «Settings» (Impostazioni).",
        howStep2: "Apri «Private Integrations» e premi «Create new integration».",
        howStep3: "Come nome scrivi «Gioia365».",
        howStep4: "Scegli soltanto gli ambiti di sola lettura: contacts.readonly, conversations.readonly, conversations/message.readonly, locations.readonly, locations/customFields.readonly, opportunities.readonly.",
        howStep5: "Crea l'integrazione e copia subito il token: GoHighLevel lo mostra una volta sola.",
        howLocation: "Il Location ID è in «Settings» → «Business Profile» (Profilo dell'attività), alla voce «Location ID»; è anche nell'indirizzo del sotto-account, dopo «/location/».",
        probeTitle: "Prova la lettura",
        probeText: "Conta i contatti e le conversazioni della posizione e ti dice soltanto i numeri: nessun nome, nessun dato, niente si scrive in GoHighLevel né in Gioia365.",
        probeStart: "Prova la lettura",
        probing: "Leggo da GoHighLevel…",
        probeNeedsKey: "Prima salva la chiave.",
        probeNone: "Nessuna prova di lettura con questa chiave.",
        probeWhen: "Ultima prova il {date} alle {time} da {person}.",
        probeWhenBySomeone: "Ultima prova il {date} alle {time}.",
        probeToast: "Prova di lettura fatta.",
        probeOk: "Lettura riuscita",
        resource: { contacts: "Contatti", conversations: "Conversazioni" },
        count: "{what}: {count}",
        outcome: {
            rejected: "{what}: GoHighLevel non accetta la chiave, o le manca un ambito.",
            forbidden: "{what}: alla chiave manca il permesso di leggerli.",
            rate_limited: "{what}: GoHighLevel ha ricevuto troppe richieste, riprova fra un minuto.",
            unavailable: "{what}: GoHighLevel non ha risposto, riprova fra qualche minuto.",
        },
        scopes: "Gli ambiti di sola lettura che servono: contacts.readonly, conversations.readonly, conversations/message.readonly, locations.readonly, locations/customFields.readonly, opportunities.readonly.",
        readOnlyOn: "Chiave di GoHighLevel: salvata.",
        readOnlyOff: "Chiave di GoHighLevel: non ancora salvata.",
        readOnlyWho: "La salvano e la provano il Super admin di {organization} e il Super admin di Gioia365.",
        platformShortcut: "Per la chiave e i pulsanti entra come Super admin di Gioia365:",
        platformShortcutButton: "Entra come Super admin di Gioia365",
        platformPartsWho: "L'importazione da GoHighLevel e la scrittura su GoHighLevel le fa il Super admin di Gioia365.",
        platformPartsShortcut: "Per l'importazione e la scrittura su GoHighLevel entra come Super admin di Gioia365:",
    },
    // La scrittura su GoHighLevel (INGR-19; campi e regole: scelta di Claude 29/10/2026), soltanto per il Super admin di Gioia365.
    ghlWrite: {
        title: "Scrittura su GoHighLevel",
        intro: "Gioia365 è l'anagrafica principale: tiene aggiornati i contatti di GoHighLevel perché le automazioni delle email li usino. Trova il contatto di ogni Lead dal legame che c'è già, poi dall'email, poi dal cellulare; se ne trova più d'uno non scrive niente. Mai fra le 21:00 e le 22:05 (l'importazione da Close). Spenta, non scrive niente.",
        fields: "Scrive nome, cognome, email e cellulare (soltanto se Gioia365 li ha: un vuoto non cancella), i campi {fields} e aggiunge i tag {tags} (mai tolti).",
        scopes: "Per scrivere il token deve avere anche gli ambiti: {scopes}.",
        stopped: {
            forbidden: "GoHighLevel ha rifiutato il token per scrivere e la scrittura si è spenta da sola. Crea un token nuovo che abbia anche gli ambiti {scopes}, salvalo qui sopra, rifai la prova e riaccendi.",
            fields_missing: "Un campo «G365 · …» non c'è più in GoHighLevel e la scrittura si è spenta da sola: riaccendila, i campi che mancano si ricreano.",
        },
        needsKey: "Prima salva la chiave.",
        loading: "Carico lo stato della scrittura…",
        counts: {
            considered: "Lead guardati: {count}",
            update: "Contatti da aggiornare: {count}",
            create: "Contatti da creare: {count}",
            unchanged: "Già aggiornati, niente da scrivere: {count}",
            noMatch: "Senza un contatto in GoHighLevel (non si crea): {count}",
            ambiguous: "Con più contatti possibili (non si scrive): {count}",
            rejected: "Rifiutati da GoHighLevel: {count}",
            archived: "Archiviati o uniti (non si scrive): {count}",
            failed: "Non riusciti, da riprovare: {count}",
        },
        dryRunTitle: "1. Prova senza scrivere",
        dryRunText: "Guarda i {count} Lead cambiati più di recente e ti dice che cosa scriverebbe, con qualche esempio coi dati coperti. Legge soltanto: in GoHighLevel non cambia niente.",
        dryRunStart: "Prova senza scrivere",
        dryRunRunning: "Provo…",
        dryRunToast: "Prova fatta: il risultato è qui sotto.",
        dryRunWhen: "Prova del {date} alle {time}, di {person}.",
        dryRunWhenNoOne: "Prova del {date} alle {time}.",
        dryRunOld: "Questa prova è stata fatta con una chiave di prima: rifalla.",
        noDryRun: "Nessuna prova ancora.",
        missingFields: "Campi da creare in GoHighLevel quando accendi: {fields}.",
        examplesTitle: "Esempi",
        exampleLead: "Lead",
        exampleWhat: "Che cosa farebbe",
        exampleFields: "Campi e tag",
        operation: {
            update: "Aggiorna il contatto trovato {by}",
            create: "Crea un contatto nuovo",
        },
        matchedBy: {
            contact: "dal legame",
            email: "dall'email",
            phone: "dal cellulare",
        },
        skip: {
            noMatch: "Niente: nessun contatto in GoHighLevel",
            ambiguous: "Niente: più contatti possibili",
            archived: "Niente: archiviato",
        },
        outcome: {
            ok: "Andato bene.",
            forbidden: "GoHighLevel ha rifiutato il token: servono anche gli ambiti {scopes}.",
            fields_missing: "Mancava un campo «G365 · …»: la scrittura si è spenta.",
            rate_limited: "GoHighLevel ha ricevuto troppe richieste: si riprova al giro dopo.",
            unavailable: "GoHighLevel non ha risposto: si riprova al giro dopo.",
            close_window: "Fra le 21:00 e le 22:05 non si scrive.",
        },
        switchTitle: "2. Interruttore",
        isOn: "Accesa: ogni minuto Gioia365 aggiorna i contatti dei Lead cambiati.",
        isOff: "Spenta: niente si scrive in GoHighLevel.",
        changed: "Cambiata il {date} alle {time} da {person}.",
        changedNoOne: "Cambiata il {date} alle {time}.",
        createMissing: "Crea in GoHighLevel i contatti che mancano",
        createMissingHint: "Spento: aggiorna soltanto i contatti che ci sono già. Acceso: un Lead con email o cellulare senza contatto ne riceve uno nuovo, e le automazioni di GoHighLevel possono scrivergli.",
        needsDryRun: "Si accende dopo una prova senza scrivere riuscita con la chiave di adesso.",
        turnOn: "Accendi la scrittura",
        turnOnYes: "Sì, accendi",
        confirm: "Da adesso Gioia365 aggiorna i contatti di GoHighLevel dei Lead, e le automazioni di GoHighLevel possono mandare email con quei dati. Crea i campi «G365 · …» che mancano. Accendo?",
        confirmWithCreate: "Da adesso Gioia365 aggiorna i contatti di GoHighLevel e crea quelli che mancano: le automazioni di GoHighLevel possono mandare email anche ai contatti nuovi. Crea i campi «G365 · …» che mancano. Accendo?",
        turnOff: "Spegni la scrittura",
        saveSetting: "Salva",
        onToast: "Scrittura accesa.",
        offToast: "Scrittura spenta.",
        roundTitle: "Ultimo giro",
        roundWhen: "Il {date} alle {time}.",
        noRound: "Nessun giro ancora.",
        queue: "In coda: {pending} · scritti: {done} · non scritti: {skipped} · fermi dopo troppi tentativi: {failed}.",
    },
    // L'importazione da GoHighLevel (INGR-30): prova senza salvare, tag confermati voce per voce, importazione.
    ghlImport: {
        title: "Importazione da GoHighLevel",
        intro: "Incrocia ogni contatto di GoHighLevel con i Lead e porta la storia che manca: email personali e risposte, WhatsApp, Instagram, Facebook, SMS, chiamate; newsletter e sequenze in una riga col conteggio. Nessun campo dei Lead cambia. I contatti soltanto in GoHighLevel con un cellulare italiano diventano Lead nuovi di {owner}, con il tag «{tag}», nella Smart List «{list}», senza sequenza. I candidati del funnel delle assunzioni restano fuori.",
        needsKey: "Prima salva la chiave.",
        closeBusy: "Sta girando l'importazione da Close, o sono fra le 21:00 e le 22:05: prova e importazione da GoHighLevel ripartono quando ha finito.",
        dryRunTitle: "1. Prova senza salvare",
        dryRunText: "Legge tutto da GoHighLevel e ti dice soltanto numeri e tag: niente si scrive, né in Gioia365 né in GoHighLevel. Può durare decine di minuti (una richiesta per ogni conversazione): la pagina si aggiorna da sola.",
        dryRunStart: "Prova senza salvare",
        dryRunStarting: "La faccio partire…",
        dryRunToast: "Prova partita: il rapporto arriva qui quando finisce.",
        dryRunOld: "Questa prova è stata fatta con una chiave di prima: rifalla.",
        running: "In corso, partita il {date} alle {time}…",
        started: "Partita il {date} alle {time}.",
        finished: "Finita il {date} alle {time}.",
        failed: "Non riuscita ({code}). Riprova: quello che è già entrato non si duplica.",
        noRun: "Nessuna prova ancora.",
        contactsTitle: "Contatti",
        read: "Letti: {count}",
        matchedByContact: "Già Lead, per il contatto di GoHighLevel: {count}",
        matchedByEmail: "Già Lead, per l'email: {count}",
        matchedByPhone: "Già Lead, per il telefono: {count}",
        matchedArchived: "Di questi archiviati (prendono la storia, non i tag): {count}",
        toCreate: "Lead nuovi da creare: {count}",
        sameNewLead: "Con il cellulare o l'email di un altro contatto che diventa Lead nuovo (lo raggiungono, non ne fanno un altro): {count}",
        created: "Lead nuovi creati: {count}",
        ownerMissing: "{owner} non è nel Team come User attivo: senza di lui l'importazione non parte.",
        candidates: "Candidati del funnel delle assunzioni, esclusi: {count} (già Lead: {already})",
        uncertain: "Incerti (segni di candidatura e di salone): {count}; già Lead, si incrociano: {matched}; non diventano Lead: {notCreated}",
        discardedTitle: "Non diventano Lead",
        noItalianMobile: "Senza cellulare italiano: {count}",
        notQualified: "Tipo «non qualificato»: {count}",
        notHairdresser: "«Sei un parrucchiere?» = No: {count}",
        pipelineRead: "Pipeline delle assunzioni lette: {pipelines}, con {count} contatti",
        pipelineUnreadable: "La chiave non legge le opportunità: la pipeline delle assunzioni non si è guardata (restano tag, provenienza e modulo).",
        conversationsTitle: "Conversazioni",
        conversations: "Lette: {count}; dei contatti che restano fuori, non lette: {outOfScope}",
        channelLine: "{channel}: {single} come riga, {counted} nel conteggio",
        skippedTitle: "Non entrano (attività e altri tipi di GoHighLevel)",
        skippedLine: "{kind}: {count}",
        channels: { email: "Email", whatsapp: "WhatsApp", instagram: "Instagram", facebook: "Facebook", sms: "SMS", call: "Chiamate" },
        requests: "Richieste a GoHighLevel: {count}",
        incomplete: "GoHighLevel dice {contacts} contatti e {conversations} conversazioni; letti {read} e {readConversations}: la lettura è monca, rifai la prova prima di importare.",
        gapTolerated: "GoHighLevel dice {contacts} contatti e {conversations} conversazioni; letti {read} e {readConversations}. La differenza resta sotto lo 0,1% (di solito voci cancellate o doppie nel suo elenco): si può importare.",
        tagsTitle: "2. Tag, voce per voce",
        tagsText: "Spunta i tag che entrano sui Lead: si aggiungono, non si tolgono mai. Di partenza entrano le campagne; i tecnici e quelli delle assunzioni no. Niente si importa finché non confermi.",
        tagsNone: "Nessun tag nei contatti.",
        tagColumn: "Tag",
        contactsColumn: "Contatti",
        destinyColumn: "Destino",
        enterColumn: "Entra",
        destiny: { enter: "campagna", technical: "tecnico", candidates: "assunzioni" },
        tagsConfirm: "Conferma i tag",
        tagsConfirming: "Salvo…",
        tagsConfirmed: "Tag confermati il {date} alle {time} da {person}: {count} entrano.",
        tagsConfirmedBySomeone: "Tag confermati il {date} alle {time}: {count} entrano.",
        tagsToast: "Tag confermati.",
        importTitle: "3. Importa adesso",
        importText: "Scrive in Gioia365 quello che la prova ha mostrato, con i tag confermati. Si può rilanciare: niente entra due volte.",
        importNeeds: "Prima una prova finita con la chiave di adesso e i suoi tag confermati.",
        importStart: "Importa adesso",
        importConfirm: "Importare adesso da GoHighLevel? I Lead nuovi nascono e la storia entra nelle Timeline.",
        importYes: "Sì, importa",
        importToast: "Importazione partita: il rapporto arriva qui quando finisce.",
        writtenTitle: "Scritto",
        leadsCreated: "Lead nuovi: {count} (già creati prima: {already})",
        tagsAdded: "Tag aggiunti ai Lead: {count}",
        messagesWritten: "Messaggi entrati come riga: {count}",
        summariesWritten: "Righe di conteggio: {count}",
        alreadyImported: "Già entrati prima, non ripetuti: {count}",
        smartList: { created: "Smart List «{list}» creata.", existing: "Smart List «{list}» già presente.", missing: "Smart List «{list}» non creata." },
    },
    // Disco e demo (piano M6, R7; SEZ-9, SEZ-11, TASK-11, TEL-20): la finestra della prenotazione, gli appuntamenti nel Riepilogo della
    // scheda con i loro esiti, il passo della postazione, Google Calendar in «Il tuo account», i Task, il banner e la Timeline.
    appointments: {
        headerButton: "Prenota disco o demo",
        kind: { disco: "Disco", demo: "Demo" },
        dialog: {
            title: "Prenota disco o demo",
            moveTitle: "Sposta: {kind} del {when}",
            kind: "Cosa prenoti",
            day: "Giorno",
            time: "Ora",
            minutes: "Durata in minuti",
            minutesHint: "Da 5 a 480 minuti.",
            colleague: "Collega da invitare",
            noColleague: "Nessun collega",
            leadEmail: "Email del Lead",
            leadEmailHint: "Serve per l'invito di Google Calendar.",
            withCalendar: "Nasce un evento sul tuo Google Calendar con il link Meet: l'invito va al Lead e al collega scelto.",
            withoutCalendar: "Il tuo Google Calendar non è collegato: l'appuntamento resta soltanto in Gioia365 e il link si manda con il WhatsApp.",
            withoutEmail: "Senza l'email del Lead l'appuntamento resta soltanto in Gioia365 e il link si manda con il WhatsApp.",
            save: "Prenota",
            move: "Sposta",
            saved: "{kind} prenotata per {when}.",
            moved: "{kind} spostata a {when}.",
            exists: "C'è già una {kind} aperta per questo Lead: spostala o chiudila dal Riepilogo.",
            invalidTime: "Scegli un giorno e un'ora validi.",
        },
        block: {
            title: "Disco e demo",
            opportunity: "Opportunità: {stage}",
            reschedule: "da riprogrammare",
            item: "{kind} · {when} · {minutes} min",
            meet: "Apri il link Meet",
            files: {
                transcript: "Trascrizione",
                notes: "Note di Gemini",
                recording: "Registrazione",
                opensGoogle: "{name}: si apre su Google, con i permessi di Google",
                waiting: "Trascrizione e registrazione: Gioia365 le cerca su Google dopo la fine del Meet, fino a 7 giorni.",
                none: "Su Google non c'è né trascrizione né registrazione di questo Meet: vanno accese nel Meet.",
                unavailable: "Trascrizione non leggibile: il Google Calendar di chi l'ha prenotata non è più collegato.",
                no_calendar: "Niente trascrizione in Gioia365: questa {kind} non è su Google Calendar. Arriva da sola quando la prenota chi ha collegato Google Calendar da «Il tuo account».",
            },
            calendar: {
                created: "Su Google Calendar",
                pending: "Google Calendar in aggiornamento",
                failed: "Google Calendar non aggiornato: l'appuntamento resta in Gioia365",
                not_connected: "Soltanto in Gioia365",
            },
            status: { open: "In programma", done: "Chiusa", canceled: "Annullata" },
            result: { held: "Fatta", no_show: "Il Lead non si è presentato" },
            held: "Fatta",
            heldMinutes: "Minuti effettivi (facoltativo)",
            saveHeld: "Segna come fatta",
            noShow: "Il Lead non si è presentato",
            move: "Sposta",
            cancel: "Annulla",
            cancelReason: "Motivo dell'annullamento",
            cancelConfirm: "Annulla l'appuntamento",
            keep: "Lascia com'è",
            afterStart: "Gli esiti si segnano dall'ora dell'appuntamento.",
            saved: "Esito salvato.",
            canceled: "Appuntamento annullato.",
        },
        stages: {
            disco_booked: "Disco prenotata",
            disco_held: "Disco effettuata",
            demo_booked: "Demo prenotata",
            demo_held: "Demo effettuata",
            sold: "Venduto",
            lost: "Persa",
        },
        step: {
            question: "Prenota la {kind}: dopo questo esito è obbligatorio.",
            open: "Prenota",
            done: "{kind} prenotata per {when}",
        },
        account: {
            title: "Google Calendar",
            help: "Collega il tuo Google Calendar: le disco e le demo che prenoti nascono lì, con il link Meet.",
            connected: "Collegato a {email}.",
            notConnected: "Non collegato.",
            revoked: "Scollegato: puoi collegarlo di nuovo.",
            failed: "Il collegamento non funziona più: collegalo di nuovo.",
            unavailable: "Google Calendar non è ancora disponibile in Gioia365: lo attiva chi gestisce la piattaforma.",
            connect: "Collega Google Calendar",
            disconnect: "Scollega",
            disconnected: "Google Calendar scollegato.",
            justConnected: "Google Calendar collegato.",
            justFailed: "Il collegamento con Google non è riuscito. Riprova da Il tuo account.",
        },
        tasks: {
            what: "{kind} · {when} · {minutes} min",
            offAppointments: "Disco e demo non si chiamano in cascata: il Power Dialer prende soltanto i richiami.",
            meet: "Meet",
        },
        banner: {
            title: "{kind} alle {time} con {lead}",
            soon: "tra {minutes} min",
            announce: "Promemoria: {kind} alle {time} con {lead}.",
            meet: "Apri Meet",
            dismiss: "Chiudi il promemoria",
        },
        timeline: {
            booked: "{kind} prenotata per {when} · {minutes} min",
            rescheduled: "{kind} spostata a {when}",
            canceled: "{kind} annullata",
            canceledReason: "Motivo: {reason}",
            held: "{kind} fatta",
            noShow: "{kind}: il Lead non si è presentato",
            opportunityOpened: "Opportunità aperta: «{stage}»",
            stageChanged: "Opportunità: da «{before}» a «{after}»",
            stageNow: "Opportunità: «{stage}»",
            // Una disco o una demo storica di Close (22/10/2026).
            imported: "{kind} prenotata in Close, importata",
            importedWhen: "Per il {when}",
            importedOutcome: {
                held: "Fatta",
                canceled: "Annullata in Close",
                unknown: "Esito non scritto in Close: non conta fra le «da fare»",
            },
        },
    },
    // Le Opportunità (piano M6, R8, Task 25; SEZ-9, SEZ-10): la pagina «Opportunità» e il riquadro nella scheda, alla lettera dai
    // mock-up `opportunita.html` e `scheda-lead.html` (con `mockup.js`); le date in numeri (UX-5). Le parole che i mock-up non hanno
    // sono di Claude (UX-12): i motivi di «Persa» vengono dalla questione 380, il prossimo passo del riquadro dal brief del Task 25.
    opportunities: {
        title: "Le opportunità",
        // Il pulsante della testata della scheda (LEAD-2), dopo «Prenota disco o demo»: apre la finestra «Opportunità di …».
        headerButton: "Opportunità",
        openCount: "{count} aperte",
        intro: "Ogni disco prenotata apre un'opportunità. Qui vedi a che punto è ognuna: disco, demo, fino a «Venduto» o «Persa». Lo status del Lead non cambia da solo.",
        layoutLabel: "Come vederle",
        layouts: { board: "Per fase", table: "Tabella" },
        viewsLabel: "Quali",
        views: { open: "Aperte", sold: "Vendute", lost: "Perse", all: "Tutte" },
        who: "Di chi",
        wholeTeam: "Tutto il team",
        campaign: "Campagna",
        allCampaigns: "Tutte",
        search: "Cerca un Lead o un'azienda target",
        totalsLabel: "A che punto è il lavoro",
        totals: {
            disco_booked: "Disco da fare",
            disco_held: "Disco fatte, demo da prenotare",
            demo_booked: "Demo da fare",
            demo_held: "Demo fatte, da chiudere",
            sold: "Vendute a {month}",
            lost: "Perse a {month}",
        },
        countWithValue: "{count} · {value}",
        stages: {
            disco_booked: "Disco prenotata",
            disco_held: "Disco effettuata",
            demo_booked: "Demo prenotata",
            demo_held: "Demo effettuata",
            sold: "Venduto",
            lost: "Persa",
        },
        none: "Nessuna",
        noShow: "Il Lead non si è presentato: da riprogrammare",
        reschedule: "Da riprogrammare",
        empty: "Nessuna opportunità qui.",
        emptyFiltered: "Cambia la ricerca o la campagna.",
        emptyHint: "Un'opportunità si apre quando prenoti una disco o una demo: da «Nuova opportunità» qui sopra o dalla scheda del Lead.",
        newButton: "Nuova opportunità",
        newDialog: {
            title: "Nuova opportunità",
            intro: "Scegli che cosa prenoti e il Lead: l'opportunità si apre con la prenotazione.",
            kind: "Che cosa prenoti",
            search: "Cerca il Lead: nome, salone o telefono",
            typeMore: "Scrivi almeno due lettere.",
            noLead: "Nessun Lead trovato fra quelli che vedi.",
            results: "Lead trovati",
            unnamed: "Lead senza nome",
        },
        more: "Mostra altre",
        caption: "Le opportunità, in ordine di fase e poi di data",
        columns: {
            lead: "Lead",
            stage: "Fase",
            next: "Prossimo passo",
            assignee: "Commerciale",
            bookedBy: "Prenotata da",
            closedBy: "Chiusa da",
            value: "Valore",
            campaign: "Campagna",
            openedAt: "Aperta il",
        },
        // Il prossimo passo delle carte e della tabella (`oppNextStep` del mock-up).
        next: {
            disco_booked: "Disco {when}",
            disco_held: "Disco fatta {when}: da prenotare la demo",
            demo_booked: "Demo {when}",
            demo_held: "Demo fatta {when}: Venduto o Persa?",
            sold: "{product} · {value} · {date}",
            lost: "Persa il {date}: {reason}",
        },
        // Il prossimo passo del riquadro della scheda (brief del Task 25), con l'ora dell'appuntamento quando c'è.
        step: {
            disco_booked: "Disco da fare",
            disco_held: "Disco fatta, demo da prenotare",
            demo_booked: "Demo da fare",
            demo_held: "Demo fatta, da chiudere",
            at: "{step} · {when}",
        },
        products: { club: "Club", percorso: "Percorso" },
        valueUnknown: "valore non indicato",
        lostReasons: {
            not_interested: "Non interessato",
            price: "Prezzo",
            timing: "Tempi",
            competitor: "Concorrente",
            unreachable: "Non risponde più",
            other: "Altro",
        },
        reasonWithNote: "{reason} · {note}",
        // Il dettaglio della pagina («Opportunità di …»): la fase si cambia nella scheda, qui si legge.
        detail: {
            title: "Opportunità di {name}",
            status: "{salon} · status «{status}»: la fase dell'opportunità non lo cambia.",
            statusNoSalon: "Status «{status}»: la fase dell'opportunità non lo cambia.",
            steps: "Fasi",
            step: { disco: "Disco", demo: "Demo", sold: "Venduto" },
            reached: "raggiunta",
            notReached: "non ancora",
            stage: "Fase",
            next: "Prossimo passo",
            owner: "Commerciale (owner del Lead)",
            bookedBy: "Disco prenotata da",
            closedBy: "Chiusa da",
            product: "Cosa ha comprato",
            value: "Valore",
            contract: "Tipo di contratto",
            offer: "Offerta proposta",
            payFrom: "Paga dal",
            bonus: "Bonus",
            campaign: "Campagna",
            openedAt: "Aperta il",
            history: "Com'è andata",
            opened: "Si apre l'opportunità",
            appointment: {
                open: "{kind} in programma",
                held: "{kind} effettuata",
                no_show: "{kind}: non si è presentata",
                canceled: "{kind} annullata",
            },
            sold: "Venduto: {product} · {value}",
            lost: "Persa. Motivo: {reason}",
            howTo: "La fase si cambia dalla scheda del Lead, nella finestra «Opportunità» e in «Disco e demo»: ogni passaggio chiede i suoi dati (giorno e ora, minuti, motivo o valore) e finisce nella Timeline.",
            open: "Aggiorna nella scheda del Lead",
        },
        // Il riquadro compatto nella colonna destra della scheda (mock-up `scheda-lead.html`, LEAD-2).
        box: {
            title: "Opportunità",
            stage: "Fase",
            next: "Prossimo passo",
            noneOpen: "Nessuna aperta",
            note: "Lo status del Lead resta a parte: non cambia con l'opportunità.",
            open: "Apri l'opportunità",
            notVisible: "L'opportunità aperta di questo Lead non è fra quelle che vedi: la fase è in «Disco e demo».",
        },
        // La finestra «Opportunità di …» della scheda (mock-up `scheda-lead.html`, `renderOpportunity` e `OPP_STAGES`; il titolo è
        // `detail.title`, le fasi raggiunte `detail.step`).
        window: {
            stageNow: "Fase di adesso:",
            stageWith: "{stage} · {detail}",
            sale: "{product} · {value}",
            none: "Nessuna opportunità aperta",
            whatHappened: "Cosa è successo?",
            toOpen: "Per aprire un'opportunità",
            bookDisco: "Prenota disco",
            bookDemo: "Prenota demo",
            sold: "Venduto",
            lost: "Persa",
            appointments: "Disco e demo fatte, non presentate, spostate o annullate si segnano nel riquadro «Disco e demo».",
            final: "Fase finale. Più avanti da qui nascerà il cliente nel modulo amministrativo.",
            readOnly: "La segue {name}: puoi vederla, non cambiarla.",
            reopen: "Riapri",
            reopened: "Opportunità riaperta: torna a «{stage}».",
            statusNote: "Lo status del Lead non cambia mai da solo: lo cambi tu dal menu Status.",
        },
        soldDialog: {
            title: "Venduto",
            product: "Cosa ha comprato",
            choose: "Scegli",
            productMissing: "Scegli Club o Percorso.",
            value: "Valore in € · obbligatorio",
            valueMissing: "Scrivi il valore della vendita in euro.",
            contract: "Tipo di contratto",
            contractPlaceholder: "Per esempio: 12 mesi",
            offer: "Offerta",
            paymentStart: "Data di inizio pagamento",
            bonus: "Bonus",
            closer: "Chi ha chiuso",
            closerMissing: "Scegli chi ha chiuso la vendita.",
            save: "Registra la vendita",
            saved: "Vendita registrata. Lo status resta «{status}»: se serve, cambialo tu dal menu Status.",
        },
        lostDialog: {
            title: "Persa",
            reason: "Perché l'opportunità è persa? · obbligatorio",
            choose: "Scegli il motivo",
            reasonMissing: "Scegli il motivo.",
            note: "Note",
            notePlaceholder: "Per esempio: ha scelto un altro corso, non ha budget",
            noteHint: "Con «Altro» la nota è obbligatoria.",
            noteMissing: "Scrivi il motivo: resta nella Timeline.",
            save: "Segna come persa",
            saved: "Opportunità segnata come persa. Lo status del Lead non cambia.",
        },
        // La vendita e la perdita nella Timeline (gli eventi `opportunity.sold` e `opportunity.lost`), come le scrive il mock-up.
        timeline: {
            sold: "Venduto · {product} · {value}",
            closedBy: "Chiuso da {name}",
            lost: "Opportunità persa",
            reason: "Motivo: {reason}",
            // Un'opportunità entrata o aggiornata dall'importazione da Close (INGR-26).
            imported: "Opportunità da Close: «{stage}»",
            importedChanged: "Opportunità da Close: da «{before}» a «{after}»",
            importedValue: "Valore: {value}",
        },
    },
    // La pagina «Report», scheda «Commerciali» (piano M7, Task 3; mock-up `report.html` del 17/10/2026, script della pagina): le parole
    // sono quelle del mock-up, tolte «Proposta da decidere» e «(proposta)», decise il 17/10/2026. Finché Impostazioni → «Obiettivi» non
    // c'è (Task 6) la nota degli obiettivi non vi rimanda: i colori sono quelli di partenza. I periodi, «Dal» e «Al» sono quelli di
    // «Conversazioni» (`conversations.periods`), i nomi dei giorni quelli del calendario.
    reports: {
        title: "I numeri del lavoro",
        intro: "Come il vostro foglio «KPI SALES INDIVIDUALE»: chiamate, disco, demo e chiusure, con le stesse formule. Il periodo di partenza è il Mese.",
        tabsLabel: "Quale report",
        // «Campagne» (Task 5) ha la sua frase in testata, dallo stesso script del mock-up.
        introCampaigns: "Come il vostro foglio «Vendite per campagne»: da dove vengono i Lead, chi li ha lavorati, che cosa hanno comprato e per quanto.",
        tabs: { sales: "Commerciali", campaigns: "Campagne" },
        status: "Report «{tab}», {range}.",
        controls: {
            label: "Periodo e persone",
            period: "Periodo",
            customMissing: "Scegli tutte e due le date.",
            customOrder: "«Dal» viene dopo «Al»: scambiale.",
            customFuture: "Si arriva al massimo a oggi, {day}.",
            customTooLong: "Al massimo un anno: scegli un periodo più corto.",
            who: "Di chi",
            wholeTeam: "Tutto il team",
            whoHint: "Nessuno scelto vuol dire «Tutto il team». Scegline più di uno per sommarli.",
            inactive: "non più attivo",
        },
        // Il periodo come lo scrive `rangeText` del mock-up: con la minuscola, che la pagina alza quando la frase comincia lì.
        range: {
            dayName: "{weekday} {date}",
            dayUntil: "{day}, fino alle {time}",
            days: "dal {from} al {to}",
            daysUntil: "dal {from} al {to}, oggi fino alle {time}",
        },
        // I giorni della settimana del Report, interi («giovedì 15/10/2026», la mappa) e corti («Giorno per giorno», le righe della mappa).
        weekday: {
            long: { "1": "lunedì", "2": "martedì", "3": "mercoledì", "4": "giovedì", "5": "venerdì", "6": "sabato", "7": "domenica" },
            short: { "1": "lun", "2": "mar", "3": "mer", "4": "gio", "5": "ven", "6": "sab", "7": "dom" },
        },
        compare: {
            day: "Le frecce confrontano con {day}.",
            dayUntil: "Le frecce confrontano con {day}, fino alle {time}.",
            days: "Le frecce confrontano con i {count} giorni prima: dal {from} al {to}.",
            daysUntil: "Le frecce confrontano con i {count} giorni prima: dal {from} al {to}, l'ultimo fino alle {time}.",
        },
        // Chi si guarda (`scopeText`): la prima parte è in grassetto, il resto la segue. Nella «Guarda come…» la frase nomina la persona
        // osservata invece del «lei» del mock-up, perché vale per chiunque (ruling del registro del Task 3).
        scope: {
            own: ": vedi soltanto i tuoi numeri. I colleghi non compaiono, nemmeno nei totali.",
            watchingLead: "Come la vede {name}",
            watching: ": soltanto i suoi numeri, senza i colleghi.",
            team: "Tutto il team",
            teamCount: ": {count} Commerciali, nessuno scelto.",
            teamCountOne: ": 1 Commerciale, nessuno scelto.",
            one: "Una persona",
            many: "{count} persone",
            chosen: ": {names}. I numeri sono la somma, con i Lead contati una volta.",
        },
        summary: {
            team: "I numeri del team",
            person: "I numeri di {name}",
            people: "I numeri delle {count} persone scelte",
            own: "I tuoi numeri",
            intro: "I gruppi e i numeri del foglio «KPI SALES INDIVIDUALE», con le stesse formule. Sono gli stessi numeri della Home e, per le chiusure, della pagina Opportunità.",
            footnote: "Obiettivi: «8–10%» delle disco sulle chiamate e «almeno 50%» di show up delle demo sono già decisi; gli altri vengono dal vostro foglio «Calcolo Sales» e si cambiano in Impostazioni → «Obiettivi». Le percentuali si ricalcolano sui totali, non si fa la media delle persone. Chiamate, risposte e minuti arrivano dalla telefonia; disco, demo e vendite dagli appuntamenti e da «Venduto»; quello inserito a mano conta uguale e resta riconoscibile.",
            callsSub: "{count} chiuse presto, sotto i 20 secondi: escluse",
            callsManual: " · {count} inserite a mano",
            fromClose: " · {count} da Close, storiche",
            minutesSub: "chiamate {calls} · disco {disco} · demo {demo}",
        },
        // I gruppi e i numeri del foglio (`KPI_GROUPS`): il nome, quello corto delle colonne e la formula a parole.
        groups: { calls: "Chiamate", disco: "Disco", demo: "Demo", closings: "Chiusure" },
        kpis: {
            calls: { label: "Chiamate effettuate", short: "Chiamate", how: "le chiamate valide" },
            answered: { label: "Chiamate con risposta", short: "Con risposta" },
            answerRate: { label: "% di risposta", short: "% di risposta", how: "con risposta ÷ effettuate" },
            leads: { label: "Lead diversi chiamati", short: "Lead diversi", how: "ognuno conta una volta nel periodo" },
            leadRate: { label: "% di Lead con risposta", short: "% Lead con risposta", how: "Lead che hanno risposto ÷ Lead diversi chiamati" },
            minutes: { label: "Minuti al telefono", short: "Minuti al telefono", how: "chiamate, disco e demo" },
            discoBooked: { label: "Disco prenotate", short: "Prenotate", how: "a chi le ha prenotate" },
            discoOnCalls: { label: "Disco su chiamate", short: "Su chiamate", how: "prenotate ÷ chiamate effettuate" },
            discoOnAnswered: { label: "Disco su risposte", short: "Su risposte", how: "prenotate ÷ chiamate con risposta" },
            discoDue: { label: "Disco da fare", short: "Da fare", how: "con l'ora nel periodo, tolte le annullate" },
            discoHeld: { label: "Disco effettuate", short: "Effettuate", how: "chiuse con «Fatta»" },
            discoShow: { label: "% show up disco", short: "% show up", how: "effettuate ÷ da fare" },
            discoRescheduled: { label: "Disco riprogrammate", short: "Riprogrammate", how: "«Spostata» con il nuovo giorno" },
            demoBooked: { label: "Demo prenotate", short: "Prenotate", how: "a chi le ha prenotate" },
            demoOnDisco: { label: "Demo su disco", short: "Su disco", how: "demo prenotate ÷ disco effettuate" },
            demoDue: { label: "Demo da fare", short: "Da fare", how: "con l'ora nel periodo, tolte le annullate" },
            demoHeld: { label: "Demo effettuate", short: "Effettuate", how: "chiuse con «Fatta»" },
            demoRescheduled: { label: "Demo riprogrammate", short: "Riprogrammate", how: "«Spostata» con il nuovo giorno" },
            demoShow: { label: "% show up demo", short: "% show up", how: "effettuate ÷ da fare" },
            closings: { label: "Chiusure", short: "Chiusure", how: "«Venduto», a chi ha chiuso" },
            closeRate: { label: "% close rate", short: "% close rate", how: "chiusure ÷ demo effettuate" },
            value: { label: "Valore delle chiusure", short: "Valore", how: "la somma dei valori di «Venduto»" },
            averageValue: { label: "Valore medio di una chiusura", short: "Valore medio", how: "valore ÷ chiusure" },
        },
        headTitle: "{label} · {how}",
        // Le frecce del confronto (`deltaBadge`): il segno, il numero, e per lo screen reader il numero di prima.
        delta: {
            points: "{sign}{value} punti",
            decimal: ",",
            percent: "{sign}{value}%",
            first: "prima nessuna",
            stable: "stabile",
            title: "Periodo prima: {value}",
            hidden: " rispetto al periodo prima, che aveva {value}",
        },
        // Gli obiettivi (`targetBadge`, `cell`): verde con ✓ raggiunto, arancione con ↓ mancato, mai soltanto il colore.
        target: {
            range: "obiettivo {min}–{max}%",
            atLeast: "obiettivo almeno {min}%",
            exact: "obiettivo {min}%",
            badge: "{target} · {word}",
            cell: "{target}: {word}",
            hidden: " ({target}: {word})",
            cardHidden: " ({word})",
            words: { below: "sotto", inLine: "in linea", above: "sopra" },
        },
        marks: { ok: "✓", below: "↓" },
        table: {
            groups: { summary: "Sintesi", calls: "Chiamate", disco: "Disco", demo: "Demo", closings: "Chiusure", all: "Tutte, come nel foglio" },
            cardKey: "{calls} · {closings}",
            callsOne: "1 chiamata",
            callsMany: "{count} chiamate",
            closingsOne: "1 chiusura",
            closingsMany: "{count} chiusure",
            countedOnce: "Lead contati una volta",
            wideNote: "Con tutte le colonne la tabella è larga come il foglio e scorre di lato nel suo riquadro; il nome resta fermo a sinistra.",
        },
        team: {
            title: "Una riga per Commerciale",
            intro: "Come il foglio del mese: una riga per persona e il totale. In verde con ✓ l'obiettivo raggiunto, in arancione con ↓ quello mancato.",
            groupsLabel: "Colonne della tabella del team",
            caption: "I numeri di ogni Commerciale, {range}",
            firstHead: "Commerciale",
            total: "Tutto il team",
            totalChosen: "Totale delle persone scelte",
        },
        days: {
            title: "Giorno per giorno",
            intro: "{whose}: una riga per giorno lavorativo, il più recente in cima, e il totale, come le righe del foglio.",
            groupsLabel: "Colonne della tabella giorno per giorno",
            caption: "Giorno per giorno, {range}",
            firstHead: "Giorno",
            total: "Totale del periodo",
            note: "Nel totale «Lead diversi» è più basso della somma dei giorni: un Lead chiamato in più giorni conta una volta. I giorni di chiusura (sabato, domenica, feste) compaiono soltanto se qualcuno ha lavorato.",
        },
        // «Andamento» (`trendSection` del mock-up): una barra per giorno lavorativo con il numero sopra, la media del periodo prima
        // tratteggiata; in un giorno solo, ora per ora. Le frasi delle barre servono anche senza colore e allo screen reader.
        trend: {
            title: "Andamento",
            metricsLabel: "Che cosa mostra l'andamento",
            metrics: { calls: "Chiamate", discoBooked: "Disco prenotate", demoHeld: "Demo effettuate", closings: "Chiusure" },
            counts: {
                discoBookedOne: "1 disco prenotata",
                discoBookedMany: "{count} disco prenotate",
                demoHeldOne: "1 demo effettuata",
                demoHeldMany: "{count} demo effettuate",
            },
            bar: "{day}: {count}",
            barAnswered: "{day}: {count}, {answered} con risposta",
            chartDays: "{metric} giorno per giorno, {range}",
            chartHours: "Chiamate ora per ora, {range}",
            summary: "Media al giorno lavorativo: {now}; nel periodo prima {before} (la linea tratteggiata).",
            summaryNoBefore: "Media al giorno lavorativo: {now}; il periodo prima non aveva giorni lavorativi.",
            answeredBlue: " In blu le chiamate con risposta.",
            hourly: "In un giorno solo l'andamento è ora per ora, per le chiamate: in blu quelle con risposta.",
            average: "media del periodo prima: {value}",
            notAnswered: "Senza risposta",
            answered: "Con risposta",
            legendNote: "Il numero sopra ogni barra; il dettaglio di ogni giorno è in «Giorno per giorno».",
            legendNoteHourly: "Il numero sopra ogni barra.",
        },
        // Le frasi di un'ora, per le barre dell'andamento di un giorno e le celle di «Quando si chiama»: «dalle 8:30 alle 9», le chiamate,
        // la pausa fra mattina e pomeriggio della sequenza, il venerdì pomeriggio con «il venerdì solo la mattina», le ore chiuse.
        hours: {
            span: "dalle {from} alle {to}",
            bar: "{span}: {what}",
            cell: "{weekday} {span}: {what}",
            calls: "{calls}, {answered} con risposta",
            rate: " ({rate})",
            pause: "pausa fra mattina e pomeriggio",
            friday: "chiuso, il venerdì si chiama solo la mattina",
            closed: "chiuso",
            withCalls: "{state}; {calls}",
        },
        // «Quando si chiama» (`heatSection`): giorno della settimana per ora, il numero dentro ogni cella, il dettaglio al passaggio.
        heat: {
            title: "Quando si chiama",
            introPeriod: "Le chiamate del periodo sommate per giorno della settimana e ora: più è blu, più si è chiamato, e il numero è scritto dentro. Passa sopra un quadratino, o toccalo, per le risposte.",
            introDay: "Le chiamate del giorno ora per ora: più è blu, più si è chiamato, e il numero è scritto dentro. Passa sopra un quadratino, o toccalo, per le risposte.",
            mapLabel: "Mappa delle chiamate per giorno e ora",
            hint: "Passa sopra un quadratino, o toccalo, per vedere chiamate e risposte.",
            detail: "{sentence}.",
            legend: "A righe: {parts}, quando la sequenza non chiama.",
            legendPause: "pausa {from}–{to}",
            legendFriday: "venerdì pomeriggio",
            legendClosed: "fuori orario",
        },
        // «Le campagne» (Task 5; `renderCampagne` del mock-up): una riga per campagna o lista, il totale, le frecce sui Lead nuovi, le disco,
        // le vendite e il valore. Le sorgenti si scrivono con le parole della colonna «Provenienza» (`leadList.source`); «Senza
        // provenienza» è una parola nuova (piano M7, R3).
        campaigns: {
            title: "Le campagne",
            whoseTeam: "Tutto il team.",
            whoseChosen: "Lead arrivati come owner a {names}, le loro disco e le loro vendite.",
            whoseOwn: "Soltanto i tuoi: i Lead arrivati a te come owner, le disco che hai prenotato, le vendite che hai chiuso.",
            intro: "{whose} Ogni Lead resta nella campagna con cui è entrato la prima volta, anche se poi rientra da un'altra.",
            caption: "Le campagne, {range}",
            firstHead: "Campagna o lista",
            columns: {
                fresh: { label: "Lead nuovi", how: "entrati la prima volta da qui" },
                back: { label: "Rientrati", how: "Lead che c'erano già, entrati di nuovo da qui" },
                disco: { label: "Disco prenotate", how: "dei Lead entrati la prima volta da qui" },
                closings: { label: "Vendite", how: "«Venduto», a chi ha chiuso" },
                closeRate: { label: "% close rate", how: "vendite ÷ demo effettuate dei Lead entrati la prima volta da qui" },
                value: { label: "Valore", how: "somma dei valori di «Venduto»" },
                average: { label: "Valore medio", how: "valore ÷ vendite" },
            },
            total: "Tutte le campagne",
            noSource: "Senza provenienza",
            salesOne: "1 vendita",
            salesMany: "{count} vendite",
        },
        // «Vendite per campagne» (`renderCampagne`): una riga per vendita raggruppata per campagna, con «Chi ha fatto cosa». I campi del
        // salone hanno le voci della scheda; «Incasso mensile» del mock-up non c'è finché la domanda n. 52 è aperta (D8). Il nome del salone
        // nella scheda si chiama come nel resto del prodotto («Azienda Target»). Parole nuove (piano M7, R3, e scelte di Claude): «Un Lead
        // che non vedi», «Nessuna disco», «Nessuna demo», «{campo}: {voce}».
        campaignSales: {
            title: "Vendite per campagne",
            introTeam: "Una riga per vendita, come nel vostro foglio, raggruppate per campagna; dentro, la più recente in cima.",
            introOwn: "Le vendite che hai prenotato o chiuso, una riga per vendita.",
            caption: "Vendite per campagne, {range}",
            // Una vendita importata da Close, che non dice Club o Percorso (INGR-26).
            productUnknown: "Non indicato",
            columns: {
                lead: "Lead",
                date: "Data",
                campaign: "Campagna o lista",
                who: "Chi ha fatto cosa",
                product: "Cosa ha comprato",
                offer: "Offerta e pagamento",
                value: "Valore",
            },
            group: "{campaign} · {sales} · {value}",
            hiddenLead: "Un Lead che non vedi",
            salonCity: "{salon} · {city}",
            field: "{label}: {value}",
            fields: { addetti: "Addetti", ficheMedia: "Fiche media", presenzeMensili: "Presenze mensili" },
            latest: "Ultimo ingresso: {campaign}, {day}",
            disco: "Disco: {name}, {day}",
            demo: "Demo: {name}, {day}",
            noDisco: "Nessuna disco",
            noDemo: "Nessuna demo",
            closedBy: "Chiusa da: {name}",
            countsTo: "Conta a {name}, che ha chiuso",
            contract: "Tipo di contratto: {contract}",
            offer: "Offerta proposta: {offer}",
            noOffer: "Nessuna offerta proposta",
            payFrom: "Paga dal {day}",
            bonus: "Bonus: {bonus}",
            noBonus: "Nessun bonus",
            card: {
                key: "{day} · {value}",
                salon: "Azienda Target",
                campaign: "Campagna o lista",
                latest: "Ultimo ingresso",
                disco: "Disco",
                demo: "Demo",
                closedBy: "Chiusa da",
                product: "Cosa ha comprato",
                offer: "Offerta proposta",
                payFrom: "Paga dal",
                bonus: "Bonus",
                personDay: "{name}, {day}",
                campaignDay: "{campaign}, {day}",
                productContract: "{product}, {contract}",
                noOffer: "nessuna",
                noBonus: "nessuno",
            },
            empty: "Nessuna vendita nel periodo.",
            emptyHint: "Le campagne qui sopra hanno portato Lead e disco, ma nessuno ha ancora comprato: prova il «Mese».",
            footnote: "«Chi ha fatto cosa» viene dagli appuntamenti e da «Venduto»: prende il posto delle note scritte a mano del foglio. Le date e i valori di «Venduto» sono quelli scritti da chi ha chiuso.",
        },
        // «Obiettivi del mese» (piano M7, Task 6): le parole di `goalsSection` del mock-up, senza «Proposta da decidere» e senza «i numeri
        // qui sono inventati»; le frasi di quando manca qualcosa, «Imposta gli obiettivi», la persona sola e la somma parziale sono scelte
        // di Claude. I valori in grassetto arrivano nei segnaposti `{value}`, `{needed}` e `{average}`.
        goals: {
            title: "Obiettivi del mese",
            intro: "Dal {from} al {to}, a qualunque periodo scelto sopra. Come il vostro foglio «Calcolo Sales»: dall'obiettivo di vendite si risale a chiusure, demo, disco e chiamate che servono. Il segno nero sulla barra è dove si dovrebbe essere oggi, al giorno lavorativo {day} di {days}.",
            goalOwn: "Obiettivo tuo: {value}",
            goalTeam: "Obiettivo del team: {value}",
            goalPerson: "Obiettivo di {name}: {value}",
            goalPeople: "Obiettivo delle persone scelte ({names}): {value}",
            averageSale: "Valore medio di una vendita: {value}",
            callsPerDay: "Chiamate al giorno: servono {needed}, la media è {average}",
            partial: "Persone con un obiettivo: {with} su {of}; le altre non ce l'hanno per questo mese e i loro numeri qui non contano.",
            steps: {
                value: "Vendite del mese",
                closings: "Chiusure",
                demoHeld: "Demo effettuate",
                demoDue: "Demo da fare",
                discoHeld: "Disco effettuate",
                discoDue: "Disco da fare",
                calls: "Chiamate",
            },
            how: {
                value: "l'obiettivo, in euro",
                closings: "obiettivo ÷ valore medio di {value}",
                demoHeld: "chiusure ÷ close rate {rate}",
                demoDue: "demo effettuate ÷ show up {rate}",
                discoHeld: "demo da fare ÷ demo su disco {rate}",
                discoDue: "disco effettuate ÷ show up {rate}",
                calls: "disco ÷ disco su chiamate {rate}",
            },
            // «del 20%», «dell'8%»: l'articolo davanti al numero letto.
            of: { consonant: "del ", vowel: "dell'" },
            needed: "Serve nel mese: {value}",
            done: "Fatto dal {day}: {value}",
            projected: "A questo ritmo a fine mese: {value}",
            separator: " · ",
            status: { inLine: "in linea", slightlyBehind: "poco sotto", behind: "indietro" },
            bar: "{label}: fatto {done} su {needed}; oggi si dovrebbe essere a {expected}%",
            footnote: "Obiettivo, valore medio e percentuali li fissa il Super admin in Impostazioni → «Obiettivi», persona per persona. Provvigioni e fatturato dell'azienda, che il foglio ha, qui non ci sono.",
            missingGoal: "Nessun obiettivo per il mese dal {from} al {to}.",
            missingAverage: "Manca il valore medio di una vendita: si scrive in Impostazioni → «Obiettivi».",
            setGoals: "Imposta gli obiettivi",
        },
        // «La giornata a blocchi di 30 minuti» (piano M7, Task 7; `blocksSection` del mock-up, alla lettera, senza l'avviso sui dati
        // inventati; SEZ-4, SEZ-16): spenta finché la domanda n. 34 è aperta, e la accende soltanto il Super admin di Gioia365. La frase della
        // sezione spenta, l'interruttore e la conferma sono le parole del piano (R5); sono scelte di Claude quelle del caricamento, dell'errore
        // e del periodo senza giorni lavorativi, i numeri di una pausa o di un'ora chiusa in cui qualcuno ha lavorato lo stesso e la legenda
        // che dice soltanto le righe che ci sono. Agli utenti non si nomina il registro delle domande.
        blocks: {
            title: "La giornata a blocchi di 30 minuti",
            intro: "{name}, {day}. Ogni barra è mezz'ora: sopra le chiamate, in blu quelle con risposta; sotto, in «+N», le altre attività nel CRM (note, WhatsApp, Task).",
            dayUntil: "{day}, fino alle {time}",
            person: "Persona",
            day: "Giorno",
            barsLabel: "La giornata a blocchi di 30 minuti",
            facts: { phone: "Al telefono", screen: "Solo al computer", idle: "Fermo", calls: "Chiamate" },
            blocksOne: "1 blocco",
            blocksMany: "{count} blocchi",
            factBlocks: "{blocks} · {time}",
            factCalls: "{calls} · {answered} con risposta · {time}",
            states: { phone: "al telefono", screen: "solo al computer", idle: "fermo", pause: "pausa", closed: "chiuso", future: "non ancora" },
            span: "Dalle {from} alle {to}: {state}",
            numbers: "{span} · {calls}, {answered} con risposta, {time} al telefono · {activities} (note, WhatsApp, Task)",
            callsOne: "1 chiamata",
            callsMany: "{count} chiamate",
            activitiesOne: "1 altra attività",
            activitiesMany: "{count} altre attività",
            extra: "+{count}",
            hint: "Passa sopra una barra, o toccala, per vedere che cosa è successo in quella mezz'ora.",
            detail: "{sentence}.",
            legendStriped: "A righe: {parts}",
            legendPause: "pausa {from}–{to}",
            legendClosed: "chiuso",
            legendFuture: "non ancora",
            off: "La giornata a blocchi di 30 minuti è spenta. Si accende quando l'azienda ha dato l'informativa ai Commerciali.",
            turnOn: "Accendi per {company}",
            turnOff: "Spegni per {company}",
            confirmTitle: "Accendere la giornata a blocchi per {company}?",
            confirm: "Chi vede i report del team vedrà la giornata di ogni persona, mezz'ora per mezz'ora; ogni Commerciale la sua. Accendila soltanto dopo l'informativa ai Commerciali.",
            confirmAction: "Accendi",
            loading: "Sto leggendo la giornata…",
            error: "Non riesco a leggere la giornata adesso.",
            noWorkingDay: "Nel periodo scelto non c'è un giorno lavorativo.",
        },
        states: {
            loading: "Sto leggendo i numeri del periodo…",
            emptyTitle: "Nessun numero in questo periodo",
            empty: "{range}: nessuna chiamata, nessun appuntamento e nessuna vendita. Erano giorni di chiusura, oppure non ha lavorato nessuno.",
            emptyChosen: "{range}: nessuna chiamata, nessun appuntamento e nessuna vendita delle persone scelte. Erano giorni di chiusura, oppure non ha lavorato nessuno.",
            emptyCampaigns: "{range}: nessun Lead entrato, nessuna disco e nessuna vendita. Erano giorni di chiusura, oppure non ha lavorato nessuno.",
            emptyCampaignsChosen: "{range}: nessun Lead entrato, nessuna disco e nessuna vendita delle persone scelte. Erano giorni di chiusura, oppure non ha lavorato nessuno.",
            goToMonth: "Guarda il «Mese»",
            errorTitle: "Non riesco a leggere i numeri adesso",
            error: "Gioia365 non ha risposto. Non ti mostro numeri vecchi come se fossero di adesso: riprova fra poco.",
            noAccessTitle: "I Report non sono fra le cose che vedi",
            noAccess: "Il tuo ruolo non ha «Report e numeri della Home → Vedere». Se ti servono, chiedilo al Super admin: si cambia in Impostazioni → «Ruoli e permessi».",
            home: "Torna alla Home",
        },
    },
    // «Attività» («Chi ha fatto cosa», SEZ-8; M7 parte 2): il registro di tutte le azioni dell'azienda, una riga per azione. Parole
    // nuove, scelta di Claude (UX-12): i gruppi del filtro «Che cosa» e i titoli degli eventi che la Timeline non scrive come eventi.
    activity: {
        title: "Chi ha fatto cosa",
        introTeam: "Ogni azione dell'azienda, anche quelle automatiche, dalla più recente. Il dettaglio è nella Timeline del Lead.",
        introOwn: "Le tue azioni, dalla più recente. Il dettaglio è nella Timeline del Lead.",
        introWatching: "Le azioni che vede {name}, dalla più recente.",
        caption: "Le azioni del periodo, dalla più recente",
        columns: {
            when: "Quando",
            who: "Chi",
            what: "Che cosa",
            lead: "Lead",
            action: "Apri",
        },
        group: "Che cosa",
        allGroups: "Tutte le azioni",
        groups: {
            calls: "Chiamate",
            outcomes: "Esiti",
            notes: "Note",
            whatsapp: "WhatsApp",
            status: "Status",
            owner: "Owner",
            tasks: "Task e richiami",
            appointments: "Disco e demo",
            opportunities: "Opportunità",
            sequence: "Sequenza di chiamate e Power Dialer",
            lead_data: "Altri dati del Lead",
            imports: "Importazioni",
            settings: "Impostazioni e Smart List",
            platform: "Accessi di Gioia365",
        },
        more: "Mostra altre azioni",
        loadingMore: "Carico altre azioni…",
        empty: "Nessuna azione in questo periodo.",
        emptyHint: "Prova un altro periodo, togli un filtro o cerca un altro Lead.",
        automatic: "automatico",
        fromClose: "da Close",
        platformActor: "Gioia365 · {name}",
        viewOf: "guardando come {name}",
        leadArchived: "archiviato",
        leadMerged: "unito in un Lead che non vedi",
        leadMergedInto: "unito in {name}",
        hiddenLead: "Un Lead che non vedi",
        hiddenAction: "{group}: azione su un Lead che non vedi",
        noLead: "—",
        openInTimeline: "Apri nella Timeline",
        note: "Nota scritta",
        memo: "Appunto della chiamata",
        platformPath: "{method} {path}",
        skippedRoles: "Ruoli lasciati com'erano: {names}",
        noAccessTitle: "«Attività» non è fra le cose che vedi",
        noAccess: "Il tuo ruolo non ha «Attività → Vedere». Se ti serve, chiedilo al Super admin: si cambia in Impostazioni → «Ruoli e permessi».",
        types: {
            whatsappPrepared: "WhatsApp preparato",
            whatsappDeclaredSent: "WhatsApp segnato come inviato",
            whatsappSent: "WhatsApp ufficiale inviato",
            whatsappFailed: "WhatsApp non consegnato",
            whatsappReceived: "WhatsApp ricevuto dal Lead",
            dialerStarted: "Power Dialer avviato · {name}",
            dialerInterrupted: "Power Dialer interrotto · {name}",
            dialerFinished: "Power Dialer finito · {name}",
            dialerPaused: "Power Dialer in pausa · {name}",
            dialerResumed: "Power Dialer ripreso · {name}",
            callerNumberAdded: "Cellulare dell'ufficio aggiunto",
            callerNumberVerified: "Cellulare dell'ufficio verificato",
            callerNumberVerificationFailed: "Verifica di un cellulare dell'ufficio non riuscita",
            callerNumberAssigned: "Cellulare dell'ufficio dato a una persona",
            callerNumberUnassigned: "Cellulare dell'ufficio tolto a una persona",
            callerNumberRemoved: "Cellulare dell'ufficio tolto",
            whatsappSenderSet: "WhatsApp di una persona impostato",
            whatsappTemplateUpdated: "Modello WhatsApp cambiato",
            whatsappSettingsUpdated: "Riga «scrivi STOP» cambiata",
            leadFieldsPublished: "Campi della scheda pubblicati",
            leadVisibilityChanged: "«Chi vede i Lead» cambiato",
            tableLayoutPublished: "Vista dell'azienda salvata",
            callSequenceChanged: "Sequenza di chiamate cambiata",
            whatsappChannelsChanged: "WhatsApp dell'azienda cambiati",
            assignmentChanged: "Assegnazione dei Lead cambiata",
            reportGoalsChanged: "Obiettivi cambiati",
            workBlocksChanged: "Giornata a blocchi accesa o spenta",
            leadIntakeChanged: "Ingressi dei Lead cambiati",
            intakeAddressCopied: "Indirizzo di un ingresso copiato",
            intakeAddressRotated: "Indirizzo di un ingresso cambiato",
            smartListCreated: "Smart List «{name}» creata",
            smartListSaved: "Smart List «{name}» salvata",
            smartListShared: "Smart List «{name}» condivisa",
            smartListRenamed: "Smart List rinominata in «{name}»",
            smartListArchived: "Smart List «{name}» archiviata",
            tagCreated: "Tag «{name}» creato",
            importCompleted: "Importazione completata",
            leadDeleted: "Lead eliminato per sempre",
            phoneMarkedWrong: "Numero segnato errato",
            platformAccess: "Il gestore di Gioia365 ha aperto i dati dell'azienda",
        },
    },
    // Impostazioni → «Collegamenti» (M7 parte 2): un blocco a sé, in fondo, per non toccare gli altri.
    connections: {
        menu: "Collegamenti",
        about: {
            title: "A cosa serve",
            text: "Qui vedi in un posto solo se i collegamenti di {organization} funzionano: telefonia, WhatsApp, ingressi dei Lead, Google, Close ed email. Questa pagina non cambia niente: ogni riga dice che cosa manca e dove si sistema.",
            whoTitle: "Chi la vede",
            who: "L'Admin e il Super admin dell'azienda, e il Super admin di Gioia365. Niente numeri di telefono, email o chiavi: solo stati, conteggi e i nomi delle persone del team.",
        },
        groups: {
            calls: "Chiamate",
            whatsapp: "WhatsApp",
            intake: "Ingressi dei Lead",
            other: "Altri collegamenti",
        },
        items: {
            telephony: "Telefonia",
            callerNumbers: "Cellulari dell'ufficio",
            whatsappOfficial: "WhatsApp ufficiale",
            whatsappAgile: "WhatsApp Agile",
            whatsappManual: "WhatsApp a mano",
            intakeMeta: "Moduli di Meta",
            intakeWeb: "Sito e landing",
            intakeGhl: "GoHighLevel",
            google: "Google Calendar",
            closeImport: "Importazione da Close",
            email: "Email di sistema",
        },
        state: {
            working: "Funziona",
            incomplete: "Da completare",
            off: "Spento",
            error: "Non funziona",
        },
        lastWorked: "Ultima volta che ha funzionato: {when}",
        missingTitle: "Che cosa manca",
        facts: {
            recordingOn: "Le chiamate si registrano.",
            recordingOff: "Le chiamate non si registrano.",
            numbers: "Cellulari nel parco: {total} · verificati: {verified} · in verifica: {pending} · verifica non riuscita: {failed} · dati a qualcuno: {assigned}",
            senders: "Persone pronte: {ready} · da sistemare: {notReady}",
            templates: "Modelli approvati da Meta: {approved} su {total}",
            manualPeople: "Persone che scrivono a mano: {count}",
            page: "Pagina Facebook collegata: {page}",
            failedArrivals: "Arrivi non entrati negli ultimi 7 giorni: {count}",
            closeOn: "Accesa: si importa ogni sera alle 21:00.",
            closeOff: "Spenta: la sera non si importa.",
            closeNext: "Prossima importazione: {when}",
            closeLast: "Ultima della sera: {outcome}",
        },
        closeOutcome: {
            running: "in corso",
            completed: "finita",
            interrupted: "fermata da un riavvio, riparte da sola",
            failed: "non riuscita",
        },
        people: {
            withoutNumber: "Chiamano senza un cellulare:",
            withoutWhatsApp: "Mandano WhatsApp senza un WhatsApp impostato:",
            googleConnected: "Collegato da:",
            googleFailed: "Non funziona più per:",
            nobody: "nessuno",
        },
        fix: {
            byGioia365: "Lo imposta Gioia365.",
            platformCompanies: "Apri le aziende di Gioia365",
            team: "Vai a Team",
            whatsappSending: "Vai a «Invio dei WhatsApp»",
            whatsappTemplates: "Vai a «Modelli WhatsApp»",
            leadIntake: "Vai a «Ingressi dei Lead»",
            ownAccount: "Ognuno collega il suo calendario da «Il tuo account».",
            closeImport: "Vai all'importazione da Close",
        },
        missing: {
            telephony_off: "La telefonia non è accesa: la accende Gioia365.",
            telephony_setting_up: "La telefonia si sta preparando.",
            telephony_failed: "La preparazione della telefonia non è riuscita.",
            telephony_account_blocked: "L'account della telefonia è sospeso o chiuso.",
            telephony_check_failed: "L'ultima prova della telefonia non è riuscita.",
            recording_off: "Le chiamate non si registrano: dovrebbero registrarsi sempre.",
            numbers_none: "Nel parco non c'è nessun cellulare dell'ufficio.",
            numbers_pending: "Ci sono cellulari che aspettano la verifica: chi tiene il telefono deve digitare il codice.",
            numbers_failed: "La verifica di un cellulare non è riuscita: va rifatta.",
            people_without_number: "Qualcuno che può chiamare non ha un cellulare: non può chiamare.",
            whatsapp_meta_unavailable: "Il WhatsApp ufficiale non è attivo su Gioia365.",
            whatsapp_meta_company_off: "L'azienda non usa il WhatsApp ufficiale.",
            whatsapp_meta_not_connected: "La registrazione su Meta non è finita.",
            whatsapp_meta_failed: "Una registrazione su Meta non è riuscita.",
            whatsapp_meta_link_error: "Meta segnala un problema con il collegamento: va controllato in «Invio dei WhatsApp».",
            whatsapp_meta_messages_failed: "Alcuni WhatsApp delle ultime 24 ore non sono partiti.",
            whatsapp_meta_no_senders: "Nessuna persona ha il WhatsApp ufficiale pronto.",
            whatsapp_meta_senders_not_ready: "Il WhatsApp ufficiale di qualcuno non è pronto.",
            whatsapp_meta_templates: "Alcuni modelli non sono ancora approvati da Meta.",
            whatsapp_agile_unavailable: "WhatsApp Agile non è disponibile su Gioia365.",
            whatsapp_agile_company_off: "L'azienda non usa WhatsApp Agile.",
            whatsapp_agile_no_senders: "Nessuna persona ha WhatsApp Agile pronto.",
            whatsapp_agile_senders_not_ready: "WhatsApp Agile di qualcuno non è pronto.",
            whatsapp_agile_down: "Un telefono collegato a WhatsApp Agile non consegna: va ricollegato con il codice QR.",
            intake_meta_unavailable: "I moduli di Meta non sono attivi su Gioia365.",
            intake_meta_no_page: "Nessuna pagina Facebook collegata.",
            intake_meta_round_failed: "L'ultima lettura dei moduli non è riuscita: forse la pagina va collegata di nuovo.",
            intake_meta_no_round: "Gioia365 non ha ancora letto i moduli dall'ultimo avvio: se resta così, qualcosa non va.",
            intake_meta_round_stale: "L'ultima lettura dei moduli è di più di un'ora fa: dovrebbe essercene una ogni minuto.",
            intake_door_off: "La porta è spenta: da qui non entra nessun Lead.",
            intake_failed_arrivals: "Alcuni arrivi degli ultimi 7 giorni non sono entrati.",
            intake_no_arrivals: "Nessun Lead arrivato negli ultimi 90 giorni: controlla che il modulo mandi qui i contatti.",
            google_unavailable: "Google Calendar non è attivo su Gioia365.",
            google_nobody: "Nessuno ha collegato il suo calendario.",
            google_failed: "Il calendario di qualcuno non è più collegato: va collegato di nuovo.",
            close_no_key: "Manca la chiave di Close.",
            close_dry_run_needed: "Prima dell'importazione serve una prova senza salvare con la chiave di adesso.",
            close_nightly_off: "L'importazione della sera è spenta.",
            close_last_failed: "L'ultima importazione della sera non è riuscita.",
            email_off: "Le email di sistema non partono: inviti e reimpostazioni della password si consegnano a mano.",
        },
    },
};
//# sourceMappingURL=it.js.map